var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSustainabilityFeatures(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 430.81 450",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{mask:url(#mask);}.cls-3{fill:url(#radial-gradient-4);}.cls-3,.cls-4,.cls-5,.cls-6,.cls-7{mix-blend-mode:screen;}.cls-4{fill:url(#radial-gradient-9);}.cls-8,.cls-9{fill:#5cba47;}.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-9,.cls-26{fill-rule:evenodd;}.cls-10,.cls-27{fill:#18496b;}.cls-11,.cls-28{fill:#f99d29;}.cls-12,.cls-29{fill:#f26a2c;}.cls-13,.cls-30{fill:#fac315;}.cls-14,.cls-31,.cls-32{fill:#fff;}.cls-33{filter:url(#luminosity-noclip-21);}.cls-34{filter:url(#luminosity-noclip-17);}.cls-35{filter:url(#luminosity-noclip-13);}.cls-36{filter:url(#luminosity-noclip-11);}.cls-37{filter:url(#luminosity-noclip-19);}.cls-38,.cls-18{fill:#29bee2;}.cls-39{filter:url(#luminosity-noclip-4);}.cls-40{filter:url(#luminosity-noclip-6);}.cls-41{filter:url(#luminosity-noclip-9);}.cls-42{filter:url(#luminosity-noclip-2);}.cls-43{fill:url(#radial-gradient-10);}.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54{mix-blend-mode:multiply;}.cls-44{fill:url(#radial-gradient);}.cls-45{opacity:.14;}.cls-55{fill:url(#linear-gradient-8);}.cls-56{fill:url(#linear-gradient-7);}.cls-57{fill:url(#linear-gradient-5);}.cls-58{fill:url(#linear-gradient-6);}.cls-59{fill:url(#linear-gradient-9);}.cls-60{fill:url(#linear-gradient-4);}.cls-61{fill:url(#linear-gradient-3);}.cls-62{fill:url(#linear-gradient-2);}.cls-63,.cls-21{fill:#a21c44;}.cls-15,.cls-64{fill:#bf8b2c;}.cls-65{fill:#231f20;}.cls-16,.cls-66{fill:#407f44;}.cls-5{fill:url(#linear-gradient-19);opacity:.75;}.cls-31{mix-blend-mode:overlay;}.cls-67{fill:url(#linear-gradient);}.cls-68,.cls-25{fill:#c5202e;}.cls-69{fill:#0b9eda;}.cls-70{fill:#95d3bf;}.cls-17,.cls-71{fill:#01699e;}.cls-72{fill:#fefeff;}.cls-73{isolation:isolate;}.cls-74{mask:url(#mask-2);}.cls-75{mask:url(#mask-3);}.cls-76{mask:url(#mask-4);}.cls-77{mask:url(#mask-5);}.cls-78{mask:url(#mask-7);}.cls-79{mask:url(#mask-6);}.cls-80{mask:url(#mask-1);}.cls-81{mask:url(#mask-9);}.cls-82{mask:url(#mask-8);}.cls-46{fill:url(#linear-gradient-17);}.cls-47{fill:url(#linear-gradient-16);}.cls-48{fill:url(#linear-gradient-18);}.cls-6{fill:url(#radial-gradient-11);}.cls-83{fill:#fdfeff;}.cls-84,.cls-26{fill:#4ca046;}.cls-19,.cls-85{fill:#dea93a;}.cls-20,.cls-86{fill:#e4253c;}.cls-22,.cls-87{fill:#ef402c;}.cls-88{fill:url(#linear-gradient-10);}.cls-89{fill:url(#linear-gradient-11);}.cls-90{fill:url(#linear-gradient-12);}.cls-91{fill:url(#linear-gradient-13);}.cls-92{fill:url(#linear-gradient-14);}.cls-93{fill:url(#linear-gradient-15);}.cls-94{fill:#b9bbbf;opacity:.63;}.cls-95{opacity:.32;}.cls-96,.cls-23{fill:#1c97d4;}.cls-24,.cls-97{fill:#dd1768;}.cls-49{fill:url(#radial-gradient-8);}.cls-50{fill:url(#radial-gradient-3);}.cls-51{fill:url(#radial-gradient-2);}.cls-52{fill:url(#radial-gradient-7);}.cls-53{fill:url(#radial-gradient-5);}.cls-54{fill:url(#radial-gradient-6);}.cls-98{fill:#e6e7e8;}.cls-99{mask:url(#mask-10);}.cls-100{mask:url(#mask-14);}.cls-101{mask:url(#mask-18);}.cls-102{mask:url(#mask-11);}.cls-103{mask:url(#mask-16);}.cls-104{mask:url(#mask-13);}.cls-105{mask:url(#mask-19);}.cls-106{mask:url(#mask-12);}.cls-107{mask:url(#mask-17);}.cls-108{mask:url(#mask-15);}.cls-109{mask:url(#mask-22);}.cls-110{mask:url(#mask-21);}.cls-111{mask:url(#mask-20);}.cls-112{mask:url(#mask-25);}.cls-113{mask:url(#mask-24);}.cls-114{mask:url(#mask-23);}.cls-115{fill:#fbfbfb;}.cls-116{fill:#91d2c1;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 335.01,
    y1: 441.18,
    x2: 335.01,
    y2: 253.98,
    gradientTransform: "translate(-123.48 328.01) rotate(-44.92)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4da5a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#58b2ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#63c0b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#67c5b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#e2f2ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 304.58,
    y1: 170.16,
    x2: 393.15,
    y2: 170.16,
    gradientTransform: "translate(10.91 -20.75) rotate(3.46)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4da5a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#58b2ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#63c0b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67c5b4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 284.71,
    y1: 275.18,
    x2: 389.97,
    y2: 355.08,
    gradientTransform: "translate(16.03 -16.3) rotate(2.86)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0c2c4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 272.74,
    y1: 329.95,
    x2: 265.03,
    y2: 291.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#fff",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#fff",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#fff",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#fff",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#fff",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 249.65,
    y1: 336.25,
    x2: 297.05,
    y2: 336.25,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 242.16,
    y1: 344.86,
    x2: 285.16,
    y2: 344.86,
    gradientTransform: "translate(-130.87 494.55) rotate(-73.99)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4da5a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#4ea6a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#54adab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#5db9b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67c5b4"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 310.64,
    y: -8417,
    width: 18.96,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    x: 310.64,
    y: -8417,
    width: 18.96,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 230.22,
    cy: 274.46,
    fx: 230.22,
    fy: 274.46,
    r: 14.36,
    gradientTransform: "translate(479.38 152.91) rotate(82.33) scale(.66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#494949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 310.64,
    y: 318.2,
    width: 18.96,
    height: 18.96,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-80"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-44",
    cx: 320.11,
    cy: 327.68,
    r: 9.48,
    transform: "translate(-47.34 601.21) rotate(-82.33)"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-2",
    x: 310.64,
    y: 318.2,
    width: 18.96,
    height: 18.96,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-3",
    x: 310.64,
    y: -8417,
    width: 18.96,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    x: 310.64,
    y: -8417,
    width: 18.96,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 230.22,
    cy: 274.46,
    fx: 230.22,
    fy: 274.46,
    r: 14.36,
    gradientTransform: "translate(479.38 152.91) rotate(82.33) scale(.66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#9a9a9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 310.64,
    y: 318.2,
    width: 18.96,
    height: 18.96,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-75"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-51",
    cx: 320.11,
    cy: 327.68,
    r: 9.48,
    transform: "translate(-47.34 601.21) rotate(-82.33)"
  })))), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-4",
    x: 310.64,
    y: 318.2,
    width: 18.96,
    height: 18.96,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-5",
    x: 310.64,
    y: -8417,
    width: 18.96,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    x: 310.64,
    y: -8417,
    width: 18.96,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    x: 310.64,
    y: 318.2,
    width: 18.96,
    height: 18.96,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-77"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-51",
    cx: 320.11,
    cy: 327.68,
    r: 9.48,
    transform: "translate(-47.34 601.21) rotate(-82.33)"
  })))), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-6",
    x: 310.64,
    y: 318.2,
    width: 18.96,
    height: 18.96,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-7",
    x: 310.64,
    y: -8417,
    width: 18.96,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    x: 310.64,
    y: -8417,
    width: 18.96,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 230.22,
    cy: 274.46,
    fx: 230.22,
    fy: 274.46,
    r: 14.36,
    gradientTransform: "translate(479.38 152.91) rotate(82.33) scale(.66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    x: 310.64,
    y: 318.2,
    width: 18.96,
    height: 18.96,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-78"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-50",
    cx: 320.11,
    cy: 327.68,
    r: 9.48,
    transform: "translate(-47.34 601.21) rotate(-82.33)"
  })))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 230.22,
    cy: 274.46,
    fx: 230.22,
    fy: 274.46,
    r: 14.36,
    gradientTransform: "translate(479.38 152.91) rotate(82.33) scale(.66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd2526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-8",
    x: 344.34,
    y: -8417,
    width: 18.96,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    x: 344.34,
    y: -8417,
    width: 18.96,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 295.26,
    cy: 306.45,
    fx: 295.26,
    fy: 306.45,
    r: 13.13,
    gradientTransform: "translate(544.84 106.6) rotate(82.38) scale(.72)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    x: 344.34,
    y: 337.76,
    width: 18.96,
    height: 18.96,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-81"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-53",
    cx: 353.82,
    cy: 347.24,
    r: 9.48,
    transform: "translate(-37.29 651.87) rotate(-82.38)"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-9",
    x: 344.34,
    y: 337.76,
    width: 18.96,
    height: 18.96,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-10",
    x: 344.34,
    y: -8417,
    width: 18.96,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-11",
    x: 344.34,
    y: -8417,
    width: 18.96,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 295.26,
    cy: 306.45,
    fx: 295.26,
    fy: 306.45,
    r: 13.13,
    gradientTransform: "translate(544.84 106.6) rotate(82.38) scale(.72)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    x: 344.34,
    y: 337.76,
    width: 18.96,
    height: 18.96,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-102"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-54",
    cx: 353.82,
    cy: 347.24,
    r: 9.48,
    transform: "translate(-37.29 651.87) rotate(-82.38)"
  })))), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-11",
    x: 344.34,
    y: 337.76,
    width: 18.96,
    height: 18.96,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-12",
    x: 344.34,
    y: -8417,
    width: 18.96,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-13",
    x: 344.34,
    y: -8417,
    width: 18.96,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 295.26,
    cy: 306.45,
    fx: 295.26,
    fy: 306.45,
    r: 13.13,
    gradientTransform: "translate(544.84 106.6) rotate(82.38) scale(.72)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    x: 344.34,
    y: 337.76,
    width: 18.96,
    height: 18.96,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-104"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-52",
    cx: 353.82,
    cy: 347.24,
    r: 9.48,
    transform: "translate(-37.29 651.87) rotate(-82.38)"
  })))), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-13",
    x: 344.34,
    y: 337.76,
    width: 18.96,
    height: 18.96,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-14",
    x: 344.34,
    y: -8417,
    width: 18.96,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-15",
    x: 344.34,
    y: -8417,
    width: 18.96,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 295.26,
    cy: 306.45,
    fx: 295.26,
    fy: 306.45,
    r: 13.13,
    gradientTransform: "translate(544.84 106.6) rotate(82.38) scale(.72)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    x: 344.34,
    y: 337.76,
    width: 18.96,
    height: 18.96,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-108"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-49",
    cx: 353.82,
    cy: 347.24,
    r: 9.48,
    transform: "translate(-37.29 651.87) rotate(-82.38)"
  })))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 295.26,
    cy: 306.45,
    fx: 295.26,
    fy: 306.45,
    r: 13.13,
    gradientTransform: "translate(544.84 106.6) rotate(82.38) scale(.72)",
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 322.46,
    y1: 336.25,
    x2: 351.48,
    y2: 336.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#35b98f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#34b88f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#309290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#2c7891"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#2a6791"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a6292"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 310.53,
    y1: 281.61,
    x2: 360.44,
    y2: 311.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#35b98f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#319d8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#2d7d91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#2a6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a6292"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 336.97,
    y1: 262.25,
    x2: 336.97,
    y2: 317.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a6292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2a6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#2d7d91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#319d8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35b98f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 310.53,
    y1: 265.18,
    x2: 360.44,
    y2: 294.72,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 336.97,
    y1: 245.82,
    x2: 336.97,
    y2: 300.77,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 310.53,
    y1: 248.75,
    x2: 360.44,
    y2: 278.29,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 336.97,
    y1: 229.39,
    x2: 336.97,
    y2: 284.34,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 309.26,
    y1: 258.11,
    x2: 364.69,
    y2: 258.11,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 312.26,
    y1: 259.84,
    x2: 361.69,
    y2: 259.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a6292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35b98f"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-15",
    x: 298.2,
    y: -8417,
    width: 77.54,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-17",
    x: 298.2,
    y: -8417,
    width: 77.54,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 46.64,
    cy: 169.39,
    fx: 46.64,
    fy: 169.39,
    r: 38.5,
    gradientTransform: "translate(423.87 162.05) rotate(30) scale(.82 .71) skewX(-26.42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    x: 298.2,
    y: 228.31,
    width: 77.54,
    height: 44.77,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-107"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M364.47,266.57c-15.09,8.71-39.64,8.67-54.83-.1-15.19-8.77-15.26-22.94-.17-31.65,15.09-8.71,39.64-8.67,54.83.1,15.19,8.77,15.26,22.94.17,31.65Z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: 46.64,
    cy: 169.39,
    fx: 46.64,
    fy: 169.39,
    r: 38.5,
    gradientTransform: "translate(423.87 162.05) rotate(30) scale(.82 .71) skewX(-26.42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dd2526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-16",
    x: 309.26,
    y: -8417,
    width: 55.43,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-19",
    x: 309.26,
    y: -8417,
    width: 55.43,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 336.97,
    y1: 175.65,
    x2: 336.97,
    y2: 273.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#050505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#c2c2c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-18",
    x: 309.26,
    y: 175.46,
    width: 55.43,
    height: 98.64,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-105"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "309.26 175.46 309.26 258.09 336.97 274.11 364.69 258.09 364.68 175.46 309.26 175.46"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-17",
    x: 309.26,
    y: 175.46,
    width: 55.43,
    height: 98.64,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-18",
    x: 309.26,
    y: -8417,
    width: 55.43,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-21",
    x: 309.26,
    y: -8417,
    width: 55.43,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-20",
    x: 309.26,
    y: 175.46,
    width: 55.43,
    height: 98.64,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-110"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "309.26 175.46 309.26 258.09 336.97 274.11 364.69 258.09 364.68 175.46 309.26 175.46"
  })))), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-19",
    x: 309.26,
    y: 196.77,
    width: 55.43,
    height: 77.34,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-20",
    x: 309.26,
    y: -8417,
    width: 55.43,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-23",
    x: 309.26,
    y: -8417,
    width: 55.43,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 336.97,
    y1: 197.73,
    x2: 336.97,
    y2: 271.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-22",
    x: 309.26,
    y: 196.77,
    width: 55.43,
    height: 77.34,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-114"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "309.26 196.77 309.26 258.09 336.97 274.11 364.69 258.09 364.68 196.77 309.26 196.77"
  })))), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-21",
    x: 309.26,
    y: 196.77,
    width: 55.43,
    height: 77.34,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-22",
    x: 309.26,
    y: -8417,
    width: 55.43,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-25",
    x: 309.26,
    y: -8417,
    width: 55.43,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 336.97,
    y1: 197.73,
    x2: 336.97,
    y2: 271.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#393939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#7e7e7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#ddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-24",
    x: 309.26,
    y: 196.77,
    width: 55.43,
    height: 77.34,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-112"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "309.26 196.77 309.26 258.09 336.97 274.11 364.69 258.09 364.68 196.77 309.26 196.77"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 336.97,
    y1: 197.73,
    x2: 336.97,
    y2: 271.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#170404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#5c1010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#931919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#bb1f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#d42324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dd2526"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-67",
    cx: 335.01,
    cy: 313.36,
    r: 69.23,
    transform: "translate(-19.49 22.23) rotate(-3.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M398.95,158.44c.88,3.77,1.34,7.69,1.34,11.72,0,28.4-23.03,51.43-51.43,51.43-28.4,0-51.43-23.03-51.43-51.43,0-28.4,23.03-51.43,51.43-51.43,3.55,0,7.02.36,10.37,1.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M359.23,119.77c19.63,4.02,35.19,19.22,39.72,38.66l-48.07,16.86,8.34-55.53Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-62",
    cx: 348.86,
    cy: 170.16,
    r: 44.28,
    transform: "translate(-9.64 21.37) rotate(-3.46)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-61",
    cx: 335.01,
    cy: 313.36,
    r: 64.2,
    transform: "translate(-15.2 17.08) rotate(-2.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M372.82,182.61h-13.85c-.35,0-.63-.28-.63-.63s.28-.63.63-.63h13.59c2.71-2.8,4.2-6.54,4.2-10.56,0-8.13-6.24-14.75-13.91-14.75-1.21,0-2.42.17-3.6.5-.28.08-.58-.04-.72-.3-2.45-4.35-6.94-7.06-11.71-7.06-6.19,0-11.61,4.43-13.18,10.78-.07.3-.35.51-.66.48h-.14c-.21-.03-.41-.04-.62-.04-6.21,0-11.26,5.36-11.26,11.94,0,3.1,1.11,6.03,3.13,8.26h13.98c.35,0,.63.28.63.63s-.28.63-.63.63h-14.25c-.17,0-.34-.07-.46-.2-2.36-2.49-3.65-5.8-3.65-9.32,0-7.28,5.62-13.2,12.52-13.2.11,0,.22,0,.33,0,1.87-6.64,7.66-11.22,14.27-11.22,5.07,0,9.84,2.78,12.56,7.28,1.14-.28,2.3-.42,3.47-.42,8.37,0,15.17,7.18,15.17,16.01,0,4.45-1.69,8.58-4.75,11.64-.12.12-.28.18-.44.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M342.31,191.11c-.35,0-.63-.28-.63-.63v-9.6c0-.35.28-.63.63-.63s.63.28.63.63v9.6c0,.35-.28.63-.63.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M342.31,192.39c-.23,0-.43-.12-.55-.31l-1.81-3.13c-.17-.3-.07-.69.23-.86.3-.17.69-.07.86.23l1.26,2.18,1.26-2.18c.17-.3.56-.4.86-.23.3.17.4.56.23.86l-1.81,3.13c-.11.2-.32.31-.55.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M348.67,191.11c-.35,0-.63-.28-.63-.63v-9.6c0-.35.28-.63.63-.63s.63.28.63.63v9.6c0,.35-.28.63-.63.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M348.67,192.39h0c-.23,0-.43-.12-.55-.31l-1.81-3.13c-.17-.3-.07-.69.23-.86.3-.17.69-.07.86.23l1.26,2.18,1.26-2.18c.17-.3.56-.4.86-.23s.4.56.23.86l-1.81,3.13c-.11.2-.32.31-.55.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M355.02,191.11c-.35,0-.63-.28-.63-.63v-9.6c0-.35.28-.63.63-.63s.63.28.63.63v9.6c0,.35-.28.63-.63.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M355.02,192.39c-.23,0-.43-.12-.55-.31l-1.81-3.13c-.17-.3-.07-.69.23-.86.3-.17.69-.07.86.23l1.26,2.18,1.26-2.18c.17-.3.56-.4.86-.23.3.17.4.56.23.86l-1.81,3.13c-.11.2-.32.31-.55.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M342.04,162.2,342.1,163.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M353.42,162.2,353.42,163.51"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-32",
    x1: 360.42,
    y1: 175.66,
    x2: 363.01,
    y2: 175.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M327.01,155.54c-2.1,0-3.81-1.71-3.81-3.81s1.71-3.81,3.81-3.81,3.81,1.71,3.81,3.81-1.71,3.81-3.81,3.81ZM327.01,149.18c-1.41,0-2.55,1.14-2.55,2.55s1.14,2.55,2.55,2.55,2.55-1.14,2.55-2.55-1.14-2.55-2.55-2.55Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 335.84,
    y: 162.87,
    width: 41.98,
    height: 17.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M341.77,168.21c2.42.51,3.74,1.33,3.74,3.58,0,2-1.54,3.51-4.31,3.51-3.54,0-4.27-1.83-4.64-3.09-.02-.08-.03-.14-.03-.2,0-.34.26-.57.59-.65.09-.02.17-.03.26-.03.29,0,.59.14.68.47.28,1.04.79,2.2,3.06,2.2,1.77,0,2.87-.85,2.87-2.19s-.7-1.83-2.53-2.2l-1.24-.26c-2.33-.48-3.38-1.37-3.38-3.4,0-1.63,1.21-3.21,4.13-3.21s3.76,1.49,4.1,2.61c.03.08.05.16.05.23,0,.33-.26.56-.57.62-.08.02-.17.03-.26.03-.28,0-.56-.12-.68-.45-.25-.88-.9-1.75-2.62-1.75s-2.62.9-2.62,1.92c0,1.12.54,1.69,2.28,2.03l1.15.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M350.87,166.22c2.05,0,2.89,1.13,3.27,2.11.03.08.05.17.05.23,0,.29-.23.48-.47.57-.11.03-.23.05-.34.05-.23,0-.43-.09-.54-.36-.29-.79-.76-1.4-1.94-1.4-1.61,0-2.5,1.37-2.5,3.34s.87,3.32,2.51,3.32c1.21,0,1.69-.59,1.99-1.43.11-.29.33-.42.57-.42.11,0,.22.02.33.06.28.06.5.25.5.53,0,.09-.02.17-.06.28-.42,1.07-1.24,2.19-3.35,2.19-2.51,0-3.93-1.85-3.93-4.52s1.37-4.56,3.91-4.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M358.74,169.48c-.39.02-.59-.33-.59-.7s.2-.7.59-.68l.84.03h.12c1.57,0,2.54-.82,2.54-2.17,0-1.24-.93-1.97-2.42-1.97-1.38,0-2.09.57-2.47,1.57-.12.28-.34.39-.59.39-.12,0-.25-.03-.36-.06-.29-.09-.5-.29-.5-.57,0-.09.02-.19.06-.28.47-1.16,1.51-2.3,3.91-2.3,2.28,0,3.82,1.23,3.82,3.12,0,1.54-.76,2.53-2.3,2.9,1.8.25,2.67,1.32,2.67,3.1,0,2.05-1.61,3.46-4.31,3.46-2.34,0-3.65-.99-4.21-2.41-.05-.09-.06-.19-.06-.28,0-.29.22-.53.56-.62.11-.03.22-.05.31-.05.28,0,.5.14.64.45.4,1.01,1.19,1.61,2.79,1.61s2.79-.87,2.79-2.3-1.06-2.27-2.9-2.27h-.09l-.85.02Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 252.28,
    y: 293.58,
    width: 9.19,
    height: 10.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M253.51,298.85c0-.73.06-1.36.18-1.88s.27-.96.47-1.31.41-.64.65-.85c.24-.21.49-.38.73-.49s.49-.18.72-.22c.23-.04.44-.05.61-.05s.38.02.61.05c.23.03.47.11.72.22.25.11.49.27.73.49.24.21.46.5.65.85s.35.79.47,1.31c.12.52.18,1.15.18,1.88s-.06,1.36-.18,1.88c-.12.52-.27.96-.47,1.31s-.41.64-.65.85c-.24.21-.48.38-.73.49-.25.11-.49.18-.72.22-.23.04-.44.05-.61.05s-.38-.02-.61-.05c-.23-.03-.47-.11-.72-.22s-.49-.27-.73-.49c-.24-.21-.46-.5-.65-.85s-.35-.79-.47-1.31c-.12-.52-.18-1.15-.18-1.88ZM255.09,298.85c0,.29.02.62.06,1,.04.38.12.74.24,1.08s.3.63.54.87c.24.24.55.35.94.35s.71-.12.94-.35c.24-.24.42-.53.54-.87s.2-.7.24-1.08c.04-.38.06-.71.06-1s-.02-.62-.06-1c-.04-.38-.12-.74-.24-1.08s-.3-.63-.54-.87c-.24-.24-.55-.35-.94-.35s-.71.12-.94.35c-.24.24-.42.53-.54.87s-.2.7-.24,1.08c-.04.38-.06.71-.06,1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 263.24,
    y: 317.38,
    width: 9.19,
    height: 10.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M264.47,322.66c0-.73.06-1.36.18-1.88s.27-.96.47-1.31.41-.64.65-.85c.24-.21.49-.38.73-.49s.49-.18.72-.22c.23-.04.44-.05.61-.05s.38.02.61.05c.23.03.47.11.72.22.25.11.49.27.73.49.24.21.46.5.65.85s.35.79.47,1.31c.12.52.18,1.15.18,1.88s-.06,1.36-.18,1.88c-.12.52-.27.96-.47,1.31s-.41.64-.65.85c-.24.21-.48.38-.73.49-.25.11-.49.18-.72.22-.23.04-.44.05-.61.05s-.38-.02-.61-.05c-.23-.03-.47-.11-.72-.22s-.49-.27-.73-.49c-.24-.21-.46-.5-.65-.85s-.35-.79-.47-1.31c-.12-.52-.18-1.15-.18-1.88ZM266.05,322.66c0,.29.02.62.06,1,.04.38.12.74.24,1.08s.3.63.54.87c.24.24.55.35.94.35s.71-.12.94-.35c.24-.24.42-.53.54-.87s.2-.7.24-1.08c.04-.38.06-.71.06-1s-.02-.62-.06-1c-.04-.38-.12-.74-.24-1.08s-.3-.63-.54-.87c-.24-.24-.55-.35-.94-.35s-.71.12-.94.35c-.24.24-.42.53-.54.87s-.2.7-.24,1.08c-.04.38-.06.71-.06,1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 286.04,
    y: 303.79,
    width: 3.88,
    height: 4.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M286.56,306.02c0-.31.02-.57.08-.79.05-.22.12-.4.2-.55s.17-.27.27-.36c.1-.09.21-.16.31-.21s.21-.08.3-.09c.1-.01.18-.02.26-.02s.16,0,.26.02c.1.02.2.05.3.09.11.05.21.11.31.21.1.09.19.21.27.36.08.15.15.33.2.55s.07.48.07.79-.02.58-.07.79-.12.4-.2.55c-.08.15-.17.27-.27.36-.1.09-.2.16-.31.21-.1.05-.21.08-.3.09s-.18.02-.26.02-.16,0-.26-.02c-.1-.01-.2-.04-.3-.09s-.21-.11-.31-.21c-.1-.09-.19-.21-.27-.36s-.15-.33-.2-.55c-.05-.22-.08-.48-.08-.79ZM287.23,306.02c0,.12,0,.26.02.42s.05.31.1.46c.05.14.13.27.23.37.1.1.23.15.4.15s.3-.05.4-.15.18-.22.23-.37c.05-.14.09-.3.1-.46.02-.16.02-.3.02-.42s0-.26-.02-.42c-.02-.16-.05-.31-.1-.46s-.13-.27-.23-.37-.23-.15-.4-.15-.3.05-.4.15c-.1.1-.18.22-.23.37-.05.14-.09.3-.1.46-.02.16-.02.3-.02.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 266.15,
    y: 287.11,
    width: 3.88,
    height: 4.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M266.67,289.34c0-.31.02-.57.08-.79.05-.22.12-.4.2-.55s.17-.27.27-.36c.1-.09.21-.16.31-.21s.21-.08.3-.09c.1-.01.18-.02.26-.02s.16,0,.26.02c.1.02.2.05.3.09.11.05.21.11.31.21.1.09.19.21.27.36.08.15.15.33.2.55s.07.48.07.79-.02.58-.07.79-.12.4-.2.55c-.08.15-.17.27-.27.36-.1.09-.2.16-.31.21-.1.05-.21.08-.3.09s-.18.02-.26.02-.16,0-.26-.02c-.1-.01-.2-.04-.3-.09s-.21-.11-.31-.21c-.1-.09-.19-.21-.27-.36s-.15-.33-.2-.55c-.05-.22-.08-.48-.08-.79ZM267.34,289.34c0,.12,0,.26.02.42s.05.31.1.46c.05.14.13.27.23.37.1.1.23.15.4.15s.3-.05.4-.15.18-.22.23-.37c.05-.14.09-.3.1-.46.02-.16.02-.3.02-.42s0-.26-.02-.42c-.02-.16-.05-.31-.1-.46s-.13-.27-.23-.37-.23-.15-.4-.15-.3.05-.4.15c-.1.1-.18.22-.23.37-.05.14-.09.3-.1.46-.02.16-.02.3-.02.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 290.08,
    y: 289.31,
    width: 3.88,
    height: 4.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M290.6,291.54c0-.31.02-.57.08-.79.05-.22.12-.4.2-.55s.17-.27.27-.36c.1-.09.21-.16.31-.21s.21-.08.3-.09c.1-.01.18-.02.26-.02s.16,0,.26.02c.1.02.2.05.3.09.11.05.21.11.31.21.1.09.19.21.27.36.08.15.15.33.2.55s.07.48.07.79-.02.58-.07.79-.12.4-.2.55c-.08.15-.17.27-.27.36-.1.09-.2.16-.31.21-.1.05-.21.08-.3.09s-.18.02-.26.02-.16,0-.26-.02c-.1-.01-.2-.04-.3-.09s-.21-.11-.31-.21c-.1-.09-.19-.21-.27-.36s-.15-.33-.2-.55c-.05-.22-.08-.48-.08-.79ZM291.26,291.54c0,.12,0,.26.02.42s.05.31.1.46c.05.14.13.27.23.37.1.1.23.15.4.15s.3-.05.4-.15.18-.22.23-.37c.05-.14.09-.3.1-.46.02-.16.02-.3.02-.42s0-.26-.02-.42c-.02-.16-.05-.31-.1-.46s-.13-.27-.23-.37-.23-.15-.4-.15-.3.05-.4.15c-.1.1-.18.22-.23.37-.05.14-.09.3-.1.46-.02.16-.02.3-.02.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 278.4,
    y: 320.39,
    width: 3.88,
    height: 4.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M278.92,322.62c0-.31.02-.57.08-.79.05-.22.12-.4.2-.55s.17-.27.27-.36c.1-.09.21-.16.31-.21s.21-.08.3-.09c.1-.01.18-.02.26-.02s.16,0,.26.02c.1.02.2.05.3.09.11.05.21.11.31.21.1.09.19.21.27.36.08.15.15.33.2.55s.07.48.07.79-.02.58-.07.79-.12.4-.2.55c-.08.15-.17.27-.27.36-.1.09-.2.16-.31.21-.1.05-.21.08-.3.09s-.18.02-.26.02-.16,0-.26-.02c-.1-.01-.2-.04-.3-.09s-.21-.11-.31-.21c-.1-.09-.19-.21-.27-.36s-.15-.33-.2-.55c-.05-.22-.08-.48-.08-.79ZM279.59,322.62c0,.12,0,.26.02.42s.05.31.1.46c.05.14.13.27.23.37.1.1.23.15.4.15s.3-.05.4-.15.18-.22.23-.37c.05-.14.09-.3.1-.46.02-.16.02-.3.02-.42s0-.26-.02-.42c-.02-.16-.05-.31-.1-.46s-.13-.27-.23-.37-.23-.15-.4-.15-.3.05-.4.15c-.1.1-.18.22-.23.37-.05.14-.09.3-.1.46-.02.16-.02.3-.02.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 276.29,
    y: 288.84,
    width: 9.19,
    height: 10.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M277.53,294.11c0-.73.06-1.36.18-1.88s.27-.96.47-1.31.41-.64.65-.85c.24-.21.49-.38.73-.49s.49-.18.72-.22c.23-.04.44-.05.61-.05s.38.02.61.05c.23.03.47.11.72.22.25.11.49.27.73.49.24.21.46.5.65.85s.35.79.47,1.31c.12.52.18,1.15.18,1.88s-.06,1.36-.18,1.88c-.12.52-.27.96-.47,1.31s-.41.64-.65.85c-.24.21-.48.38-.73.49-.25.11-.49.18-.72.22-.23.04-.44.05-.61.05s-.38-.02-.61-.05c-.23-.03-.47-.11-.72-.22s-.49-.27-.73-.49c-.24-.21-.46-.5-.65-.85s-.35-.79-.47-1.31c-.12-.52-.18-1.15-.18-1.88ZM279.1,294.11c0,.29.02.62.06,1,.04.38.12.74.24,1.08s.3.63.54.87c.24.24.55.35.94.35s.71-.12.94-.35c.24-.24.42-.53.54-.87s.2-.7.24-1.08c.04-.38.06-.71.06-1s-.02-.62-.06-1c-.04-.38-.12-.74-.24-1.08s-.3-.63-.54-.87c-.24-.24-.55-.35-.94-.35s-.71.12-.94.35c-.24.24-.42.53-.54.87s-.2.7-.24,1.08c-.04.38-.06.71-.06,1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 267.1,
    y: 302.77,
    width: 3.57,
    height: 4.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M268.74,303.72l-.68.63-.36-.42,1.09-.91h.56v3.61h-.61v-2.9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 277.84,
    y: 308.16,
    width: 7.11,
    height: 8.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M281.11,310.05l-1.35,1.25-.71-.84,2.17-1.81h1.11v7.19h-1.22v-5.79Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 242.23,
    y: 310.35,
    width: 11.05,
    height: 12.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M247.32,313.29l-2.1,1.94-1.1-1.31,3.38-2.81h1.72v11.17h-1.89v-9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 258.44,
    y: 308.56,
    width: 4.78,
    height: 5.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M260.65,309.83l-.91.84-.48-.57,1.46-1.21h.74v4.83h-.82v-3.89Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 296.27,
    y: 300.94,
    width: 4.78,
    height: 5.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M298.48,302.21l-.91.84-.48-.57,1.46-1.21h.74v4.83h-.82v-3.89Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 238.97,
    y: 296.98,
    width: 59.84,
    height: 27.72
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-57",
    cx: 273.35,
    cy: 336.25,
    r: 23.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 273.35,
    cy: 336.25,
    r: 21.5,
    transform: "translate(-124.13 163.63) rotate(-27.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 257.95,
    y: 330.07,
    width: 31.87,
    height: 16.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M258.89,340.13l4.4-4.25c.13-.13.26-.26.4-.41.14-.14.26-.3.38-.46.11-.16.21-.33.28-.5s.11-.36.11-.55c0-.23-.05-.44-.14-.62-.09-.18-.21-.34-.36-.46s-.32-.23-.52-.3-.41-.1-.63-.1c-.48,0-.87.14-1.18.42-.31.28-.5.65-.56,1.12l-2.02-.16c.04-.52.17-.98.38-1.38.21-.4.48-.73.81-1,.33-.27.71-.47,1.15-.61.44-.14.91-.21,1.42-.21s.99.07,1.43.2c.44.13.83.33,1.16.59.33.26.59.59.78,1s.29.88.29,1.42c0,.71-.16,1.33-.49,1.85-.33.52-.74,1.01-1.26,1.48l-3.5,3.25h5.25v1.73h-7.58v-2.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M268.06,336.5c0-.9.07-1.66.22-2.29.14-.63.33-1.17.57-1.6s.5-.78.79-1.04c.29-.26.59-.46.9-.59.3-.13.6-.22.88-.26.28-.04.53-.06.74-.06s.46.02.74.06c.28.04.58.13.88.26.3.13.6.33.9.59.29.26.56.61.79,1.04s.42.96.57,1.6c.14.63.22,1.4.22,2.29s-.07,1.66-.22,2.29c-.14.63-.33,1.17-.57,1.6-.23.43-.5.78-.79,1.04-.29.26-.59.46-.9.59-.3.13-.6.22-.88.26-.28.04-.53.06-.74.06s-.46-.02-.74-.06c-.28-.04-.58-.13-.88-.26-.3-.13-.6-.33-.9-.59-.29-.26-.56-.61-.79-1.04-.23-.43-.42-.96-.57-1.6-.14-.63-.22-1.4-.22-2.29ZM269.98,336.5c0,.35.02.76.07,1.22s.15.9.3,1.32c.15.42.37.77.66,1.05.29.29.67.43,1.15.43s.86-.14,1.15-.43c.29-.29.51-.64.66-1.05.15-.42.25-.86.3-1.32s.07-.87.07-1.22-.02-.76-.07-1.22-.15-.9-.3-1.32c-.15-.42-.37-.77-.66-1.06-.29-.29-.67-.43-1.15-.43s-.86.14-1.15.43c-.29.29-.51.64-.66,1.06-.15.42-.25.86-.3,1.32s-.07.87-.07,1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M278.15,330.84h2.02v4.8h.1l4.69-4.8h2.72l-5.29,5.23,5.65,6.09h-2.83l-4.91-5.57h-.11v5.57h-2.02v-11.32Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M371.11,344.35c2.88,1.66,2.89,4.35.04,6.01l-28.87,16.78c-2.85,1.66-7.5,1.66-10.38,0l-29.06-16.78c-2.88-1.66-2.89-4.35-.04-6.01l28.87-16.78c2.85-1.66,7.5-1.66,10.38,0l29.06,16.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M371.07,344.36c2.87,1.66,2.89,4.35.04,6l-28.84,16.76c-2.85,1.66-7.49,1.66-10.36,0l-29.03-16.76c-2.87-1.66-2.89-4.35-.04-6l28.84-16.76c2.85-1.66,7.49-1.66,10.36,0l29.03,16.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M371.03,344.36c2.87,1.66,2.89,4.34.04,6l-28.81,16.74c-2.85,1.66-7.48,1.66-10.35,0l-29-16.74c-2.87-1.66-2.89-4.34-.04-6l28.81-16.74c2.85-1.66,7.48-1.66,10.35,0l29,16.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M371,344.36c2.87,1.66,2.88,4.34.04,5.99l-28.78,16.73c-2.85,1.65-7.48,1.65-10.34,0l-28.97-16.72c-2.87-1.66-2.88-4.34-.04-5.99l28.78-16.73c2.84-1.65,7.48-1.65,10.34,0l28.97,16.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M370.96,344.37c2.86,1.65,2.88,4.33.04,5.98l-28.75,16.71c-2.84,1.65-7.47,1.65-10.33,0l-28.94-16.71c-2.86-1.65-2.88-4.33-.04-5.98l28.75-16.71c2.84-1.65,7.47-1.65,10.33,0l28.94,16.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M370.93,344.37c2.86,1.65,2.88,4.33.04,5.98l-28.72,16.69c-2.84,1.65-7.46,1.65-10.32,0l-28.91-16.69c-2.86-1.65-2.88-4.33-.04-5.98l28.72-16.69c2.84-1.65,7.46-1.65,10.32,0l28.91,16.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M370.89,344.37c2.86,1.65,2.87,4.32.04,5.97l-28.69,16.67c-2.84,1.65-7.45,1.65-10.31,0l-28.88-16.67c-2.86-1.65-2.87-4.32-.04-5.97l28.69-16.67c2.84-1.65,7.45-1.65,10.31,0l28.88,16.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M370.86,344.37c2.86,1.65,2.87,4.32.04,5.97l-28.66,16.66c-2.83,1.65-7.44,1.65-10.3,0l-28.85-16.65c-2.86-1.65-2.87-4.32-.04-5.97l28.66-16.66c2.83-1.65,7.44-1.65,10.3,0l28.85,16.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M370.82,344.38c2.85,1.65,2.87,4.32.04,5.96l-28.63,16.64c-2.83,1.64-7.44,1.64-10.29,0l-28.82-16.64c-2.85-1.65-2.87-4.32-.04-5.96l28.63-16.64c2.83-1.64,7.44-1.64,10.29,0l28.82,16.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M370.79,344.38c2.85,1.65,2.86,4.31.04,5.95l-28.6,16.62c-2.83,1.64-7.43,1.64-10.28,0l-28.79-16.62c-2.85-1.65-2.86-4.31-.04-5.95l28.6-16.62c2.83-1.64,7.43-1.64,10.28,0l28.79,16.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M370.75,344.38c2.85,1.64,2.86,4.31.04,5.95l-28.57,16.6c-2.82,1.64-7.42,1.64-10.27,0l-28.76-16.6c-2.85-1.64-2.86-4.31-.04-5.95l28.57-16.6c2.82-1.64,7.42-1.64,10.27,0l28.76,16.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M370.72,344.39c2.84,1.64,2.86,4.3.04,5.94l-28.54,16.59c-2.82,1.64-7.41,1.64-10.26,0l-28.73-16.58c-2.84-1.64-2.86-4.3-.04-5.94l28.54-16.59c2.82-1.64,7.41-1.64,10.26,0l28.73,16.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M370.68,344.39c2.84,1.64,2.86,4.3.04,5.93l-28.51,16.57c-2.82,1.64-7.41,1.64-10.25,0l-28.7-16.57c-2.84-1.64-2.86-4.3-.04-5.93l28.51-16.57c2.82-1.64,7.41-1.64,10.25,0l28.7,16.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M370.64,344.39c2.84,1.64,2.85,4.29.04,5.93l-28.48,16.55c-2.82,1.64-7.4,1.64-10.24,0l-28.67-16.55c-2.84-1.64-2.85-4.29-.04-5.93l28.48-16.55c2.82-1.64,7.4-1.64,10.24,0l28.67,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M370.61,344.4c2.83,1.64,2.85,4.29.04,5.92l-28.45,16.53c-2.81,1.63-7.39,1.63-10.22,0l-28.63-16.53c-2.83-1.64-2.85-4.29-.04-5.92l28.45-16.53c2.81-1.63,7.39-1.63,10.22,0l28.63,16.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M370.57,344.4c2.83,1.63,2.85,4.28.04,5.92l-28.42,16.52c-2.81,1.63-7.38,1.63-10.21,0l-28.6-16.51c-2.83-1.63-2.85-4.28-.04-5.92l28.42-16.52c2.81-1.63,7.38-1.63,10.21,0l28.6,16.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M370.54,344.4c2.83,1.63,2.84,4.28.04,5.91l-28.39,16.5c-2.81,1.63-7.37,1.63-10.2,0l-28.57-16.5c-2.83-1.63-2.84-4.28-.04-5.91l28.39-16.5c2.81-1.63,7.37-1.63,10.2,0l28.57,16.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M370.5,344.41c2.83,1.63,2.84,4.27.04,5.9l-28.36,16.48c-2.8,1.63-7.37,1.63-10.19,0l-28.54-16.48c-2.83-1.63-2.84-4.27-.04-5.9l28.36-16.48c2.8-1.63,7.37-1.63,10.19,0l28.54,16.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M370.47,344.41c2.82,1.63,2.84,4.27.04,5.9l-28.33,16.47c-2.8,1.63-7.36,1.63-10.18,0l-28.51-16.46c-2.82-1.63-2.84-4.27-.04-5.9l28.33-16.47c2.8-1.63,7.36-1.63,10.18,0l28.51,16.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M370.43,344.41c2.82,1.63,2.83,4.27.04,5.89l-28.3,16.45c-2.8,1.63-7.35,1.63-10.17,0l-28.48-16.45c-2.82-1.63-2.83-4.27-.04-5.89l28.3-16.45c2.8-1.63,7.35-1.63,10.17,0l28.48,16.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M370.4,344.42c2.82,1.63,2.83,4.26.04,5.88l-28.27,16.43c-2.79,1.62-7.34,1.62-10.16,0l-28.45-16.43c-2.82-1.63-2.83-4.26-.04-5.88l28.27-16.43c2.79-1.62,7.34-1.62,10.16,0l28.45,16.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M370.36,344.42c2.81,1.62,2.83,4.26.04,5.88l-28.24,16.41c-2.79,1.62-7.34,1.62-10.15,0l-28.42-16.41c-2.81-1.62-2.83-4.26-.04-5.88l28.24-16.41c2.79-1.62,7.34-1.62,10.15,0l28.42,16.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M370.33,344.42c2.81,1.62,2.83,4.25.04,5.87l-28.21,16.4c-2.79,1.62-7.33,1.62-10.14,0l-28.39-16.39c-2.81-1.62-2.83-4.25-.04-5.87l28.21-16.4c2.79-1.62,7.33-1.62,10.14,0l28.39,16.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M370.29,344.42c2.81,1.62,2.82,4.25.04,5.87l-28.18,16.38c-2.79,1.62-7.32,1.62-10.13,0l-28.36-16.38c-2.81-1.62-2.82-4.25-.04-5.87l28.18-16.38c2.79-1.62,7.32-1.62,10.13,0l28.36,16.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M370.25,344.43c2.8,1.62,2.82,4.24.04,5.86l-28.15,16.36c-2.78,1.62-7.31,1.62-10.12,0l-28.33-16.36c-2.8-1.62-2.82-4.24-.04-5.86l28.15-16.36c2.78-1.62,7.31-1.62,10.12,0l28.33,16.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M370.22,344.43c2.8,1.62,2.82,4.24.04,5.85l-28.12,16.34c-2.78,1.62-7.3,1.62-10.11,0l-28.3-16.34c-2.8-1.62-2.82-4.24-.04-5.85l28.12-16.34c2.78-1.62,7.3-1.62,10.11,0l28.3,16.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M370.18,344.43c2.8,1.62,2.81,4.23.04,5.85l-28.09,16.33c-2.78,1.61-7.3,1.61-10.1,0l-28.27-16.32c-2.8-1.62-2.81-4.23-.04-5.85l28.09-16.33c2.78-1.61,7.3-1.61,10.1,0l28.27,16.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M370.15,344.44c2.8,1.61,2.81,4.23.04,5.84l-28.06,16.31c-2.77,1.61-7.29,1.61-10.08,0l-28.24-16.31c-2.8-1.61-2.81-4.23-.04-5.84l28.06-16.31c2.77-1.61,7.29-1.61,10.08,0l28.24,16.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M370.11,344.44c2.79,1.61,2.81,4.22.04,5.84l-28.03,16.29c-2.77,1.61-7.28,1.61-10.07,0l-28.21-16.29c-2.79-1.61-2.81-4.22-.04-5.83l28.03-16.29c2.77-1.61,7.28-1.61,10.07,0l28.21,16.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M370.08,344.44c2.79,1.61,2.8,4.22.04,5.83l-28,16.27c-2.77,1.61-7.27,1.61-10.06,0l-28.18-16.27c-2.79-1.61-2.8-4.22-.04-5.83l28-16.27c2.77-1.61,7.27-1.61,10.06,0l28.18,16.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M370.04,344.45c2.79,1.61,2.8,4.22.04,5.82l-27.97,16.26c-2.76,1.61-7.27,1.61-10.05,0l-28.15-16.25c-2.79-1.61-2.8-4.22-.04-5.82l27.97-16.26c2.76-1.61,7.27-1.61,10.05,0l28.15,16.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M370.01,344.45c2.78,1.61,2.8,4.21.04,5.82l-27.94,16.24c-2.76,1.61-7.26,1.61-10.04,0l-28.12-16.24c-2.78-1.61-2.8-4.21-.04-5.82l27.94-16.24c2.76-1.61,7.26-1.61,10.04,0l28.12,16.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M369.97,344.45c2.78,1.61,2.8,4.21.04,5.81l-27.91,16.22c-2.76,1.6-7.25,1.6-10.03,0l-28.09-16.22c-2.78-1.61-2.8-4.21-.04-5.81l27.91-16.22c2.76-1.6,7.25-1.6,10.03,0l28.09,16.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M369.94,344.46c2.78,1.6,2.79,4.2.04,5.8l-27.88,16.2c-2.76,1.6-7.24,1.6-10.02,0l-28.06-16.2c-2.78-1.6-2.79-4.2-.04-5.8l27.88-16.2c2.76-1.6,7.24-1.6,10.02,0l28.06,16.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M369.9,344.46c2.77,1.6,2.79,4.2.04,5.8l-27.85,16.19c-2.75,1.6-7.23,1.6-10.01,0l-28.03-16.18c-2.77-1.6-2.79-4.2-.04-5.8l27.85-16.19c2.75-1.6,7.23-1.6,10.01,0l28.03,16.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M369.86,344.46c2.77,1.6,2.79,4.19.04,5.79l-27.82,16.17c-2.75,1.6-7.23,1.6-10,0l-28-16.17c-2.77-1.6-2.79-4.19-.04-5.79l27.82-16.17c2.75-1.6,7.23-1.6,10,0l28,16.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M369.83,344.47c2.77,1.6,2.78,4.19.04,5.79l-27.79,16.15c-2.75,1.6-7.22,1.6-9.99,0l-27.97-16.15c-2.77-1.6-2.78-4.19-.04-5.79l27.79-16.15c2.75-1.6,7.22-1.6,9.99,0l27.97,16.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M369.79,344.47c2.77,1.6,2.78,4.18.04,5.78l-27.76,16.13c-2.74,1.59-7.21,1.59-9.98,0l-27.94-16.13c-2.77-1.6-2.78-4.18-.04-5.78l27.76-16.13c2.74-1.59,7.21-1.59,9.98,0l27.94,16.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M369.76,344.47c2.76,1.6,2.78,4.18.04,5.77l-27.73,16.12c-2.74,1.59-7.2,1.59-9.97,0l-27.91-16.11c-2.76-1.6-2.78-4.18-.04-5.77l27.73-16.12c2.74-1.59,7.2-1.59,9.97,0l27.91,16.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M369.72,344.47c2.76,1.59,2.77,4.17.04,5.77l-27.7,16.1c-2.74,1.59-7.2,1.59-9.95,0l-27.88-16.1c-2.76-1.59-2.77-4.17-.04-5.77l27.7-16.1c2.74-1.59,7.2-1.59,9.95,0l27.88,16.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M369.69,344.48c2.76,1.59,2.77,4.17.04,5.76l-27.67,16.08c-2.74,1.59-7.19,1.59-9.94,0l-27.85-16.08c-2.76-1.59-2.77-4.17-.04-5.76l27.67-16.08c2.74-1.59,7.19-1.59,9.94,0l27.85,16.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M369.65,344.48c2.75,1.59,2.77,4.17.04,5.75l-27.64,16.06c-2.73,1.59-7.18,1.59-9.93,0l-27.82-16.06c-2.75-1.59-2.77-4.17-.04-5.75l27.64-16.06c2.73-1.59,7.18-1.59,9.93,0l27.82,16.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M369.62,344.48c2.75,1.59,2.77,4.16.04,5.75l-27.61,16.05c-2.73,1.59-7.17,1.59-9.92,0l-27.79-16.04c-2.75-1.59-2.77-4.16-.04-5.75l27.61-16.05c2.73-1.59,7.17-1.59,9.92,0l27.79,16.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M369.58,344.49c2.75,1.59,2.76,4.16.04,5.74l-27.58,16.03c-2.73,1.58-7.16,1.58-9.91,0l-27.76-16.03c-2.75-1.59-2.76-4.16-.04-5.74l27.58-16.03c2.73-1.58,7.16-1.58,9.91,0l27.76,16.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M369.55,344.49c2.75,1.58,2.76,4.15.04,5.74l-27.55,16.01c-2.72,1.58-7.16,1.58-9.9,0l-27.73-16.01c-2.74-1.58-2.76-4.15-.04-5.74l27.55-16.01c2.72-1.58,7.16-1.58,9.9,0l27.73,16.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M369.51,344.49c2.74,1.58,2.76,4.15.04,5.73l-27.52,15.99c-2.72,1.58-7.15,1.58-9.89,0l-27.7-15.99c-2.74-1.58-2.76-4.15-.04-5.73l27.52-15.99c2.72-1.58,7.15-1.58,9.89,0l27.7,15.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M369.47,344.5c2.74,1.58,2.75,4.14.04,5.72l-27.49,15.98c-2.72,1.58-7.14,1.58-9.88,0l-27.67-15.97c-2.74-1.58-2.75-4.14-.04-5.72l27.49-15.98c2.72-1.58,7.14-1.58,9.88,0l27.67,15.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M369.44,344.5c2.74,1.58,2.75,4.14.04,5.72l-27.46,15.96c-2.71,1.58-7.13,1.58-9.87,0l-27.64-15.96c-2.74-1.58-2.75-4.14-.04-5.72l27.46-15.96c2.71-1.58,7.13-1.58,9.87,0l27.64,15.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M369.4,344.5c2.73,1.58,2.75,4.13.04,5.71l-27.43,15.94c-2.71,1.58-7.12,1.58-9.86,0l-27.61-15.94c-2.73-1.58-2.75-4.13-.04-5.71l27.43-15.94c2.71-1.58,7.12-1.58,9.86,0l27.61,15.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M369.37,344.51c2.73,1.58,2.74,4.13.04,5.7l-27.4,15.92c-2.71,1.57-7.12,1.57-9.85,0l-27.58-15.92c-2.73-1.58-2.74-4.13-.04-5.7l27.4-15.92c2.71-1.57,7.12-1.57,9.85,0l27.58,15.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M369.33,344.51c2.73,1.57,2.74,4.13.04,5.7l-27.37,15.91c-2.71,1.57-7.11,1.57-9.84,0l-27.55-15.9c-2.73-1.57-2.74-4.13-.04-5.7l27.37-15.91c2.71-1.57,7.11-1.57,9.84,0l27.55,15.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M369.3,344.51c2.72,1.57,2.74,4.12.04,5.69l-27.34,15.89c-2.7,1.57-7.1,1.57-9.83,0l-27.52-15.89c-2.72-1.57-2.74-4.12-.04-5.69l27.34-15.89c2.7-1.57,7.1-1.57,9.83,0l27.52,15.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M369.26,344.52c2.72,1.57,2.74,4.12.04,5.69l-27.31,15.87c-2.7,1.57-7.09,1.57-9.81,0l-27.49-15.87c-2.72-1.57-2.74-4.12-.04-5.69l27.31-15.87c2.7-1.57,7.09-1.57,9.81,0l27.49,15.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M369.23,344.52c2.72,1.57,2.73,4.11.04,5.68l-27.28,15.86c-2.7,1.57-7.09,1.57-9.8,0l-27.46-15.85c-2.72-1.57-2.73-4.11-.04-5.68l27.28-15.86c2.7-1.57,7.09-1.57,9.8,0l27.46,15.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M369.19,344.52c2.72,1.57,2.73,4.11.04,5.67l-27.25,15.84c-2.69,1.57-7.08,1.57-9.79,0l-27.43-15.84c-2.72-1.57-2.73-4.11-.04-5.67l27.25-15.84c2.69-1.57,7.08-1.57,9.79,0l27.43,15.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M369.16,344.52c2.71,1.57,2.73,4.1.04,5.67l-27.22,15.82c-2.69,1.56-7.07,1.56-9.78,0l-27.4-15.82c-2.71-1.57-2.73-4.1-.04-5.67l27.22-15.82c2.69-1.56,7.07-1.56,9.78,0l27.4,15.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M369.12,344.53c2.71,1.56,2.72,4.1.04,5.66l-27.19,15.8c-2.69,1.56-7.06,1.56-9.77,0l-27.37-15.8c-2.71-1.56-2.72-4.1-.04-5.66l27.19-15.8c2.69-1.56,7.06-1.56,9.77,0l27.37,15.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M369.08,344.53c2.71,1.56,2.72,4.09.04,5.65l-27.16,15.79c-2.68,1.56-7.05,1.56-9.76,0l-27.34-15.78c-2.71-1.56-2.72-4.09-.04-5.65l27.16-15.79c2.68-1.56,7.05-1.56,9.76,0l27.34,15.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M369.05,344.53c2.7,1.56,2.72,4.09.04,5.65l-27.13,15.77c-2.68,1.56-7.05,1.56-9.75,0l-27.31-15.77c-2.7-1.56-2.72-4.09-.04-5.65l27.13-15.77c2.68-1.56,7.05-1.56,9.75,0l27.31,15.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M369.01,344.54c2.7,1.56,2.71,4.08.04,5.64l-27.1,15.75c-2.68,1.56-7.04,1.56-9.74,0l-27.28-15.75c-2.7-1.56-2.71-4.08-.04-5.64l27.1-15.75c2.68-1.56,7.04-1.56,9.74,0l27.28,15.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M368.98,344.54c2.7,1.56,2.71,4.08.04,5.64l-27.07,15.73c-2.68,1.56-7.03,1.56-9.73,0l-27.25-15.73c-2.7-1.56-2.71-4.08-.04-5.64l27.07-15.73c2.68-1.56,7.03-1.56,9.73,0l27.25,15.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M368.94,344.54c2.69,1.56,2.71,4.08.04,5.63l-27.04,15.72c-2.67,1.55-7.02,1.55-9.72,0l-27.22-15.71c-2.69-1.56-2.71-4.08-.04-5.63l27.04-15.72c2.67-1.55,7.02-1.55,9.72,0l27.22,15.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M368.91,344.55c2.69,1.55,2.71,4.07.04,5.62l-27.01,15.7c-2.67,1.55-7.02,1.55-9.71,0l-27.19-15.7c-2.69-1.55-2.71-4.07-.04-5.62l27.01-15.7c2.67-1.55,7.02-1.55,9.71,0l27.19,15.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M368.87,344.55c2.69,1.55,2.7,4.07.04,5.62l-26.98,15.68c-2.67,1.55-7.01,1.55-9.7,0l-27.16-15.68c-2.69-1.55-2.7-4.07-.04-5.62l26.98-15.68c2.67-1.55,7.01-1.55,9.7,0l27.16,15.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M368.84,344.55c2.69,1.55,2.7,4.06.04,5.61l-26.95,15.66c-2.66,1.55-7,1.55-9.69,0l-27.13-15.66c-2.69-1.55-2.7-4.06-.04-5.61l26.95-15.66c2.66-1.55,7-1.55,9.69,0l27.13,15.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M368.8,344.56c2.68,1.55,2.7,4.06.04,5.6l-26.92,15.65c-2.66,1.55-6.99,1.55-9.67,0l-27.1-15.64c-2.68-1.55-2.7-4.06-.04-5.6l26.92-15.65c2.66-1.55,6.99-1.55,9.67,0l27.1,15.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M368.77,344.56c2.68,1.55,2.69,4.05.04,5.6l-26.89,15.63c-2.66,1.54-6.98,1.54-9.66,0l-27.07-15.63c-2.68-1.55-2.69-4.05-.04-5.6l26.89-15.63c2.66-1.54,6.98-1.54,9.66,0l27.07,15.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M368.73,344.56c2.68,1.55,2.69,4.05.04,5.59l-26.86,15.61c-2.66,1.54-6.98,1.54-9.65,0l-27.03-15.61c-2.68-1.55-2.69-4.05-.04-5.59l26.86-15.61c2.66-1.54,6.98-1.54,9.65,0l27.03,15.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M368.69,344.57c2.67,1.54,2.69,4.04.04,5.59l-26.83,15.59c-2.65,1.54-6.97,1.54-9.64,0l-27-15.59c-2.67-1.54-2.69-4.04-.04-5.59l26.83-15.59c2.65-1.54,6.97-1.54,9.64,0l27,15.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M368.66,344.57c2.67,1.54,2.68,4.04.04,5.58l-26.8,15.58c-2.65,1.54-6.96,1.54-9.63,0l-26.97-15.57c-2.67-1.54-2.68-4.04-.03-5.58l26.8-15.58c2.65-1.54,6.96-1.54,9.63,0l26.97,15.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M368.62,344.57c2.67,1.54,2.68,4.03.04,5.57l-26.77,15.56c-2.65,1.54-6.95,1.54-9.62,0l-26.94-15.56c-2.67-1.54-2.68-4.03-.03-5.57l26.77-15.56c2.65-1.54,6.95-1.54,9.62,0l26.94,15.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M368.59,344.57c2.66,1.54,2.68,4.03.03,5.57l-26.74,15.54c-2.64,1.54-6.95,1.54-9.61,0l-26.91-15.54c-2.66-1.54-2.68-4.03-.03-5.57l26.74-15.54c2.64-1.54,6.95-1.54,9.61,0l26.91,15.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M368.55,344.58c2.66,1.54,2.68,4.03.03,5.56l-26.71,15.52c-2.64,1.53-6.94,1.53-9.6,0l-26.88-15.52c-2.66-1.54-2.68-4.03-.03-5.56l26.71-15.52c2.64-1.53,6.94-1.53,9.6,0l26.88,15.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M368.52,344.58c2.66,1.53,2.67,4.02.03,5.55l-26.68,15.51c-2.64,1.53-6.93,1.53-9.59,0l-26.85-15.5c-2.66-1.53-2.67-4.02-.03-5.55l26.68-15.51c2.64-1.53,6.93-1.53,9.59,0l26.85,15.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M368.48,344.58c2.66,1.53,2.67,4.02.03,5.55l-26.65,15.49c-2.63,1.53-6.92,1.53-9.58,0l-26.82-15.49c-2.66-1.53-2.67-4.02-.03-5.55l26.65-15.49c2.63-1.53,6.92-1.53,9.58,0l26.82,15.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M368.45,344.59c2.65,1.53,2.67,4.01.03,5.54l-26.62,15.47c-2.63,1.53-6.91,1.53-9.57,0l-26.79-15.47c-2.65-1.53-2.67-4.01-.03-5.54l26.62-15.47c2.63-1.53,6.91-1.53,9.57,0l26.79,15.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M368.41,344.59c2.65,1.53,2.66,4.01.03,5.54l-26.59,15.45c-2.63,1.53-6.91,1.53-9.56,0l-26.76-15.45c-2.65-1.53-2.66-4.01-.03-5.54l26.59-15.45c2.63-1.53,6.91-1.53,9.56,0l26.76,15.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M368.38,344.59c2.65,1.53,2.66,4,.03,5.53l-26.56,15.44c-2.63,1.53-6.9,1.53-9.55,0l-26.73-15.43c-2.65-1.53-2.66-4-.03-5.53l26.56-15.44c2.63-1.53,6.9-1.53,9.55,0l26.73,15.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M368.34,344.6c2.64,1.53,2.66,4,.03,5.52l-26.53,15.42c-2.62,1.52-6.89,1.52-9.53,0l-26.7-15.42c-2.64-1.53-2.66-4-.03-5.52l26.53-15.42c2.62-1.52,6.89-1.52,9.53,0l26.7,15.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M368.3,344.6c2.64,1.52,2.65,3.99.03,5.52l-26.5,15.4c-2.62,1.52-6.88,1.52-9.52,0l-26.67-15.4c-2.64-1.52-2.65-3.99-.03-5.52l26.5-15.4c2.62-1.52,6.88-1.52,9.52,0l26.67,15.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M368.27,344.6c2.64,1.52,2.65,3.99.03,5.51l-26.47,15.38c-2.62,1.52-6.88,1.52-9.51,0l-26.64-15.38c-2.64-1.52-2.65-3.99-.03-5.51l26.47-15.38c2.62-1.52,6.88-1.52,9.51,0l26.64,15.38Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-95"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M368.23,344.61c2.63,1.52,2.65,3.99.03,5.5l-26.44,15.37c-2.61,1.52-6.87,1.52-9.5,0l-26.61-15.36c-2.63-1.52-2.65-3.99-.03-5.5l26.44-15.37c2.61-1.52,6.87-1.52,9.5,0l26.61,15.36Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-74"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-76"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-79"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 320.11,
    cy: 327.68,
    r: 9.48,
    transform: "translate(-47.34 601.21) rotate(-82.33)"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "cls-82"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-99"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-106"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-100"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 353.82,
    cy: 347.24,
    r: 9.48,
    transform: "translate(-37.29 651.87) rotate(-82.38)"
  })))))), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M350.96,344.42l-6.26-3.61c-.06-.55-.37-1.07-.88-1.37l-5.81-3.35v-8.89c0-.58-.47-1.04-1.04-1.04s-1.04.47-1.04,1.04v7.69s-4.02-2.32-4.02-2.32c-.52-.3-1.12-.31-1.63-.08l-6.26-3.61c-.5-.29-1.14-.12-1.42.38-.29.5-.12,1.14.38,1.42l6.26,3.61c.06.55.37,1.07.88,1.37l11.91,6.88c.28.16.59.24.89.24.25,0,.5-.06.73-.16l6.26,3.61c.16.09.34.14.52.14.36,0,.71-.19.9-.52.29-.5.12-1.14-.38-1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M382.88,290.09h-13.27s-29.73-17.17-29.73-17.17c-1.8-1.04-4.02-1.04-5.82,0l-29.73,17.17h-13.26v10.8h0c-.08,2.03.89,4.1,2.9,5.27l37.26,21.51c3.55,2.05,7.93,2.05,11.48,0l37.26-21.51c2.01-1.16,2.98-3.23,2.9-5.27h0v-10.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M331.23,316.64l-37.26-21.51c-3.88-2.24-3.88-7.84,0-10.08l37.26-21.51c3.55-2.05,7.93-2.05,11.48,0l37.26,21.51c3.88,2.24,3.88,7.84,0,10.08l-37.26,21.51c-3.55,2.05-7.93,2.05-11.48,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M332.36,321.46c0,.44-.31.62-.7.4-.38-.22-.7-.76-.7-1.2s.31-.62.7-.4c.38.22.7.76.7,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M332.36,324.39c0,.44-.31.62-.7.4-.38-.22-.7-.76-.7-1.2s.31-.62.7-.4c.38.22.7.76.7,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M329.87,320.03c0,.44-.31.62-.7.4-.38-.22-.7-.76-.7-1.2s.31-.62.7-.4c.38.22.7.76.7,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M329.87,322.95c0,.44-.31.62-.7.4-.38-.22-.7-.76-.7-1.2s.31-.62.7-.4c.38.22.7.76.7,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M326.57,322.03l-.05-.03c-.18-.1-.32-.37-.32-.61v-4.05c0-.23.14-.34.32-.24l.05.03c.18.1.32.37.32.61v4.05c0,.23-.14.34-.32.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M324.41,320.78l-.05-.03c-.18-.1-.32-.37-.32-.61v-4.05c0-.23.14-.34.32-.24l.05.03c.18.1.32.37.32.61v4.05c0,.23-.14.34-.32.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M322.09,316.99h0c0,.22-.13.32-.3.22l-25.82-14.91c-.16-.09-.3-.35-.3-.57h0c0-.22.13-.32.3-.22l25.82,14.91c.16.09.3.35.3.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M322.09,319.05h0c0,.22-.13.32-.3.22l-25.82-14.91c-.16-.09-.3-.35-.3-.57h0c0-.22.13-.32.3-.22l25.82,14.91c.16.09.3.35.3.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M322.09,314.94h0c0,.22-.13.32-.3.22l-25.82-14.91c-.16-.09-.3-.35-.3-.57h0c0-.22.13-.32.3-.22l25.82,14.91c.16.09.3.35.3.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M382.88,273.66h-13.27s-29.73-17.17-29.73-17.17c-1.8-1.04-4.02-1.04-5.82,0l-29.73,17.17h-13.26v10.8h0c-.08,2.03.89,4.1,2.9,5.27l37.26,21.51c3.55,2.05,7.93,2.05,11.48,0l37.26-21.51c2.01-1.16,2.98-3.23,2.9-5.27h0v-10.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M331.23,300.22l-37.26-21.51c-3.88-2.24-3.88-7.84,0-10.08l37.26-21.51c3.55-2.05,7.93-2.05,11.48,0l37.26,21.51c3.88,2.24,3.88,7.84,0,10.08l-37.26,21.51c-3.55,2.05-7.93,2.05-11.48,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M332.36,305.03c0,.44-.31.62-.7.4-.38-.22-.7-.76-.7-1.2s.31-.62.7-.4c.38.22.7.76.7,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M332.36,307.96c0,.44-.31.62-.7.4-.38-.22-.7-.76-.7-1.2s.31-.62.7-.4c.38.22.7.76.7,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M329.87,303.6c0,.44-.31.62-.7.4-.38-.22-.7-.76-.7-1.2s.31-.62.7-.4c.38.22.7.76.7,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M329.87,306.52c0,.44-.31.62-.7.4-.38-.22-.7-.76-.7-1.2s.31-.62.7-.4c.38.22.7.76.7,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M326.57,305.6l-.05-.03c-.18-.1-.32-.37-.32-.61v-4.05c0-.23.14-.34.32-.24l.05.03c.18.1.32.37.32.61v4.05c0,.23-.14.34-.32.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M324.41,304.36l-.05-.03c-.18-.1-.32-.37-.32-.61v-4.05c0-.23.14-.34.32-.24l.05.03c.18.1.32.37.32.61v4.05c0,.23-.14.34-.32.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M322.09,300.56h0c0,.22-.13.32-.3.22l-25.82-14.91c-.16-.09-.3-.35-.3-.57h0c0-.22.13-.32.3-.22l25.82,14.91c.16.09.3.35.3.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M322.09,302.62h0c0,.22-.13.32-.3.22l-25.82-14.91c-.16-.09-.3-.35-.3-.57h0c0-.22.13-.32.3-.22l25.82,14.91c.16.09.3.35.3.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M322.09,298.51h0c0,.22-.13.32-.3.22l-25.82-14.91c-.16-.09-.3-.35-.3-.57h0c0-.22.13-.32.3-.22l25.82,14.91c.16.09.3.35.3.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M382.88,257.23h-13.27s-29.73-17.17-29.73-17.17c-1.8-1.04-4.02-1.04-5.82,0l-29.73,17.17h-13.26v10.8h0c-.08,2.03.89,4.1,2.9,5.27l37.26,21.51c3.55,2.05,7.93,2.05,11.48,0l37.26-21.51c2.01-1.16,2.98-3.23,2.9-5.27h0v-10.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M331.23,283.79l-37.26-21.51c-3.88-2.24-3.88-7.84,0-10.08l37.26-21.51c3.55-2.05,7.93-2.05,11.48,0l37.26,21.51c3.88,2.24,3.88,7.84,0,10.08l-37.26,21.51c-3.55,2.05-7.93,2.05-11.48,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M332.36,288.6c0,.44-.31.62-.7.4-.38-.22-.7-.76-.7-1.2s.31-.62.7-.4c.38.22.7.76.7,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M332.36,291.53c0,.44-.31.62-.7.4-.38-.22-.7-.76-.7-1.2s.31-.62.7-.4c.38.22.7.76.7,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M329.87,287.17c0,.44-.31.62-.7.4-.38-.22-.7-.76-.7-1.2s.31-.62.7-.4c.38.22.7.76.7,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M329.87,290.09c0,.44-.31.62-.7.4-.38-.22-.7-.76-.7-1.2s.31-.62.7-.4c.38.22.7.76.7,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M326.57,289.17l-.05-.03c-.18-.1-.32-.37-.32-.61v-4.05c0-.23.14-.34.32-.24l.05.03c.18.1.32.37.32.61v4.05c0,.23-.14.34-.32.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M324.41,287.93l-.05-.03c-.18-.1-.32-.37-.32-.61v-4.05c0-.23.14-.34.32-.24l.05.03c.18.1.32.37.32.61v4.05c0,.23-.14.34-.32.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M322.09,284.14h0c0,.22-.13.32-.3.22l-25.82-14.91c-.16-.09-.3-.35-.3-.57h0c0-.22.13-.32.3-.22l25.82,14.91c.16.09.3.35.3.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M322.09,286.19h0c0,.22-.13.32-.3.22l-25.82-14.91c-.16-.09-.3-.35-.3-.57h0c0-.22.13-.32.3-.22l25.82,14.91c.16.09.3.35.3.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M322.09,282.08h0c0,.22-.13.32-.3.22l-25.82-14.91c-.16-.09-.3-.35-.3-.57h0c0-.22.13-.32.3-.22l25.82,14.91c.16.09.3.35.3.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M354.71,347.24c0,.49-.4.89-.89.89s-.89-.4-.89-.89.4-.89.89-.89.89.4.89.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M353.82,348.84c-.88,0-1.6-.72-1.6-1.6s.72-1.6,1.6-1.6,1.6.72,1.6,1.6-.72,1.6-1.6,1.6ZM353.82,345.73c-.83,0-1.51.68-1.51,1.51s.68,1.51,1.51,1.51,1.51-.68,1.51-1.51-.68-1.51-1.51-1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M320.11,329.28c-.88,0-1.6-.72-1.6-1.6s.72-1.6,1.6-1.6,1.6.72,1.6,1.6-.72,1.6-1.6,1.6ZM320.11,326.17c-.83,0-1.51.68-1.51,1.51s.68,1.51,1.51,1.51,1.51-.68,1.51-1.51-.68-1.51-1.51-1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M321,327.68c0,.49-.4.89-.89.89s-.89-.4-.89-.89.4-.89.89-.89.89.4.89.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "309.26 258.11 336.97 242.11 364.69 258.11 336.97 274.11 309.26 258.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "312.26 259.84 336.97 245.57 361.69 259.84 336.97 274.11 312.26 259.84"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-103"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M364.47,266.57c-15.09,8.71-39.64,8.67-54.83-.1-15.19-8.77-15.26-22.94-.17-31.65,15.09-8.71,39.64-8.67,54.83.1,15.19,8.77,15.26,22.94.17,31.65Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M351.53,242.67c-.18.1-.47.1-.66,0-.18-.11-.18-.27,0-.38.18-.1.47-.1.66,0,.18.11.18.27,0,.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M351.31,242.54c-.06.03-.16.03-.22,0-.06-.03-.06-.09,0-.12.06-.03.16-.03.22,0,.06.03.06.09,0,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M350.54,242.12c-.06.04-.15.04-.22,0-.06-.03-.07-.09-.01-.12.06-.04.15-.04.22,0,.06.03.07.09.01.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M349.74,241.72c-.05.04-.15.04-.21.01s-.08-.09-.02-.12c.05-.04.15-.04.21-.01.07.03.08.09.02.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M348.91,241.34s-.14.05-.21.02c-.07-.03-.08-.08-.03-.12s.14-.05.21-.02.08.08.03.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M348.04,240.99s-.14.05-.21.03c-.07-.03-.09-.08-.05-.12s.14-.05.21-.03c.07.03.09.08.05.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M347.14,240.67s-.14.06-.21.03c-.07-.02-.1-.08-.06-.12.04-.04.14-.06.21-.03.07.02.1.08.06.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M346.21,240.37s-.13.06-.21.04c-.08-.02-.11-.08-.07-.12.04-.04.13-.06.21-.04.08.02.11.08.07.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M345.26,240.1s-.12.06-.2.04c-.08-.02-.11-.07-.08-.12.03-.04.12-.06.2-.04.08.02.11.07.08.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M344.29,239.86s-.12.07-.2.05c-.08-.02-.12-.07-.09-.11.03-.05.12-.07.2-.05.08.02.12.07.09.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M343.29,239.65s-.11.07-.19.06c-.08-.02-.12-.07-.1-.11.03-.05.11-.07.19-.06.08.02.12.07.1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M342.28,239.47s-.11.07-.19.06c-.08-.01-.13-.06-.11-.11s.11-.07.19-.06c.08.01.13.06.11.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M341.26,239.32s-.1.08-.18.07c-.08-.01-.14-.06-.12-.1.02-.05.1-.08.18-.07s.14.06.12.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M340.22,239.21s-.09.08-.17.07-.14-.05-.13-.1c.01-.05.09-.08.17-.07.08,0,.14.05.13.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M339.17,239.12s-.08.08-.17.08c-.08,0-.15-.05-.14-.1,0-.05.08-.08.17-.08.08,0,.15.05.14.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M338.12,239.07s-.08.09-.16.08c-.08,0-.15-.04-.15-.09s.08-.09.16-.08c.08,0,.15.04.15.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M337.06,239.04s-.07.09-.15.09c-.08,0-.15-.04-.15-.09,0-.05.07-.09.15-.09.08,0,.15.04.15.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M336.01,239.05s-.06.09-.14.09c-.08,0-.16-.04-.16-.08,0-.05.06-.09.14-.09.08,0,.16.04.16.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M334.95,239.09s-.05.09-.14.1c-.08,0-.16-.03-.17-.08,0-.05.05-.09.14-.1.08,0,.16.03.17.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M333.9,239.17s-.04.09-.13.1c-.08,0-.16-.03-.18-.07-.01-.05.04-.09.13-.1.08,0,.16.03.18.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M332.86,239.27s-.03.09-.12.1-.16-.02-.18-.07c-.02-.05.03-.09.12-.1.08,0,.16.02.18.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M331.83,239.41s-.03.1-.11.11-.17-.02-.19-.06c-.02-.05.03-.1.11-.11.08-.01.17.02.19.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M330.82,239.58s-.02.1-.1.11c-.08.01-.17-.01-.19-.06-.03-.05.02-.1.1-.11.08-.01.17.01.19.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M329.82,239.77s0,.1-.09.11c-.08.02-.17,0-.2-.05-.03-.05,0-.1.09-.11.08-.02.17,0,.2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M328.84,240s0,.1-.08.12c-.08.02-.17,0-.2-.05-.03-.04,0-.1.08-.12.08-.02.17,0,.2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M327.89,240.26s0,.1-.07.12c-.08.02-.17,0-.21-.04-.04-.04,0-.1.07-.12.08-.02.17,0,.21.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M326.96,240.54s.02.1-.06.12c-.07.02-.17,0-.21-.03-.04-.04-.02-.1.06-.12.07-.02.17,0,.21.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M326.06,240.86s.03.1-.04.12c-.07.03-.17.01-.21-.03-.05-.04-.03-.1.04-.12s.17-.01.21.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M325.18,241.2s.04.09-.03.12c-.07.03-.16.02-.21-.02-.05-.04-.04-.09.03-.12.07-.03.16-.02.21.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M324.34,241.56c.05.04.04.09-.02.12-.07.03-.16.02-.22-.01-.05-.04-.04-.09.02-.12.07-.03.16-.02.22.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M323.53,241.95c.06.04.05.09-.01.12-.06.03-.16.03-.22,0-.06-.04-.05-.09.01-.12.06-.03.16-.03.22,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M322.76,242.37c.06.03.06.09,0,.12-.06.03-.16.03-.22,0-.06-.03-.06-.09,0-.12.06-.03.16-.03.22,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M322.03,242.81c.06.03.07.09.01.12s-.15.04-.22,0c-.06-.03-.07-.09-.01-.12.06-.04.15-.04.22,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M321.34,243.27c.07.03.08.09.02.12-.05.04-.15.04-.21.01-.07-.03-.08-.09-.02-.12.05-.04.15-.04.22-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M320.7,243.75c.07.03.08.08.03.12s-.15.05-.21.02c-.07-.03-.08-.08-.03-.12s.15-.05.21-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M320.09,244.24c.07.03.09.08.05.12s-.14.05-.21.03c-.07-.03-.09-.08-.05-.12.05-.04.14-.05.21-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M319.54,244.76c.07.02.1.08.06.12-.04.04-.14.06-.21.03-.07-.02-.1-.08-.06-.12.04-.04.14-.06.21-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M319.03,245.29c.08.02.11.08.07.12-.04.04-.13.06-.21.04-.08-.02-.11-.08-.07-.12.04-.04.13-.06.21-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M318.57,245.84c.08.02.11.07.08.12s-.12.06-.2.04c-.08-.02-.11-.07-.08-.12.03-.04.12-.06.2-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M318.16,246.4c.08.02.12.07.09.11-.03.05-.12.07-.2.05-.08-.02-.12-.07-.09-.11.03-.05.12-.07.2-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M317.81,246.98c.08.02.12.07.1.11-.03.05-.11.07-.19.06-.08-.02-.12-.07-.1-.11.03-.05.11-.07.19-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M317.5,247.56c.08.01.13.06.11.11-.02.05-.11.07-.19.06-.08-.01-.13-.06-.11-.11.02-.05.11-.07.19-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M317.25,248.15c.08.01.14.06.12.1s-.1.08-.18.07-.14-.06-.12-.1c.02-.05.1-.08.18-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M317.05,248.75c.08,0,.14.05.13.1-.01.05-.09.08-.17.07-.08,0-.14-.05-.13-.1.01-.05.09-.08.17-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M316.91,249.35c.08,0,.15.05.14.1,0,.05-.08.08-.17.08-.08,0-.15-.05-.14-.1,0-.05.08-.08.17-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M316.82,249.96c.08,0,.15.04.15.09,0,.05-.08.09-.16.08-.08,0-.15-.04-.15-.09,0-.05.08-.09.16-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M316.79,250.57c.08,0,.15.04.15.09,0,.05-.07.09-.15.09-.08,0-.15-.04-.15-.09,0-.05.07-.09.15-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M316.81,251.18c.08,0,.16.04.16.08,0,.05-.06.09-.14.09-.08,0-.16-.04-.16-.08,0-.05.06-.09.14-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M316.89,251.79c.08,0,.16.03.17.08,0,.05-.05.09-.14.1-.08,0-.16-.03-.17-.08,0-.05.05-.09.14-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M317.02,252.39c.08,0,.16.03.18.07.01.05-.04.09-.13.1s-.16-.03-.18-.07c-.01-.05.04-.09.13-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M317.21,253c.08,0,.16.02.18.07s-.03.09-.12.1c-.08,0-.16-.02-.18-.07-.02-.05.03-.09.12-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M317.45,253.59c.08-.01.17.02.19.06.02.05-.03.1-.11.11-.08.01-.17-.02-.19-.06-.02-.05.03-.1.11-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M317.75,254.18c.08-.01.17.01.19.06.03.05-.02.1-.1.11-.08.01-.17-.01-.19-.06-.03-.05.02-.1.1-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M318.1,254.75c.08-.02.17,0,.2.05.03.05,0,.1-.09.11-.08.02-.17,0-.2-.05-.03-.05,0-.1.09-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M318.5,255.32c.08-.02.17,0,.2.05s0,.1-.08.12c-.08.02-.17,0-.2-.05-.03-.04,0-.1.08-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M318.95,255.87c.08-.02.17,0,.21.04.04.04,0,.1-.07.12-.08.02-.17,0-.21-.04s0-.1.07-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M319.45,256.41c.07-.02.17,0,.21.03.04.04.02.1-.06.12-.07.02-.17,0-.21-.03-.04-.04-.02-.1.06-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M320,256.94c.07-.03.17-.01.21.03.05.04.03.1-.04.12-.07.03-.17.01-.21-.03-.05-.04-.03-.1.04-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M320.59,257.44c.07-.03.16-.02.21.02s.04.09-.03.12c-.07.03-.16.02-.21-.02s-.04-.09.03-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M321.23,257.93c.07-.03.16-.02.22.01.05.04.04.09-.02.12-.07.03-.16.02-.22-.01-.05-.04-.04-.09.02-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M321.91,258.4c.06-.03.16-.03.22,0,.06.04.05.09-.01.12-.06.03-.16.03-.22,0-.06-.04-.05-.09.01-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M322.64,258.85c.06-.03.16-.03.22,0s.06.09,0,.12c-.06.03-.16.03-.22,0-.06-.03-.06-.09,0-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M323.4,259.27c.06-.04.15-.04.22,0,.06.03.07.09.01.12-.06.04-.15.04-.22,0-.06-.03-.07-.09-.01-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M324.2,259.67c.05-.04.15-.04.22-.01.07.03.08.09.02.12-.05.04-.15.04-.22.01-.07-.03-.08-.09-.02-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M325.04,260.05s.15-.05.21-.02c.07.03.08.08.03.12s-.14.05-.21.02c-.07-.03-.08-.08-.03-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M325.9,260.4s.14-.05.21-.03c.07.03.09.08.05.12-.05.04-.14.05-.21.03-.07-.03-.09-.08-.05-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M326.8,260.72s.14-.06.21-.03c.07.02.1.08.06.12-.04.04-.14.06-.21.03-.07-.02-.1-.08-.06-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M327.73,261.02s.13-.06.21-.04c.08.02.11.08.07.12-.04.04-.13.06-.21.04-.08-.02-.11-.08-.07-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M328.68,261.29s.12-.06.2-.04c.08.02.11.07.08.12-.03.04-.12.06-.2.04-.08-.02-.11-.07-.08-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M329.66,261.53s.12-.07.2-.05.12.07.09.11c-.03.05-.12.07-.2.05-.08-.02-.12-.07-.09-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M330.65,261.74s.11-.07.19-.06c.08.02.12.07.1.11-.03.05-.11.07-.19.06s-.12-.07-.1-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M331.66,261.92s.11-.07.19-.06c.08.01.13.06.11.11-.02.05-.11.07-.19.06-.08-.01-.13-.06-.11-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M332.69,262.07s.1-.08.18-.07c.08.01.14.06.12.1-.02.05-.1.08-.18.07-.08-.01-.14-.06-.12-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M333.73,262.18s.09-.08.17-.07.14.05.13.1c-.01.05-.09.08-.17.07-.08,0-.14-.05-.13-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M334.77,262.27s.08-.08.17-.08c.08,0,.15.05.14.1,0,.05-.08.08-.17.08-.08,0-.15-.05-.14-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M335.83,262.32s.08-.09.16-.08c.08,0,.15.04.15.09,0,.05-.08.09-.16.08-.08,0-.15-.04-.15-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M336.88,262.35s.07-.09.15-.09c.08,0,.15.04.15.09,0,.05-.07.09-.15.09-.08,0-.15-.04-.15-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M337.94,262.34s.06-.09.14-.09c.08,0,.16.04.16.08,0,.05-.06.09-.14.09-.08,0-.16-.04-.16-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M338.99,262.3s.05-.09.14-.1c.08,0,.16.03.17.08,0,.05-.05.09-.14.1-.08,0-.16-.03-.17-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M340.04,262.22s.04-.09.13-.1c.08,0,.16.03.18.07.01.05-.04.09-.13.1-.08,0-.16-.03-.18-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M341.08,262.12s.03-.09.12-.1.16.02.18.07c.02.05-.03.09-.12.1-.08,0-.16-.02-.18-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M342.11,261.98s.03-.1.11-.11c.08-.01.17.02.19.06.02.05-.03.1-.11.11s-.17-.02-.19-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M343.12,261.82s.02-.1.1-.11c.08-.01.17.01.19.06s-.02.1-.1.11c-.08.01-.17-.01-.19-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M344.12,261.62s0-.1.09-.11c.08-.02.17,0,.2.05.03.05,0,.1-.09.11-.08.02-.17,0-.2-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M345.1,261.39s0-.1.08-.12.17,0,.2.05c.03.04,0,.1-.08.12-.08.02-.17,0-.2-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M346.05,261.13s0-.1.07-.12c.08-.02.17,0,.21.04s0,.1-.07.12c-.08.02-.17,0-.21-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M346.99,260.85s-.02-.1.06-.12c.07-.02.17,0,.21.03.04.04.02.1-.06.12-.07.02-.17,0-.21-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M347.89,260.54s-.03-.1.04-.12c.07-.03.17-.01.21.03.05.04.03.1-.04.12-.07.03-.17.01-.21-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M348.76,260.2s-.04-.09.03-.12c.07-.03.16-.02.21.02s.04.09-.03.12-.16.02-.21-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M349.6,259.83c-.05-.04-.04-.09.02-.12.07-.03.16-.02.22.01.05.04.04.09-.02.12-.07.03-.16.02-.22-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M350.41,259.44c-.06-.04-.05-.09.01-.12.06-.03.16-.03.22,0,.06.04.05.09-.01.12-.06.03-.16.03-.22,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M351.18,259.02c-.06-.03-.06-.09,0-.12.06-.03.16-.03.22,0,.06.03.06.09,0,.12-.06.03-.16.03-.22,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M351.91,258.58c-.06-.03-.07-.09-.01-.12.06-.04.15-.04.22,0,.06.03.07.09.01.12-.06.04-.15.04-.22,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M352.6,258.13c-.07-.03-.08-.09-.02-.12.05-.04.15-.04.22-.01.07.03.08.09.02.12-.05.04-.15.04-.21.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M353.25,257.65c-.07-.03-.08-.08-.03-.12.05-.04.15-.05.21-.02.07.03.08.08.03.12-.05.04-.15.05-.21.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M353.85,257.15c-.07-.03-.09-.08-.05-.12.05-.04.14-.05.21-.03s.09.08.05.12c-.05.04-.14.05-.21.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M354.41,256.63c-.07-.02-.1-.08-.06-.12.04-.04.14-.06.21-.03.07.02.1.08.06.12-.04.04-.14.06-.21.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M354.91,256.1c-.08-.02-.11-.08-.07-.12.04-.04.13-.06.21-.04.08.02.11.08.07.12-.04.04-.13.06-.21.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M355.37,255.55c-.08-.02-.11-.07-.08-.12.03-.04.12-.06.2-.04.08.02.11.07.08.12-.03.04-.12.06-.2.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M355.78,254.99c-.08-.02-.12-.07-.09-.11.03-.05.12-.07.2-.05.08.02.12.07.09.11-.03.05-.12.07-.2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M356.14,254.41c-.08-.02-.12-.07-.1-.11.03-.05.11-.07.19-.06.08.02.12.07.1.11-.03.05-.11.07-.19.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M356.44,253.83c-.08-.01-.13-.06-.11-.11s.11-.07.19-.06c.08.01.13.06.11.11-.02.05-.11.07-.19.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M356.69,253.24c-.08-.01-.14-.06-.12-.1.02-.05.1-.08.18-.07.08.01.14.06.12.1-.02.05-.1.08-.18.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M356.89,252.64c-.08,0-.14-.05-.13-.1.01-.05.09-.08.17-.07.08,0,.14.05.13.1-.01.05-.09.08-.17.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M357.03,252.04c-.08,0-.15-.05-.14-.1,0-.05.08-.08.17-.08.08,0,.15.05.14.1,0,.05-.08.08-.17.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M357.12,251.43c-.08,0-.15-.04-.15-.09,0-.05.08-.09.16-.08.08,0,.15.04.15.09,0,.05-.08.09-.16.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M357.15,250.82c-.08,0-.15-.04-.15-.09s.07-.09.15-.09c.08,0,.15.04.15.09,0,.05-.07.09-.15.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M357.13,250.21c-.08,0-.16-.04-.16-.08,0-.05.06-.09.14-.09.08,0,.16.04.16.08,0,.05-.06.09-.14.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M357.05,249.6c-.08,0-.16-.03-.17-.08,0-.05.05-.09.14-.1.08,0,.16.03.17.08,0,.05-.05.09-.14.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M356.92,249c-.08,0-.16-.03-.18-.07-.01-.05.04-.09.13-.1.08,0,.16.03.18.07.01.05-.04.09-.13.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M356.73,248.39c-.08,0-.16-.02-.18-.07-.02-.05.03-.09.12-.1.08,0,.16.02.18.07.02.05-.03.09-.12.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M356.49,247.8c-.08.01-.17-.02-.19-.06s.03-.1.11-.11c.08-.01.17.02.19.06.02.05-.03.1-.11.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M356.19,247.21c-.08.01-.17-.01-.19-.06s.02-.1.1-.11c.08-.01.17.01.19.06s-.02.1-.1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M355.85,246.64c-.08.02-.17,0-.2-.05-.03-.05,0-.1.09-.11.08-.02.17,0,.2.05.03.05,0,.1-.09.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M355.45,246.07c-.08.02-.17,0-.2-.05-.03-.04,0-.1.08-.12.08-.02.17,0,.2.05.03.04,0,.1-.08.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M355,245.52c-.08.02-.17,0-.21-.04-.04-.04,0-.1.07-.12.08-.02.17,0,.21.04.04.04,0,.1-.07.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M354.5,244.98c-.07.02-.17,0-.21-.03-.04-.04-.02-.1.06-.12.07-.02.17,0,.21.03.04.04.02.1-.06.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M353.95,244.45c-.07.03-.17.01-.21-.03s-.03-.1.04-.12c.07-.03.17-.01.21.03.05.04.03.1-.04.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M353.35,243.95c-.07.03-.16.02-.21-.02-.05-.04-.04-.09.03-.12.07-.03.16-.02.21.02.05.04.04.09-.03.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M352.71,243.46c-.07.03-.16.02-.22-.01-.05-.04-.04-.09.02-.12s.16-.02.22.01c.05.04.04.09-.02.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M352.03,242.99c-.06.03-.16.03-.22,0-.06-.04-.05-.09.01-.12.06-.03.16-.03.22,0,.06.04.05.09-.01.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M349.99,241.83c-.16.11-.45.13-.65.04-.2-.09-.23-.26-.07-.38.16-.11.45-.13.65-.04.2.09.23.26.07.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M324.58,241.45c.16.12.13.28-.07.38-.2.09-.49.07-.65-.04-.16-.12-.13-.28.07-.38.2-.09.49-.07.65.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M322.98,242.24c.18.11.18.27,0,.38-.18.1-.47.1-.66,0-.18-.11-.18-.27,0-.38.18-.1.47-.1.66,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M321.54,243.13c.2.09.23.26.07.38-.16.11-.45.13-.65.04-.2-.09-.23-.26-.07-.38.16-.11.45-.13.65-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M321.03,257.79c.2-.09.49-.07.65.04.16.12.13.28-.07.38-.2.09-.49.07-.65-.04-.16-.12-.13-.28.07-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M322.42,258.72c.18-.1.47-.1.66,0,.18.11.18.27,0,.38-.18.1-.47.1-.66,0-.18-.11-.18-.27,0-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M323.96,259.56c.16-.11.45-.13.65-.04.2.09.23.26.07.38-.16.11-.45.13-.65.04-.2-.09-.23-.26-.07-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M349.36,259.94c-.16-.12-.13-.28.07-.38.2-.09.49-.07.65.04.16.12.13.28-.07.38-.2.09-.49.07-.65-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M350.96,259.15c-.18-.11-.18-.27,0-.38.18-.1.47-.1.66,0,.18.11.18.27,0,.38-.18.1-.47.1-.66,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M352.4,258.26c-.2-.09-.23-.26-.07-.38.16-.11.45-.13.65-.04.2.09.23.26.07.38-.16.11-.45.13-.65.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M352.91,243.6c-.2.09-.49.07-.65-.04-.16-.12-.13-.28.07-.38.2-.09.49-.07.65.04.16.12.13.28-.07.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M357.16,251c-.26,0-.47-.12-.47-.27,0-.15.21-.27.46-.27.26,0,.47.12.47.27,0,.15-.21.27-.46.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M357.09,249.78c-.26.02-.48-.09-.51-.24-.03-.15.16-.28.41-.29.26-.02.48.09.51.24.03.15-.16.28-.41.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M339.48,239.14c-.03.15-.25.25-.51.24-.26-.02-.44-.15-.41-.3.03-.15.25-.25.51-.24.26.02.44.15.41.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M337.37,239.04c0,.15-.21.27-.46.27-.26,0-.47-.12-.47-.27,0-.15.21-.27.46-.27.26,0,.47.12.47.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M335.26,239.08c.03.15-.16.28-.41.29-.26.02-.48-.09-.51-.24-.03-.15.16-.28.41-.29.26-.01.48.09.51.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M316.94,249.17c.26.02.44.15.41.3-.03.15-.25.25-.51.24-.26-.02-.44-.15-.41-.3.03-.15.25-.25.51-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M316.79,250.39c.26,0,.47.12.47.27,0,.15-.21.27-.46.27-.26,0-.47-.12-.47-.27s.21-.27.46-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M316.86,251.61c.25-.02.48.09.51.24.03.15-.16.28-.41.29s-.48-.09-.51-.24c-.03-.15.16-.28.41-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M334.46,262.25c.03-.15.25-.25.51-.24.26.02.44.15.41.3-.03.15-.25.25-.51.24-.26-.02-.44-.15-.41-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M336.57,262.35c0-.15.21-.27.46-.27s.47.12.47.27-.21.27-.46.27-.47-.12-.47-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M338.68,262.31c-.03-.15.16-.28.41-.29.26-.01.48.09.51.24.03.15-.16.28-.41.29-.26.02-.48-.09-.51-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M357,252.22c-.26-.02-.44-.15-.41-.3.03-.15.25-.25.51-.24.26.02.44.15.41.3-.03.15-.25.25-.51.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M321.96,255.28c-8.33-4.81-8.37-12.61-.09-17.39,8.28-4.78,21.8-4.76,30.13.05,8.33,4.81,8.37,12.61.09,17.39-8.28,4.78-21.8,4.76-30.13-.05ZM351.56,238.19c-8.1-4.67-21.23-4.7-29.28-.05-8.05,4.65-8.01,12.23.09,16.9,8.1,4.67,21.23,4.7,29.28.05,8.05-4.65,8.01-12.23-.09-16.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M353.52,232.97c-.21.12-.54.12-.75,0-.21-.12-.21-.31,0-.43.21-.12.54-.12.75,0,.21.12.21.31,0,.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M353.27,232.82c-.07.04-.18.04-.25,0-.07-.04-.07-.1,0-.14.07-.04.18-.04.25,0,.07.04.07.1,0,.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M352.4,232.34c-.06.04-.17.04-.25,0-.07-.04-.08-.1-.01-.14.06-.04.17-.04.25,0,.07.04.08.1.01.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M351.49,231.88c-.06.04-.17.05-.24.01-.07-.04-.09-.1-.03-.14.06-.04.17-.05.24-.01.07.04.09.1.03.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M350.54,231.46c-.06.04-.16.05-.24.02-.08-.03-.1-.1-.04-.14.06-.04.16-.05.24-.02.08.03.1.1.04.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M349.55,231.06c-.05.05-.16.06-.24.03-.08-.03-.1-.09-.05-.14.05-.05.16-.06.24-.03.08.03.1.09.05.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M348.53,230.69s-.15.06-.24.04c-.08-.03-.11-.09-.06-.14.05-.05.15-.06.24-.04.08.03.11.09.06.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M347.48,230.35s-.15.07-.23.04c-.09-.03-.12-.09-.08-.14.04-.05.15-.07.23-.04.09.03.12.09.08.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M346.4,230.05c-.04.05-.14.07-.23.05-.09-.02-.13-.08-.09-.13.04-.05.14-.07.23-.05.09.02.13.08.09.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M345.29,229.77c-.03.05-.13.08-.22.06-.09-.02-.13-.08-.1-.13.03-.05.13-.08.22-.06.09.02.13.08.1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M344.16,229.54c-.03.05-.13.08-.22.06-.09-.02-.14-.07-.11-.13.03-.05.13-.08.22-.06.09.02.14.07.11.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M343.01,229.33c-.02.05-.12.09-.21.07-.09-.01-.15-.07-.12-.12.02-.05.12-.09.21-.07.09.01.15.07.12.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M341.84,229.16c-.02.05-.11.09-.21.08-.09-.01-.15-.07-.13-.12.02-.05.11-.09.21-.08.09.01.15.07.13.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M340.66,229.03c-.01.05-.1.09-.2.08-.09,0-.16-.06-.15-.12s.1-.09.2-.08c.09,0,.16.06.15.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M339.47,228.93c0,.06-.1.09-.19.09-.1,0-.17-.06-.16-.11s.1-.09.19-.09c.1,0,.17.06.16.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M338.27,228.87c0,.06-.09.1-.18.09-.1,0-.17-.05-.17-.11,0-.06.09-.1.18-.09.1,0,.17.05.17.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M337.07,228.84c0,.06-.08.1-.17.1-.1,0-.17-.05-.17-.1,0-.06.08-.1.17-.1.1,0,.17.05.17.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M335.87,228.85c0,.06-.07.1-.16.11-.1,0-.18-.04-.18-.1,0-.06.07-.1.16-.11.1,0,.18.04.18.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M334.68,228.9c.01.06-.06.1-.15.11-.1,0-.18-.03-.19-.09-.01-.06.06-.1.15-.11.1,0,.18.03.19.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M333.48,228.98c.02.05-.05.11-.14.11-.09,0-.18-.03-.2-.08-.02-.05.05-.11.14-.11.09,0,.18.03.2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M332.3,229.1c.02.05-.04.11-.13.12-.09.01-.19-.02-.21-.08-.02-.05.04-.11.13-.12.09-.01.19.02.21.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M331.13,229.26c.03.05-.03.11-.12.12-.09.01-.19-.02-.21-.07-.03-.05.03-.11.12-.12.09-.01.19.02.21.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M329.98,229.45c.03.05-.02.11-.11.13-.09.02-.19-.01-.22-.06-.03-.05.02-.11.11-.13.09-.02.19.01.22.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M328.85,229.67c.03.05,0,.11-.1.13-.09.02-.19,0-.22-.06-.03-.05,0-.11.1-.13.09-.02.19,0,.22.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M327.73,229.93c.04.05,0,.11-.09.13-.09.02-.19,0-.23-.05-.04-.05,0-.11.09-.13.09-.02.19,0,.23.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M326.65,230.22s.01.11-.08.13c-.09.03-.19,0-.23-.04-.04-.05-.01-.11.08-.13.09-.02.19,0,.23.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M325.59,230.55s.02.11-.06.14c-.08.03-.19.01-.24-.04-.05-.05-.02-.11.06-.14.08-.03.19-.01.24.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M324.56,230.9c.05.05.03.11-.05.14-.08.03-.19.02-.24-.03-.05-.05-.03-.11.05-.14.08-.03.19-.02.24.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M323.57,231.29c.06.04.04.11-.04.14-.08.03-.19.02-.24-.02-.06-.04-.04-.11.04-.14.08-.03.19-.02.24.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M322.61,231.71c.06.04.05.11-.02.14-.07.03-.18.03-.24-.02-.06-.04-.05-.11.02-.14s.18-.03.24.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M321.7,232.15c.06.04.06.1-.01.14-.07.04-.18.03-.25,0-.06-.04-.06-.1.01-.14.07-.04.18-.03.25,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M320.82,232.62c.07.04.07.1,0,.14-.07.04-.18.04-.25,0-.07-.04-.07-.1,0-.14.07-.04.18-.04.25,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M319.99,233.12c.07.04.08.1.01.14-.06.04-.17.04-.25,0-.07-.04-.08-.1-.01-.14.06-.04.17-.04.25,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M319.21,233.64c.07.04.09.1.03.14-.06.04-.17.05-.24.01-.07-.04-.09-.1-.03-.14.06-.04.17-.05.24-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M318.47,234.19c.08.03.1.1.04.14-.06.04-.16.05-.24.02-.08-.03-.1-.1-.04-.14.06-.04.16-.05.24-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M317.79,234.76c.08.03.1.09.05.14-.05.05-.16.06-.24.03-.08-.03-.1-.09-.05-.14.05-.05.16-.06.24-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M317.16,235.34c.08.03.11.09.06.14s-.15.06-.24.04c-.08-.03-.11-.09-.06-.14.05-.05.15-.06.24-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M316.58,235.95c.09.03.12.09.08.14-.04.05-.15.07-.23.04s-.12-.09-.08-.14c.04-.05.15-.07.23-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M316.06,236.57c.09.02.13.08.09.13-.04.05-.14.07-.23.05-.09-.02-.13-.08-.09-.13.04-.05.14-.07.23-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M315.59,237.21c.09.02.13.08.1.13-.03.05-.13.08-.22.06-.09-.02-.13-.08-.1-.13.03-.05.13-.08.22-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M315.19,237.86c.09.02.14.07.11.13-.03.05-.13.08-.22.06-.09-.02-.14-.07-.11-.13.03-.05.13-.08.22-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M314.84,238.52c.09.01.15.07.12.12-.02.05-.12.09-.21.07-.09-.01-.15-.07-.12-.12.02-.05.12-.09.21-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M314.55,239.2c.09.01.15.07.13.12-.02.05-.11.09-.21.08-.09-.01-.15-.07-.13-.12s.11-.09.21-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M314.33,239.88c.09,0,.16.06.15.12s-.1.09-.2.08c-.09,0-.16-.06-.15-.12.01-.05.1-.09.2-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M314.17,240.56c.1,0,.17.06.16.11s-.1.09-.19.09c-.1,0-.17-.06-.16-.11,0-.06.1-.09.19-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M314.07,241.25c.1,0,.17.05.17.11,0,.06-.09.1-.18.09-.1,0-.17-.05-.17-.11,0-.06.09-.1.18-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M314.03,241.95c.1,0,.17.05.17.1s-.08.1-.17.1c-.1,0-.17-.05-.17-.1,0-.06.08-.1.17-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M314.06,242.64c.1,0,.18.04.18.1,0,.06-.07.1-.16.11-.1,0-.18-.04-.18-.1,0-.06.07-.1.16-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M314.15,243.33c.1,0,.18.03.19.09.01.06-.06.1-.15.11-.1,0-.18-.03-.19-.09-.01-.06.06-.1.15-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M314.3,244.02c.09,0,.18.03.2.08.02.05-.05.11-.14.11-.09,0-.18-.03-.2-.08-.02-.05.05-.11.14-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M314.51,244.7c.09-.01.19.02.21.08.02.05-.04.11-.13.12-.09.01-.19-.02-.21-.08-.02-.05.04-.11.13-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M314.79,245.38c.09-.01.19.02.21.07.03.05-.03.11-.12.12s-.19-.02-.21-.07c-.03-.05.03-.11.12-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M315.12,246.05c.09-.02.19.01.22.06.03.05-.02.11-.11.13-.09.02-.19-.01-.22-.06-.03-.05.02-.11.11-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M315.52,246.7c.09-.02.19,0,.22.06.03.05,0,.11-.1.13-.09.02-.19,0-.22-.06-.03-.05,0-.11.1-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M315.97,247.35c.09-.02.19,0,.23.05.04.05,0,.11-.09.13-.09.02-.19,0-.23-.05-.04-.05,0-.11.09-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M316.49,247.97c.09-.03.19,0,.23.04.04.05.01.11-.08.13-.09.03-.19,0-.23-.04-.04-.05-.01-.11.08-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M317.05,248.59c.08-.03.19-.01.24.04.05.05.02.11-.06.14-.08.03-.19.01-.24-.04-.05-.05-.02-.11.06-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M317.68,249.18c.08-.03.19-.02.24.03.05.05.03.11-.05.14-.08.03-.19.02-.24-.03-.05-.05-.03-.11.05-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M318.35,249.76c.08-.03.19-.02.24.02.06.04.04.11-.04.14-.08.03-.19.02-.24-.02-.06-.04-.04-.11.04-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M319.08,250.31c.07-.03.18-.03.24.02.06.04.05.11-.02.14-.07.03-.18.03-.24-.02-.06-.04-.05-.11.02-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M319.86,250.84c.07-.04.18-.03.25,0s.06.1-.01.14c-.07.04-.18.03-.25,0-.06-.04-.06-.1.01-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M320.68,251.35c.07-.04.18-.04.25,0,.07.04.07.1,0,.14s-.18.04-.25,0c-.07-.04-.07-.1,0-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M321.55,251.84c.06-.04.17-.04.25,0,.07.04.08.1.01.14-.06.04-.17.04-.25,0-.07-.04-.08-.1-.01-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M322.46,252.29c.06-.04.17-.05.24-.01.07.04.09.1.03.14s-.17.05-.24.01c-.07-.04-.09-.1-.03-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M323.41,252.72c.06-.04.16-.05.24-.02.08.03.1.1.04.14s-.16.05-.24.02c-.08-.03-.1-.1-.04-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M324.39,253.12c.05-.05.16-.06.24-.03.08.03.1.09.05.14-.05.05-.16.06-.24.03-.08-.03-.1-.09-.05-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M325.41,253.49s.15-.06.24-.04c.08.03.11.09.06.14-.05.05-.15.06-.24.04-.08-.03-.11-.09-.06-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M326.47,253.82s.15-.07.23-.04c.09.03.12.09.08.14-.04.05-.15.07-.23.04-.09-.03-.12-.09-.08-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M327.55,254.13c.04-.05.14-.07.23-.05.09.02.13.08.09.13-.04.05-.14.07-.23.05-.09-.02-.13-.08-.09-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M328.66,254.4c.03-.05.13-.08.22-.06.09.02.13.08.1.13-.03.05-.13.08-.22.06s-.13-.08-.1-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M329.79,254.64c.03-.05.13-.08.22-.06.09.02.14.07.11.13-.03.05-.13.08-.22.06-.09-.02-.14-.07-.11-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M330.94,254.84c.02-.05.12-.09.21-.07.09.01.15.07.12.12-.02.05-.12.09-.21.07-.09-.01-.15-.07-.12-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M332.1,255.01c.02-.05.11-.09.21-.08.09.01.15.07.13.12s-.11.09-.21.08-.15-.07-.13-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M333.28,255.15c.01-.05.1-.09.2-.08.09,0,.16.06.15.12-.01.05-.1.09-.2.08-.09,0-.16-.06-.15-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M334.47,255.24c0-.06.1-.09.19-.09.1,0,.17.06.16.11,0,.06-.1.09-.19.09-.1,0-.17-.06-.16-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M335.67,255.31c0-.06.09-.1.18-.09s.17.05.17.11c0,.06-.09.1-.18.09-.1,0-.17-.05-.17-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M336.87,255.33c0-.06.08-.1.17-.1.1,0,.17.05.17.1,0,.06-.08.1-.17.1-.1,0-.17-.05-.17-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M338.07,255.32c0-.06.07-.1.16-.11.1,0,.18.04.18.1,0,.06-.07.1-.16.11-.1,0-.18-.04-.18-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M339.27,255.27c-.01-.06.06-.1.15-.11.1,0,.18.03.19.09.01.06-.06.1-.15.11-.1,0-.18-.03-.19-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M340.46,255.19c-.02-.05.05-.11.14-.11.09,0,.18.03.2.08.02.05-.05.11-.14.11-.09,0-.18-.03-.2-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M341.64,255.07c-.02-.05.04-.11.13-.12.09-.01.19.02.21.08.02.05-.04.11-.13.12-.09.01-.19-.02-.21-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M342.81,254.92c-.03-.05.03-.11.12-.12.09-.01.19.02.21.07.03.05-.03.11-.12.12-.09.01-.19-.02-.21-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M343.96,254.73c-.03-.05.02-.11.11-.13.09-.02.19.01.22.06s-.02.11-.11.13c-.09.02-.19-.01-.22-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M345.1,254.5c-.03-.05,0-.11.1-.13s.19,0,.22.06c.03.05,0,.11-.1.13-.09.02-.19,0-.22-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M346.21,254.24c-.04-.05,0-.11.09-.13.09-.02.19,0,.23.05.04.05,0,.11-.09.13-.09.02-.19,0-.23-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M347.3,253.95s-.01-.11.08-.13c.09-.03.19,0,.23.04.04.05.01.11-.08.13-.09.03-.19,0-.23-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M348.35,253.63s-.02-.11.06-.14c.08-.03.19-.01.24.04.05.05.02.11-.06.14-.08.03-.19.01-.24-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M349.38,253.27c-.05-.05-.03-.11.05-.14.08-.03.19-.02.24.03.05.05.03.11-.05.14-.08.03-.19.02-.24-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M350.37,252.89c-.06-.04-.04-.11.04-.14.08-.03.19-.02.24.02.06.04.04.11-.04.14-.08.03-.19.02-.24-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M351.33,252.47c-.06-.04-.05-.11.02-.14.07-.03.18-.03.24.02.06.04.05.11-.02.14-.07.03-.18.03-.24-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M352.25,252.03c-.06-.04-.06-.1.01-.14.07-.04.18-.03.25,0,.06.04.06.1-.01.14-.07.04-.18.03-.25,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M353.12,251.55c-.07-.04-.07-.1,0-.14.07-.04.18-.04.25,0,.07.04.07.1,0,.14-.07.04-.18.04-.25,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M353.95,251.06c-.07-.04-.08-.1-.01-.14.06-.04.17-.04.25,0,.07.04.08.1.01.14s-.17.04-.25,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M354.74,250.53c-.07-.04-.09-.1-.03-.14.06-.04.17-.05.24-.01.07.04.09.1.03.14-.06.04-.17.05-.24.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M355.47,249.99c-.08-.03-.1-.1-.04-.14.06-.04.16-.05.24-.02.08.03.1.1.04.14-.06.04-.16.05-.24.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M356.16,249.42c-.08-.03-.1-.09-.05-.14.05-.05.16-.06.24-.03.08.03.1.09.05.14-.05.05-.16.06-.24.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M356.79,248.83c-.08-.03-.11-.09-.06-.14.05-.05.15-.06.24-.04.08.03.11.09.06.14s-.15.06-.24.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M357.37,248.23c-.09-.03-.12-.09-.08-.14.04-.05.15-.07.23-.04.09.03.12.09.08.14-.04.05-.15.07-.23.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M357.89,247.6c-.09-.02-.13-.08-.09-.13.04-.05.14-.07.23-.05.09.02.13.08.09.13-.04.05-.14.07-.23.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M358.35,246.97c-.09-.02-.13-.08-.1-.13.03-.05.13-.08.22-.06.09.02.13.08.1.13-.03.05-.13.08-.22.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M358.76,246.32c-.09-.02-.14-.07-.11-.13.03-.05.13-.08.22-.06.09.02.14.07.11.13-.03.05-.13.08-.22.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M359.1,245.65c-.09-.01-.15-.07-.12-.12.02-.05.12-.09.21-.07.09.01.15.07.12.12-.02.05-.12.09-.21.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M359.39,244.98c-.09-.01-.15-.07-.13-.12.02-.05.11-.09.21-.08.09.01.15.07.13.12-.02.05-.11.09-.21.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M359.61,244.3c-.09,0-.16-.06-.15-.12.01-.05.1-.09.2-.08.09,0,.16.06.15.12s-.1.09-.2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M359.78,243.61c-.1,0-.17-.06-.16-.11,0-.06.1-.09.19-.09.1,0,.17.06.16.11,0,.06-.1.09-.19.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M359.88,242.92c-.1,0-.17-.05-.17-.11,0-.06.09-.1.18-.09.1,0,.17.05.17.11,0,.06-.09.1-.18.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M359.91,242.23c-.1,0-.17-.05-.17-.1,0-.06.08-.1.17-.1.1,0,.17.05.17.1,0,.06-.08.1-.17.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M359.89,241.54c-.1,0-.18-.04-.18-.1,0-.06.07-.1.16-.11.1,0,.18.04.18.1,0,.06-.07.1-.16.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M359.8,240.84c-.1,0-.18-.03-.19-.09-.01-.06.06-.1.15-.11.1,0,.18.03.19.09.01.06-.06.1-.15.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M359.65,240.16c-.09,0-.18-.03-.2-.08-.02-.05.05-.11.14-.11.09,0,.18.03.2.08.02.05-.05.11-.14.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M359.43,239.47c-.09.01-.19-.02-.21-.08-.02-.05.04-.11.13-.12.09-.01.19.02.21.08.02.05-.04.11-.13.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M359.16,238.8c-.09.01-.19-.02-.21-.07-.03-.05.03-.11.12-.12s.19.02.21.07-.03.11-.12.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M358.82,238.13c-.09.02-.19-.01-.22-.06-.03-.05.02-.11.11-.13.09-.02.19.01.22.06.03.05-.02.11-.11.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M358.43,237.47c-.09.02-.19,0-.22-.06-.03-.05,0-.11.1-.13.09-.02.19,0,.22.06.03.05,0,.11-.1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M357.97,236.83c-.09.02-.19,0-.23-.05s0-.11.09-.13c.09-.02.19,0,.23.05.04.05,0,.11-.09.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M357.46,236.2c-.09.03-.19,0-.23-.04-.04-.05-.01-.11.08-.13.09-.03.19,0,.23.04.04.05.01.11-.08.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M356.89,235.59c-.08.03-.19.01-.24-.04-.05-.05-.02-.11.06-.14.08-.03.19-.01.24.04.05.05.02.11-.06.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M356.27,234.99c-.08.03-.19.02-.24-.03-.05-.05-.03-.11.05-.14.08-.03.19-.02.24.03.05.05.03.11-.05.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M355.59,234.42c-.08.03-.19.02-.24-.02-.06-.04-.04-.11.04-.14.08-.03.19-.02.24.02.06.04.04.11-.04.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M354.86,233.86c-.07.03-.18.03-.24-.02-.06-.04-.05-.11.02-.14.07-.03.18-.03.24.02.06.04.05.11-.02.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M354.09,233.33c-.07.04-.18.03-.25,0-.06-.04-.06-.1.01-.14.07-.04.18-.03.25,0,.06.04.06.1-.01.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M351.76,232.01c-.18.13-.52.15-.74.04-.23-.11-.26-.3-.08-.43.18-.13.52-.15.74-.04.23.11.26.3.08.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M322.89,231.58c.18.13.15.32-.08.43-.23.11-.56.08-.74-.05-.18-.13-.15-.32.08-.43.23-.11.56-.08.74.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M321.07,232.48c.21.12.21.31,0,.43-.21.12-.54.12-.75,0-.21-.12-.21-.31,0-.43.21-.12.54-.12.75,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M319.43,233.48c.23.11.26.3.08.43-.18.13-.52.15-.74.04-.23-.11-.26-.3-.08-.43.18-.13.52-.15.74-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M318.86,250.15c.23-.11.56-.08.74.05.18.13.15.32-.08.43-.23.11-.56.08-.74-.05-.18-.13-.15-.32.08-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M320.43,251.21c.21-.12.54-.12.75,0,.21.12.21.31,0,.43-.21.12-.54.12-.75,0-.21-.12-.21-.31,0-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M322.18,252.16c.18-.13.52-.15.74-.04.23.11.26.3.08.43-.18.13-.52.15-.74.04s-.26-.3-.08-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M351.06,252.6c-.18-.13-.15-.32.08-.43.23-.11.56-.08.74.05.18.13.15.32-.08.43s-.56.08-.74-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M352.87,251.7c-.21-.12-.21-.31,0-.43.21-.12.54-.12.75,0,.21.12.21.31,0,.43-.21.12-.54.12-.75,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M354.51,250.69c-.23-.11-.26-.3-.08-.43.18-.13.52-.15.74-.04.23.11.26.3.08.43-.18.13-.52.15-.74.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M355.09,234.02c-.23.11-.56.08-.74-.05-.18-.13-.15-.32.08-.43.23-.11.56-.08.74.05.18.13.15.32-.08.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M359.91,242.43c-.29,0-.53-.14-.53-.31,0-.17.23-.3.53-.3.29,0,.53.14.53.31,0,.17-.23.3-.53.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M359.84,241.05c-.29.02-.55-.1-.58-.27-.03-.17.18-.32.47-.33.29-.02.55.1.58.27.03.17-.18.32-.47.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M339.82,228.95c-.03.17-.29.29-.58.27-.29-.02-.5-.17-.47-.34.03-.17.29-.29.58-.27.29.02.5.17.47.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M337.43,228.84c0,.17-.23.3-.53.3-.29,0-.53-.14-.53-.31,0-.17.23-.3.53-.3.29,0,.53.14.53.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M335.03,228.88c.03.17-.18.32-.47.33-.29.02-.55-.1-.58-.27-.03-.17.18-.32.47-.33.29-.02.55.1.58.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M314.2,240.36c.29.02.5.17.47.34s-.29.29-.58.27c-.29-.02-.5-.17-.47-.34.03-.17.29-.29.58-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M314.03,241.74c.29,0,.53.14.53.31,0,.17-.23.3-.53.3-.29,0-.53-.14-.53-.31,0-.17.23-.3.53-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M314.11,243.13c.29-.02.55.1.58.27.03.17-.18.32-.47.33-.29.02-.55-.1-.58-.27-.03-.17.18-.32.47-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M334.12,255.22c.03-.17.29-.29.58-.27s.5.17.47.34c-.03.17-.29.29-.58.27-.29-.02-.5-.17-.47-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M336.52,255.33c0-.17.23-.3.53-.3.29,0,.53.14.53.31,0,.17-.23.3-.53.3-.29,0-.53-.14-.53-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M338.92,255.29c-.03-.17.18-.32.47-.33.29-.02.55.1.58.27.03.17-.18.32-.47.33-.29.02-.55-.1-.58-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M359.74,243.82c-.29-.02-.5-.17-.47-.34.03-.17.29-.29.58-.27.29.02.5.17.47.34-.03.17-.29.29-.58.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M351.53,226.64c-.18.1-.47.1-.66,0-.18-.11-.18-.27,0-.38.18-.1.47-.1.66,0,.18.11.18.27,0,.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M351.31,226.52c-.06.03-.16.03-.22,0s-.06-.09,0-.12.16-.03.22,0c.06.03.06.09,0,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M350.54,226.09c-.06.04-.15.04-.22,0s-.07-.09-.01-.12c.06-.04.15-.04.22,0,.06.03.07.09.01.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M349.74,225.69c-.05.04-.15.04-.21.01s-.08-.09-.02-.12c.05-.04.15-.04.21-.01.07.03.08.09.02.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M348.91,225.31s-.14.05-.21.02-.08-.08-.03-.12c.05-.04.14-.05.21-.02s.08.08.03.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M348.04,224.96s-.14.05-.21.03c-.07-.03-.09-.08-.05-.12.05-.04.14-.05.21-.03.07.03.09.08.05.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M347.14,224.64s-.14.06-.21.03c-.07-.02-.1-.08-.06-.12.04-.04.14-.06.21-.03s.1.08.06.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M346.21,224.34s-.13.06-.21.04c-.08-.02-.11-.08-.07-.12s.13-.06.21-.04c.08.02.11.08.07.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M345.26,224.07s-.12.06-.2.04c-.08-.02-.11-.07-.08-.12.03-.04.12-.06.2-.04.08.02.11.07.08.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M344.29,223.83s-.12.07-.2.05c-.08-.02-.12-.07-.09-.11.03-.05.12-.07.2-.05.08.02.12.07.09.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M343.29,223.62s-.11.07-.19.06c-.08-.02-.12-.07-.1-.11.03-.05.11-.07.19-.06.08.02.12.07.1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M342.28,223.45s-.11.07-.19.06c-.08-.01-.13-.06-.11-.11s.11-.07.19-.06c.08.01.13.06.11.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M341.26,223.3s-.1.08-.18.07c-.08-.01-.14-.06-.12-.1.02-.05.1-.08.18-.07.08.01.14.06.12.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M340.22,223.18s-.09.08-.17.07c-.08,0-.14-.05-.13-.1.01-.05.09-.08.17-.07.08,0,.14.05.13.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M339.17,223.09s-.08.08-.17.08c-.08,0-.15-.05-.14-.1,0-.05.08-.08.17-.08.08,0,.15.05.14.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M338.12,223.04s-.08.09-.16.08c-.08,0-.15-.04-.15-.09,0-.05.08-.09.16-.08.08,0,.15.04.15.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M337.06,223.02s-.07.09-.15.09-.15-.04-.15-.09.07-.09.15-.09c.08,0,.15.04.15.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M336.01,223.03s-.06.09-.14.09c-.08,0-.16-.04-.16-.08,0-.05.06-.09.14-.09.08,0,.16.04.16.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M334.95,223.07s-.05.09-.14.1c-.08,0-.16-.03-.17-.08,0-.05.05-.09.14-.1.08,0,.16.03.17.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M333.9,223.14s-.04.09-.13.1c-.08,0-.16-.03-.18-.07-.01-.05.04-.09.13-.1.08,0,.16.03.18.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M332.86,223.24s-.03.09-.12.1c-.08,0-.16-.02-.18-.07-.02-.05.03-.09.12-.1.08,0,.16.02.18.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M331.83,223.38s-.03.1-.11.11-.17-.02-.19-.06c-.02-.05.03-.1.11-.11.08-.01.17.02.19.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M330.82,223.55s-.02.1-.1.11c-.08.01-.17-.01-.19-.06-.03-.05.02-.1.1-.11.08-.01.17.01.19.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M329.82,223.75s0,.1-.09.11c-.08.02-.17,0-.2-.05-.03-.05,0-.1.09-.11.08-.02.17,0,.2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M328.84,223.97s0,.1-.08.12c-.08.02-.17,0-.2-.05-.03-.04,0-.1.08-.12.08-.02.17,0,.2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M327.89,224.23s0,.1-.07.12c-.08.02-.17,0-.21-.04-.04-.04,0-.1.07-.12.08-.02.17,0,.21.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M326.96,224.51s.02.1-.06.12c-.07.02-.17,0-.21-.03-.04-.04-.02-.1.06-.12.07-.02.17,0,.21.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M326.06,224.83s.03.1-.04.12c-.07.03-.17.01-.21-.03-.05-.04-.03-.1.04-.12s.17-.01.21.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M325.18,225.17s.04.09-.03.12c-.07.03-.16.02-.21-.02-.05-.04-.04-.09.03-.12.07-.03.16-.02.21.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M324.34,225.53c.05.04.04.09-.02.12s-.16.02-.22-.01c-.05-.04-.04-.09.02-.12.07-.03.16-.02.22.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M323.53,225.93c.06.04.05.09-.01.12-.06.03-.16.03-.22,0-.06-.04-.05-.09.01-.12.06-.03.16-.03.22,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M322.76,226.34c.06.03.06.09,0,.12-.06.03-.16.03-.22,0-.06-.03-.06-.09,0-.12.06-.03.16-.03.22,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M322.03,226.78c.06.03.07.09.01.12s-.15.04-.22,0c-.06-.03-.07-.09-.01-.12.06-.04.15-.04.22,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M321.34,227.24c.07.03.08.09.02.12-.05.04-.15.04-.21.01-.07-.03-.08-.09-.02-.12.05-.04.15-.04.22-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M320.7,227.72c.07.03.08.08.03.12-.05.04-.15.05-.21.02-.07-.03-.08-.08-.03-.12.05-.04.15-.05.21-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M320.09,228.22c.07.03.09.08.05.12s-.14.05-.21.03c-.07-.03-.09-.08-.05-.12.05-.04.14-.05.21-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M319.54,228.73c.07.02.1.08.06.12-.04.04-.14.06-.21.03-.07-.02-.1-.08-.06-.12.04-.04.14-.06.21-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M319.03,229.27c.08.02.11.08.07.12-.04.04-.13.06-.21.04-.08-.02-.11-.08-.07-.12.04-.04.13-.06.21-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M318.57,229.81c.08.02.11.07.08.12-.03.04-.12.06-.2.04-.08-.02-.11-.07-.08-.12.03-.04.12-.06.2-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M318.16,230.38c.08.02.12.07.09.11-.03.05-.12.07-.2.05-.08-.02-.12-.07-.09-.11.03-.05.12-.07.2-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M317.81,230.95c.08.02.12.07.1.11-.03.05-.11.07-.19.06-.08-.02-.12-.07-.1-.11.03-.05.11-.07.19-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M317.5,231.53c.08.01.13.06.11.11-.02.05-.11.07-.19.06s-.13-.06-.11-.11c.02-.05.11-.07.19-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M317.25,232.12c.08.01.14.06.12.1-.02.05-.1.08-.18.07-.08-.01-.14-.06-.12-.1.02-.05.1-.08.18-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M317.05,232.72c.08,0,.14.05.13.1-.01.05-.09.08-.17.07-.08,0-.14-.05-.13-.1.01-.05.09-.08.17-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M316.91,233.33c.08,0,.15.05.14.1,0,.05-.08.08-.17.08-.08,0-.15-.05-.14-.1,0-.05.08-.08.17-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M316.82,233.93c.08,0,.15.04.15.09,0,.05-.08.09-.16.08-.08,0-.15-.04-.15-.09,0-.05.08-.09.16-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M316.79,234.54c.08,0,.15.04.15.09,0,.05-.07.09-.15.09-.08,0-.15-.04-.15-.09,0-.05.07-.09.15-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M316.81,235.15c.08,0,.16.04.16.08,0,.05-.06.09-.14.09-.08,0-.16-.04-.16-.08,0-.05.06-.09.14-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M316.89,235.76c.08,0,.16.03.17.08,0,.05-.05.09-.14.1-.08,0-.16-.03-.17-.08,0-.05.05-.09.14-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M317.02,236.37c.08,0,.16.03.18.07.01.05-.04.09-.13.1s-.16-.03-.18-.07c-.01-.05.04-.09.13-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M317.21,236.97c.08,0,.16.02.18.07s-.03.09-.12.1c-.08,0-.16-.02-.18-.07s.03-.09.12-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M317.45,237.56c.08-.01.17.02.19.06.02.05-.03.1-.11.11-.08.01-.17-.02-.19-.06-.02-.05.03-.1.11-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M317.75,238.15c.08-.01.17.01.19.06.03.05-.02.1-.1.11-.08.01-.17-.01-.19-.06-.03-.05.02-.1.1-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M318.1,238.73c.08-.02.17,0,.2.05.03.05,0,.1-.09.11-.08.02-.17,0-.2-.05s0-.1.09-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M318.5,239.29c.08-.02.17,0,.2.05.03.04,0,.1-.08.12-.08.02-.17,0-.2-.05-.03-.04,0-.1.08-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M318.95,239.85c.08-.02.17,0,.21.04.04.04,0,.1-.07.12-.08.02-.17,0-.21-.04s0-.1.07-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M319.45,240.39c.07-.02.17,0,.21.03.04.04.02.1-.06.12-.07.02-.17,0-.21-.03-.04-.04-.02-.1.06-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M320,240.91c.07-.03.17-.01.21.03.05.04.03.1-.04.12-.07.03-.17.01-.21-.03-.05-.04-.03-.1.04-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M320.59,241.42c.07-.03.16-.02.21.02.05.04.04.09-.03.12-.07.03-.16.02-.21-.02s-.04-.09.03-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M321.23,241.9c.07-.03.16-.02.22.01.05.04.04.09-.02.12-.07.03-.16.02-.22-.01-.05-.04-.04-.09.02-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M321.91,242.37c.06-.03.16-.03.22,0,.06.04.05.09-.01.12-.06.03-.16.03-.22,0-.06-.04-.05-.09.01-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M322.64,242.82c.06-.03.16-.03.22,0s.06.09,0,.12c-.06.03-.16.03-.22,0-.06-.03-.06-.09,0-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M323.4,243.24c.06-.04.15-.04.22,0,.06.03.07.09.01.12-.06.04-.15.04-.22,0-.06-.03-.07-.09-.01-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M324.2,243.64c.05-.04.15-.04.22-.01.07.03.08.09.02.12-.05.04-.15.04-.22.01-.07-.03-.08-.09-.02-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M325.04,244.02s.15-.05.21-.02c.07.03.08.08.03.12-.05.04-.14.05-.21.02-.07-.03-.08-.08-.03-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M325.9,244.37s.14-.05.21-.03c.07.03.09.08.05.12-.05.04-.14.05-.21.03-.07-.03-.09-.08-.05-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M326.8,244.7s.14-.06.21-.03c.07.02.1.08.06.12-.04.04-.14.06-.21.03-.07-.02-.1-.08-.06-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M327.73,244.99s.13-.06.21-.04.11.08.07.12c-.04.04-.13.06-.21.04-.08-.02-.11-.08-.07-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M328.68,245.26s.12-.06.2-.04c.08.02.11.07.08.12-.03.04-.12.06-.2.04-.08-.02-.11-.07-.08-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M329.66,245.5s.12-.07.2-.05c.08.02.12.07.09.11-.03.05-.12.07-.2.05-.08-.02-.12-.07-.09-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M330.65,245.71s.11-.07.19-.06c.08.02.12.07.1.11-.03.05-.11.07-.19.06-.08-.02-.12-.07-.1-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M331.66,245.89s.11-.07.19-.06c.08.01.13.06.11.11-.02.05-.11.07-.19.06-.08-.01-.13-.06-.11-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M332.69,246.04s.1-.08.18-.07.14.06.12.1c-.02.05-.1.08-.18.07-.08-.01-.14-.06-.12-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M333.73,246.16s.09-.08.17-.07.14.05.13.1c-.01.05-.09.08-.17.07-.08,0-.14-.05-.13-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M334.77,246.24s.08-.08.17-.08c.08,0,.15.05.14.1,0,.05-.08.08-.17.08-.08,0-.15-.05-.14-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M335.83,246.3s.08-.09.16-.08c.08,0,.15.04.15.09,0,.05-.08.09-.16.08-.08,0-.15-.04-.15-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M336.88,246.32s.07-.09.15-.09c.08,0,.15.04.15.09,0,.05-.07.09-.15.09-.08,0-.15-.04-.15-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M337.94,246.31s.06-.09.14-.09c.08,0,.16.04.16.08,0,.05-.06.09-.14.09-.08,0-.16-.04-.16-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M338.99,246.27s.05-.09.14-.1c.08,0,.16.03.17.08,0,.05-.05.09-.14.1-.08,0-.16-.03-.17-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M340.04,246.2s.04-.09.13-.1c.08,0,.16.03.18.07.01.05-.04.09-.13.1-.08,0-.16-.03-.18-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M341.08,246.09s.03-.09.12-.1.16.02.18.07-.03.09-.12.1c-.08,0-.16-.02-.18-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M342.11,245.95s.03-.1.11-.11c.08-.01.17.02.19.06.02.05-.03.1-.11.11s-.17-.02-.19-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M343.12,245.79s.02-.1.1-.11c.08-.01.17.01.19.06s-.02.1-.1.11c-.08.01-.17-.01-.19-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M344.12,245.59s0-.1.09-.11c.08-.02.17,0,.2.05.03.05,0,.1-.09.11-.08.02-.17,0-.2-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M345.1,245.36s0-.1.08-.12c.08-.02.17,0,.2.05.03.04,0,.1-.08.12-.08.02-.17,0-.2-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M346.05,245.11s0-.1.07-.12c.08-.02.17,0,.21.04s0,.1-.07.12c-.08.02-.17,0-.21-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M346.99,244.82s-.02-.1.06-.12c.07-.02.17,0,.21.03.04.04.02.1-.06.12-.07.02-.17,0-.21-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M347.89,244.51s-.03-.1.04-.12c.07-.03.17-.01.21.03.05.04.03.1-.04.12-.07.03-.17.01-.21-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M348.76,244.17s-.04-.09.03-.12c.07-.03.16-.02.21.02s.04.09-.03.12c-.07.03-.16.02-.21-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M349.6,243.8c-.05-.04-.04-.09.02-.12.07-.03.16-.02.22.01.05.04.04.09-.02.12-.07.03-.16.02-.22-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M350.41,243.41c-.06-.04-.05-.09.01-.12.06-.03.16-.03.22,0s.05.09-.01.12c-.06.03-.16.03-.22,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M351.18,242.99c-.06-.03-.06-.09,0-.12.06-.03.16-.03.22,0,.06.03.06.09,0,.12-.06.03-.16.03-.22,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M351.91,242.56c-.06-.03-.07-.09-.01-.12.06-.04.15-.04.22,0,.06.03.07.09.01.12-.06.04-.15.04-.22,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M352.6,242.1c-.07-.03-.08-.09-.02-.12.05-.04.15-.04.22-.01.07.03.08.09.02.12-.05.04-.15.04-.21.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M353.25,241.62c-.07-.03-.08-.08-.03-.12.05-.04.15-.05.21-.02.07.03.08.08.03.12-.05.04-.15.05-.21.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M353.85,241.12c-.07-.03-.09-.08-.05-.12.05-.04.14-.05.21-.03s.09.08.05.12c-.05.04-.14.05-.21.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M354.41,240.6c-.07-.02-.1-.08-.06-.12.04-.04.14-.06.21-.03.07.02.1.08.06.12-.04.04-.14.06-.21.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M354.91,240.07c-.08-.02-.11-.08-.07-.12.04-.04.13-.06.21-.04.08.02.11.08.07.12-.04.04-.13.06-.21.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M355.37,239.52c-.08-.02-.11-.07-.08-.12.03-.04.12-.06.2-.04.08.02.11.07.08.12-.03.04-.12.06-.2.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M355.78,238.96c-.08-.02-.12-.07-.09-.11.03-.05.12-.07.2-.05.08.02.12.07.09.11-.03.05-.12.07-.2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M356.14,238.39c-.08-.02-.12-.07-.1-.11.03-.05.11-.07.19-.06.08.02.12.07.1.11-.03.05-.11.07-.19.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M356.44,237.8c-.08-.01-.13-.06-.11-.11.02-.05.11-.07.19-.06.08.01.13.06.11.11-.02.05-.11.07-.19.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M356.69,237.21c-.08-.01-.14-.06-.12-.1.02-.05.1-.08.18-.07.08.01.14.06.12.1s-.1.08-.18.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M356.89,236.61c-.08,0-.14-.05-.13-.1.01-.05.09-.08.17-.07.08,0,.14.05.13.1-.01.05-.09.08-.17.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M357.03,236.01c-.08,0-.15-.05-.14-.1,0-.05.08-.08.17-.08.08,0,.15.05.14.1,0,.05-.08.08-.17.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M357.12,235.4c-.08,0-.15-.04-.15-.09,0-.05.08-.09.16-.08.08,0,.15.04.15.09,0,.05-.08.09-.16.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M357.15,234.79c-.08,0-.15-.04-.15-.09s.07-.09.15-.09c.08,0,.15.04.15.09,0,.05-.07.09-.15.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M357.13,234.18c-.08,0-.16-.04-.16-.08,0-.05.06-.09.14-.09.08,0,.16.04.16.08,0,.05-.06.09-.14.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M357.05,233.57c-.08,0-.16-.03-.17-.08,0-.05.05-.09.14-.1.08,0,.16.03.17.08,0,.05-.05.09-.14.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M356.92,232.97c-.08,0-.16-.03-.18-.07-.01-.05.04-.09.13-.1.08,0,.16.03.18.07.01.05-.04.09-.13.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M356.73,232.37c-.08,0-.16-.02-.18-.07s.03-.09.12-.1c.08,0,.16.02.18.07.02.05-.03.09-.12.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M356.49,231.77c-.08.01-.17-.02-.19-.06-.02-.05.03-.1.11-.11.08-.01.17.02.19.06.02.05-.03.1-.11.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M356.19,231.19c-.08.01-.17-.01-.19-.06-.03-.05.02-.1.1-.11.08-.01.17.01.19.06.03.05-.02.1-.1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M355.85,230.61c-.08.02-.17,0-.2-.05-.03-.05,0-.1.09-.11.08-.02.17,0,.2.05.03.05,0,.1-.09.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M355.45,230.04c-.08.02-.17,0-.2-.05-.03-.04,0-.1.08-.12.08-.02.17,0,.2.05.03.04,0,.1-.08.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M355,229.49c-.08.02-.17,0-.21-.04-.04-.04,0-.1.07-.12.08-.02.17,0,.21.04.04.04,0,.1-.07.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M354.5,228.95c-.07.02-.17,0-.21-.03-.04-.04-.02-.1.06-.12.07-.02.17,0,.21.03.04.04.02.1-.06.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M353.95,228.43c-.07.03-.17.01-.21-.03-.05-.04-.03-.1.04-.12.07-.03.17-.01.21.03.05.04.03.1-.04.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M353.35,227.92c-.07.03-.16.02-.21-.02-.05-.04-.04-.09.03-.12.07-.03.16-.02.21.02.05.04.04.09-.03.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M352.71,227.43c-.07.03-.16.02-.22-.01-.05-.04-.04-.09.02-.12s.16-.02.22.01c.05.04.04.09-.02.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M352.03,226.96c-.06.03-.16.03-.22,0s-.05-.09.01-.12c.06-.03.16-.03.22,0,.06.04.05.09-.01.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M349.99,225.8c-.16.11-.45.13-.65.04-.2-.09-.23-.26-.07-.38.16-.11.45-.13.65-.04.2.09.23.26.07.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M324.58,225.42c.16.12.13.28-.07.38-.2.09-.49.07-.65-.04-.16-.12-.13-.28.07-.38.2-.09.49-.07.65.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M322.98,226.21c.18.11.18.27,0,.38-.18.1-.47.1-.66,0-.18-.11-.18-.27,0-.38.18-.1.47-.1.66,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M321.54,227.1c.2.09.23.26.07.38-.16.11-.45.13-.65.04-.2-.09-.23-.26-.07-.38.16-.11.45-.13.65-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M321.03,241.76c.2-.09.49-.07.65.04.16.12.13.28-.07.38-.2.09-.49.07-.65-.04-.16-.12-.13-.28.07-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M322.42,242.69c.18-.1.47-.1.66,0,.18.11.18.27,0,.38-.18.1-.47.1-.66,0-.18-.11-.18-.27,0-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M323.96,243.53c.16-.11.45-.13.65-.04.2.09.23.26.07.38-.16.11-.45.13-.65.04-.2-.09-.23-.26-.07-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M349.36,243.91c-.16-.12-.13-.28.07-.38.2-.09.49-.07.65.04.16.12.13.28-.07.38-.2.09-.49.07-.65-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M350.96,243.12c-.18-.11-.18-.27,0-.38.18-.1.47-.1.66,0,.18.11.18.27,0,.38-.18.1-.47.1-.66,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M352.4,242.24c-.2-.09-.23-.26-.07-.38.16-.11.45-.13.65-.04.2.09.23.26.07.38-.16.11-.45.13-.65.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M352.91,227.57c-.2.09-.49.07-.65-.04-.16-.12-.13-.28.07-.38s.49-.07.65.04c.16.12.13.28-.07.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M357.16,234.97c-.26,0-.47-.12-.47-.27,0-.15.21-.27.46-.27.26,0,.47.12.47.27,0,.15-.21.27-.46.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M357.09,233.75c-.26.02-.48-.09-.51-.24-.03-.15.16-.28.41-.29.26-.02.48.09.51.24.03.15-.16.28-.41.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M339.48,223.11c-.03.15-.25.25-.51.24-.26-.02-.44-.15-.41-.3.03-.15.25-.25.51-.24.26.02.44.15.41.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M337.37,223.02c0,.15-.21.27-.46.27-.26,0-.47-.12-.47-.27,0-.15.21-.27.46-.27s.47.12.47.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M335.26,223.05c.03.15-.16.28-.41.29-.26.02-.48-.09-.51-.24-.03-.15.16-.28.41-.29.26-.02.48.09.51.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M316.94,233.15c.26.02.44.15.41.3s-.25.25-.51.24c-.26-.02-.44-.15-.41-.3.03-.15.25-.25.51-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M316.79,234.36c.26,0,.47.12.47.27,0,.15-.21.27-.46.27-.26,0-.47-.12-.47-.27s.21-.27.46-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M316.86,235.58c.25-.02.48.09.51.24.03.15-.16.28-.41.29s-.48-.09-.51-.24c-.03-.15.16-.28.41-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M334.46,246.22c.03-.15.25-.25.51-.24.26.02.44.15.41.3-.03.15-.25.25-.51.24-.26-.02-.44-.15-.41-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M336.57,246.32c0-.15.21-.27.46-.27.26,0,.47.12.47.27s-.21.27-.46.27c-.26,0-.47-.12-.47-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M338.68,246.29c-.03-.15.16-.28.41-.29.26-.02.48.09.51.24.03.15-.16.28-.41.29-.26.02-.48-.09-.51-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M357,236.19c-.26-.02-.44-.15-.41-.3s.25-.25.51-.24c.26.02.44.15.41.3-.03.15-.25.25-.51.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M321.96,239.26c-8.33-4.81-8.37-12.61-.09-17.39,8.28-4.78,21.8-4.76,30.13.05,8.33,4.81,8.37,12.61.09,17.39-8.28,4.78-21.8,4.76-30.13-.05ZM351.56,222.16c-8.1-4.67-21.23-4.7-29.28-.05-8.05,4.65-8.01,12.23.09,16.9,8.1,4.67,21.23,4.7,29.28.05,8.05-4.65,8.01-12.23-.09-16.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M353.52,216.94c-.21.12-.54.12-.75,0-.21-.12-.21-.31,0-.43.21-.12.54-.12.75,0,.21.12.21.31,0,.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M353.27,216.8c-.07.04-.18.04-.25,0-.07-.04-.07-.1,0-.14.07-.04.18-.04.25,0,.07.04.07.1,0,.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M352.4,216.31c-.06.04-.17.04-.25,0-.07-.04-.08-.1-.01-.14.06-.04.17-.04.25,0,.07.04.08.1.01.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M351.49,215.86c-.06.04-.17.05-.24.01-.07-.04-.09-.1-.03-.14.06-.04.17-.05.24-.01.07.04.09.1.03.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M350.54,215.43c-.06.04-.16.05-.24.02-.08-.03-.1-.1-.04-.14.06-.04.16-.05.24-.02.08.03.1.1.04.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M349.55,215.03c-.05.05-.16.06-.24.03-.08-.03-.1-.09-.05-.14.05-.05.16-.06.24-.03.08.03.1.09.05.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M348.53,214.66s-.15.06-.24.04c-.08-.03-.11-.09-.06-.14.05-.05.15-.06.24-.04.08.03.11.09.06.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M347.48,214.32s-.15.07-.23.04c-.09-.03-.12-.09-.08-.14.04-.05.15-.07.23-.04.09.03.12.09.08.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M346.4,214.02c-.04.05-.14.07-.23.05-.09-.02-.13-.08-.09-.13.04-.05.14-.07.23-.05.09.02.13.08.09.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M345.29,213.75c-.03.05-.13.08-.22.06-.09-.02-.13-.08-.1-.13.03-.05.13-.08.22-.06.09.02.13.08.1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M344.16,213.51c-.03.05-.13.08-.22.06-.09-.02-.14-.07-.11-.13s.13-.08.22-.06c.09.02.14.07.11.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M343.01,213.3c-.02.05-.12.09-.21.07-.09-.01-.15-.07-.12-.12.02-.05.12-.09.21-.07.09.01.15.07.12.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M341.84,213.13c-.02.05-.11.09-.21.08-.09-.01-.15-.07-.13-.12.02-.05.11-.09.21-.08.09.01.15.07.13.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M340.66,213c-.01.05-.1.09-.2.08-.09,0-.16-.06-.15-.12.01-.05.1-.09.2-.08.09,0,.16.06.15.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M339.47,212.9c0,.06-.1.09-.19.09-.1,0-.17-.06-.16-.11,0-.06.1-.09.19-.09.1,0,.17.06.16.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M338.27,212.84c0,.06-.09.1-.18.09-.1,0-.17-.05-.17-.11,0-.06.09-.1.18-.09.1,0,.17.05.17.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M337.07,212.82c0,.06-.08.1-.17.1-.1,0-.17-.05-.17-.1,0-.06.08-.1.17-.1.1,0,.17.05.17.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M335.87,212.83c0,.06-.07.1-.16.11-.1,0-.18-.04-.18-.1,0-.06.07-.1.16-.11.1,0,.18.04.18.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M334.68,212.87c.01.06-.06.1-.15.11-.1,0-.18-.03-.19-.09-.01-.06.06-.1.15-.11.1,0,.18.03.19.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M333.48,212.96c.02.05-.05.11-.14.11-.09,0-.18-.03-.2-.08s.05-.11.14-.11c.09,0,.18.03.2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M332.3,213.08c.02.05-.04.11-.13.12-.09.01-.19-.02-.21-.08-.02-.05.04-.11.13-.12.09-.01.19.02.21.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M331.13,213.23c.03.05-.03.11-.12.12-.09.01-.19-.02-.21-.07-.03-.05.03-.11.12-.12.09-.01.19.02.21.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M329.98,213.42c.03.05-.02.11-.11.13-.09.02-.19-.01-.22-.06-.03-.05.02-.11.11-.13.09-.02.19.01.22.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M328.85,213.64c.03.05,0,.11-.1.13-.09.02-.19,0-.22-.06-.03-.05,0-.11.1-.13.09-.02.19,0,.22.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M327.73,213.9c.04.05,0,.11-.09.13-.09.02-.19,0-.23-.05-.04-.05,0-.11.09-.13s.19,0,.23.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M326.65,214.2s.01.11-.08.13c-.09.03-.19,0-.23-.04-.04-.05-.01-.11.08-.13.09-.02.19,0,.23.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M325.59,214.52s.02.11-.06.14c-.08.03-.19.01-.24-.04-.05-.05-.02-.11.06-.14.08-.03.19-.01.24.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M324.56,214.88c.05.05.03.11-.05.14-.08.03-.19.02-.24-.03-.05-.05-.03-.11.05-.14.08-.03.19-.02.24.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M323.57,215.26c.06.04.04.11-.04.14s-.19.02-.24-.02c-.06-.04-.04-.11.04-.14.08-.03.19-.02.24.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M322.61,215.68c.06.04.05.11-.02.14-.07.03-.18.03-.24-.02-.06-.04-.05-.11.02-.14s.18-.03.24.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M321.7,216.12c.06.04.06.1-.01.14-.07.04-.18.03-.25,0s-.06-.1.01-.14c.07-.04.18-.03.25,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M320.82,216.59c.07.04.07.1,0,.14-.07.04-.18.04-.25,0-.07-.04-.07-.1,0-.14s.18-.04.25,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M319.99,217.09c.07.04.08.1.01.14-.06.04-.17.04-.25,0-.07-.04-.08-.1-.01-.14.06-.04.17-.04.25,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M319.21,217.62c.07.04.09.1.03.14-.06.04-.17.05-.24.01-.07-.04-.09-.1-.03-.14.06-.04.17-.05.24-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M318.47,218.16c.08.03.1.1.04.14-.06.04-.16.05-.24.02-.08-.03-.1-.1-.04-.14.06-.04.16-.05.24-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M317.79,218.73c.08.03.1.09.05.14-.05.05-.16.06-.24.03-.08-.03-.1-.09-.05-.14.05-.05.16-.06.24-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M317.16,219.32c.08.03.11.09.06.14s-.15.06-.24.04c-.08-.03-.11-.09-.06-.14.05-.05.15-.06.24-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M316.58,219.92c.09.03.12.09.08.14-.04.05-.15.07-.23.04-.09-.03-.12-.09-.08-.14.04-.05.15-.07.23-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M316.06,220.54c.09.02.13.08.09.13-.04.05-.14.07-.23.05-.09-.02-.13-.08-.09-.13.04-.05.14-.07.23-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M315.59,221.18c.09.02.13.08.1.13-.03.05-.13.08-.22.06-.09-.02-.13-.08-.1-.13.03-.05.13-.08.22-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M315.19,221.83c.09.02.14.07.11.13-.03.05-.13.08-.22.06-.09-.02-.14-.07-.11-.13.03-.05.13-.08.22-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M314.84,222.5c.09.01.15.07.12.12-.02.05-.12.09-.21.07-.09-.01-.15-.07-.12-.12.02-.05.12-.09.21-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M314.55,223.17c.09.01.15.07.13.12-.02.05-.11.09-.21.08-.09-.01-.15-.07-.13-.12s.11-.09.21-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M314.33,223.85c.09,0,.16.06.15.12s-.1.09-.2.08c-.09,0-.16-.06-.15-.12.01-.05.1-.09.2-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M314.17,224.53c.1,0,.17.06.16.11s-.1.09-.19.09c-.1,0-.17-.06-.16-.11,0-.06.1-.09.19-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M314.07,225.23c.1,0,.17.05.17.11,0,.06-.09.1-.18.09-.1,0-.17-.05-.17-.11,0-.06.09-.1.18-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M314.03,225.92c.1,0,.17.05.17.1,0,.06-.08.1-.17.1-.1,0-.17-.05-.17-.1,0-.06.08-.1.17-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M314.06,226.61c.1,0,.18.04.18.1,0,.06-.07.1-.16.11s-.18-.04-.18-.1c0-.06.07-.1.16-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M314.15,227.3c.1,0,.18.03.19.09.01.06-.06.1-.15.11-.1,0-.18-.03-.19-.09s.06-.1.15-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M314.3,227.99c.09,0,.18.03.2.08.02.05-.05.11-.14.11-.09,0-.18-.03-.2-.08-.02-.05.05-.11.14-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M314.51,228.68c.09-.01.19.02.21.08.02.05-.04.11-.13.12-.09.01-.19-.02-.21-.08-.02-.05.04-.11.13-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M314.79,229.35c.09-.01.19.02.21.07.03.05-.03.11-.12.12-.09.01-.19-.02-.21-.07-.03-.05.03-.11.12-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M315.12,230.02c.09-.02.19.01.22.06.03.05-.02.11-.11.13-.09.02-.19-.01-.22-.06-.03-.05.02-.11.11-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M315.52,230.67c.09-.02.19,0,.22.06.03.05,0,.11-.1.13-.09.02-.19,0-.22-.06-.03-.05,0-.11.1-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M315.97,231.32c.09-.02.19,0,.23.05.04.05,0,.11-.09.13-.09.02-.19,0-.23-.05-.04-.05,0-.11.09-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M316.49,231.95c.09-.03.19,0,.23.04.04.05.01.11-.08.13-.09.02-.19,0-.23-.04-.04-.05-.01-.11.08-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M317.05,232.56c.08-.03.19-.01.24.04.05.05.02.11-.06.14-.08.03-.19.01-.24-.04-.05-.05-.02-.11.06-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M317.68,233.15c.08-.03.19-.02.24.03.05.05.03.11-.05.14-.08.03-.19.02-.24-.03-.05-.05-.03-.11.05-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M318.35,233.73c.08-.03.19-.02.24.02.06.04.04.11-.04.14-.08.03-.19.02-.24-.02-.06-.04-.04-.11.04-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M319.08,234.28c.07-.03.18-.03.24.02.06.04.05.11-.02.14-.07.03-.18.03-.24-.02-.06-.04-.05-.11.02-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M319.86,234.82c.07-.04.18-.03.25,0,.06.04.06.1-.01.14-.07.04-.18.03-.25,0-.06-.04-.06-.1.01-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M320.68,235.32c.07-.04.18-.04.25,0,.07.04.07.1,0,.14s-.18.04-.25,0c-.07-.04-.07-.1,0-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M321.55,235.81c.06-.04.17-.04.25,0,.07.04.08.1.01.14-.06.04-.17.04-.25,0-.07-.04-.08-.1-.01-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M322.46,236.26c.06-.04.17-.05.24-.01.07.04.09.1.03.14-.06.04-.17.05-.24.01-.07-.04-.09-.1-.03-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M323.41,236.69c.06-.04.16-.05.24-.02.08.03.1.1.04.14s-.16.05-.24.02c-.08-.03-.1-.1-.04-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M324.39,237.09c.05-.05.16-.06.24-.03.08.03.1.09.05.14-.05.05-.16.06-.24.03-.08-.03-.1-.09-.05-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M325.41,237.46s.15-.06.24-.04c.08.03.11.09.06.14-.05.05-.15.06-.24.04-.08-.03-.11-.09-.06-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M326.47,237.8s.15-.07.23-.04c.09.03.12.09.08.14-.04.05-.15.07-.23.04-.09-.03-.12-.09-.08-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M327.55,238.1c.04-.05.14-.07.23-.05.09.02.13.08.09.13-.04.05-.14.07-.23.05-.09-.02-.13-.08-.09-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M328.66,238.37c.03-.05.13-.08.22-.06.09.02.13.08.1.13-.03.05-.13.08-.22.06-.09-.02-.13-.08-.1-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M329.79,238.61c.03-.05.13-.08.22-.06.09.02.14.07.11.13-.03.05-.13.08-.22.06-.09-.02-.14-.07-.11-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M330.94,238.82c.02-.05.12-.09.21-.07.09.01.15.07.12.12-.02.05-.12.09-.21.07-.09-.01-.15-.07-.12-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M332.1,238.99c.02-.05.11-.09.21-.08.09.01.15.07.13.12s-.11.09-.21.08-.15-.07-.13-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M333.28,239.12c.01-.05.1-.09.2-.08.09,0,.16.06.15.12-.01.05-.1.09-.2.08-.09,0-.16-.06-.15-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M334.47,239.22c0-.06.1-.09.19-.09.1,0,.17.06.16.11,0,.06-.1.09-.19.09-.1,0-.17-.06-.16-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M335.67,239.28c0-.06.09-.1.18-.09.1,0,.17.05.17.11,0,.06-.09.1-.18.09-.1,0-.17-.05-.17-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M336.87,239.3c0-.06.08-.1.17-.1.1,0,.17.05.17.1s-.08.1-.17.1c-.1,0-.17-.05-.17-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M338.07,239.29c0-.06.07-.1.16-.11.1,0,.18.04.18.1,0,.06-.07.1-.16.11-.1,0-.18-.04-.18-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M339.27,239.25c-.01-.06.06-.1.15-.11.1,0,.18.03.19.09.01.06-.06.1-.15.11-.1,0-.18-.03-.19-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M340.46,239.16c-.02-.05.05-.11.14-.11.09,0,.18.03.2.08.02.05-.05.11-.14.11-.09,0-.18-.03-.2-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M341.64,239.04c-.02-.05.04-.11.13-.12.09-.01.19.02.21.08.02.05-.04.11-.13.12-.09.01-.19-.02-.21-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M342.81,238.89c-.03-.05.03-.11.12-.12.09-.01.19.02.21.07.03.05-.03.11-.12.12-.09.01-.19-.02-.21-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M343.96,238.7c-.03-.05.02-.11.11-.13.09-.02.19.01.22.06.03.05-.02.11-.11.13-.09.02-.19-.01-.22-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M345.1,238.48c-.03-.05,0-.11.1-.13s.19,0,.22.06c.03.05,0,.11-.1.13-.09.02-.19,0-.22-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M346.21,238.22c-.04-.05,0-.11.09-.13.09-.02.19,0,.23.05.04.05,0,.11-.09.13-.09.02-.19,0-.23-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M347.3,237.93s-.01-.11.08-.13c.09-.03.19,0,.23.04.04.05.01.11-.08.13-.09.03-.19,0-.23-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M348.35,237.6s-.02-.11.06-.14c.08-.03.19-.01.24.04.05.05.02.11-.06.14-.08.03-.19.01-.24-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M349.38,237.24c-.05-.05-.03-.11.05-.14.08-.03.19-.02.24.03.05.05.03.11-.05.14-.08.03-.19.02-.24-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M350.37,236.86c-.06-.04-.04-.11.04-.14.08-.03.19-.02.24.02.06.04.04.11-.04.14-.08.03-.19.02-.24-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M351.33,236.44c-.06-.04-.05-.11.02-.14.07-.03.18-.03.24.02.06.04.05.11-.02.14-.07.03-.18.03-.24-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M352.25,236c-.06-.04-.06-.1.01-.14.07-.04.18-.03.25,0,.06.04.06.1-.01.14-.07.04-.18.03-.25,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M353.12,235.53c-.07-.04-.07-.1,0-.14.07-.04.18-.04.25,0,.07.04.07.1,0,.14-.07.04-.18.04-.25,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M353.95,235.03c-.07-.04-.08-.1-.01-.14s.17-.04.25,0c.07.04.08.1.01.14s-.17.04-.25,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M354.74,234.51c-.07-.04-.09-.1-.03-.14.06-.04.17-.05.24-.01.07.04.09.1.03.14-.06.04-.17.05-.24.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M355.47,233.96c-.08-.03-.1-.1-.04-.14.06-.04.16-.05.24-.02.08.03.1.1.04.14-.06.04-.16.05-.24.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M356.16,233.39c-.08-.03-.1-.09-.05-.14.05-.05.16-.06.24-.03.08.03.1.09.05.14-.05.05-.16.06-.24.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M356.79,232.81c-.08-.03-.11-.09-.06-.14.05-.05.15-.06.24-.04.08.03.11.09.06.14-.05.05-.15.06-.24.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M357.37,232.2c-.09-.03-.12-.09-.08-.14.04-.05.15-.07.23-.04.09.03.12.09.08.14-.04.05-.15.07-.23.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M357.89,231.58c-.09-.02-.13-.08-.09-.13.04-.05.14-.07.23-.05.09.02.13.08.09.13-.04.05-.14.07-.23.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M358.35,230.94c-.09-.02-.13-.08-.1-.13.03-.05.13-.08.22-.06.09.02.13.08.1.13-.03.05-.13.08-.22.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M358.76,230.29c-.09-.02-.14-.07-.11-.13.03-.05.13-.08.22-.06.09.02.14.07.11.13-.03.05-.13.08-.22.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M359.1,229.63c-.09-.01-.15-.07-.12-.12s.12-.09.21-.07c.09.01.15.07.12.12-.02.05-.12.09-.21.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M359.39,228.95c-.09-.01-.15-.07-.13-.12.02-.05.11-.09.21-.08.09.01.15.07.13.12-.02.05-.11.09-.21.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M359.61,228.27c-.09,0-.16-.06-.15-.12.01-.05.1-.09.2-.08.09,0,.16.06.15.12s-.1.09-.2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M359.78,227.59c-.1,0-.17-.06-.16-.11,0-.06.1-.09.19-.09.1,0,.17.06.16.11,0,.06-.1.09-.19.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M359.88,226.89c-.1,0-.17-.05-.17-.11,0-.06.09-.1.18-.09s.17.05.17.11c0,.06-.09.1-.18.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M359.91,226.2c-.1,0-.17-.05-.17-.1,0-.06.08-.1.17-.1.1,0,.17.05.17.1,0,.06-.08.1-.17.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M359.89,225.51c-.1,0-.18-.04-.18-.1,0-.06.07-.1.16-.11.1,0,.18.04.18.1,0,.06-.07.1-.16.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M359.8,224.82c-.1,0-.18-.03-.19-.09-.01-.06.06-.1.15-.11.1,0,.18.03.19.09.01.06-.06.1-.15.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M359.65,224.13c-.09,0-.18-.03-.2-.08-.02-.05.05-.11.14-.11.09,0,.18.03.2.08.02.05-.05.11-.14.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M359.43,223.45c-.09.01-.19-.02-.21-.08-.02-.05.04-.11.13-.12.09-.01.19.02.21.08s-.04.11-.13.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M359.16,222.77c-.09.01-.19-.02-.21-.07-.03-.05.03-.11.12-.12s.19.02.21.07c.03.05-.03.11-.12.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M358.82,222.1c-.09.02-.19-.01-.22-.06-.03-.05.02-.11.11-.13.09-.02.19.01.22.06.03.05-.02.11-.11.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M358.43,221.45c-.09.02-.19,0-.22-.06-.03-.05,0-.11.1-.13.09-.02.19,0,.22.06.03.05,0,.11-.1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M357.97,220.8c-.09.02-.19,0-.23-.05-.04-.05,0-.11.09-.13.09-.02.19,0,.23.05.04.05,0,.11-.09.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M357.46,220.17c-.09.03-.19,0-.23-.04-.04-.05-.01-.11.08-.13.09-.02.19,0,.23.04.04.05.01.11-.08.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M356.89,219.56c-.08.03-.19.01-.24-.04-.05-.05-.02-.11.06-.14.08-.03.19-.01.24.04.05.05.02.11-.06.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M356.27,218.97c-.08.03-.19.02-.24-.03-.05-.05-.03-.11.05-.14.08-.03.19-.02.24.03.05.05.03.11-.05.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M355.59,218.39c-.08.03-.19.02-.24-.02-.06-.04-.04-.11.04-.14.08-.03.19-.02.24.02.06.04.04.11-.04.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M354.86,217.84c-.07.03-.18.03-.24-.02-.06-.04-.05-.11.02-.14.07-.03.18-.03.24.02s.05.11-.02.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M354.09,217.3c-.07.04-.18.03-.25,0-.06-.04-.06-.1.01-.14.07-.04.18-.03.25,0,.06.04.06.1-.01.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M351.76,215.99c-.18.13-.52.15-.74.04-.23-.11-.26-.3-.08-.43.18-.13.52-.15.74-.04.23.11.26.3.08.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M322.89,215.55c.18.13.15.32-.08.43s-.56.08-.74-.05c-.18-.13-.15-.32.08-.43.23-.11.56-.08.74.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M321.07,216.45c.21.12.21.31,0,.43-.21.12-.54.12-.75,0-.21-.12-.21-.31,0-.43.21-.12.54-.12.75,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M319.43,217.46c.23.11.26.3.08.43-.18.13-.52.15-.74.04-.23-.11-.26-.3-.08-.43.18-.13.52-.15.74-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M318.86,234.13c.23-.11.56-.08.74.05.18.13.15.32-.08.43-.23.11-.56.08-.74-.05-.18-.13-.15-.32.08-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M320.43,235.18c.21-.12.54-.12.75,0,.21.12.21.31,0,.43s-.54.12-.75,0c-.21-.12-.21-.31,0-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M322.18,236.13c.18-.13.52-.15.74-.04.23.11.26.3.08.43-.18.13-.52.15-.74.04-.23-.11-.26-.3-.08-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M351.06,236.57c-.18-.13-.15-.32.08-.43.23-.11.56-.08.74.05.18.13.15.32-.08.43-.23.11-.56.08-.74-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M352.87,235.67c-.21-.12-.21-.31,0-.43s.54-.12.75,0c.21.12.21.31,0,.43-.21.12-.54.12-.75,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M354.51,234.66c-.23-.11-.26-.3-.08-.43.18-.13.52-.15.74-.04.23.11.26.3.08.43-.18.13-.52.15-.74.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M355.09,217.99c-.23.11-.56.08-.74-.05-.18-.13-.15-.32.08-.43.23-.11.56-.08.74.05.18.13.15.32-.08.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M359.91,226.41c-.29,0-.53-.14-.53-.31,0-.17.23-.3.53-.3.29,0,.53.14.53.31,0,.17-.23.3-.53.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M359.84,225.02c-.29.02-.55-.1-.58-.27-.03-.17.18-.32.47-.33.29-.02.55.1.58.27.03.17-.18.32-.47.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M339.82,212.93c-.03.17-.29.29-.58.27s-.5-.17-.47-.34c.03-.17.29-.29.58-.27.29.02.5.17.47.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M337.43,212.82c0,.17-.23.3-.53.3-.29,0-.53-.14-.53-.31,0-.17.23-.3.53-.3.29,0,.53.14.53.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M335.03,212.85c.03.17-.18.32-.47.33s-.55-.1-.58-.27c-.03-.17.18-.32.47-.33s.55.1.58.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M314.2,224.33c.29.02.5.17.47.34s-.29.29-.58.27c-.29-.02-.5-.17-.47-.34.03-.17.29-.29.58-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M314.03,225.71c.29,0,.53.14.53.31,0,.17-.23.3-.53.3s-.53-.14-.53-.31c0-.17.23-.3.53-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M314.11,227.1c.29-.02.55.1.58.27.03.17-.18.32-.47.33-.29.02-.55-.1-.58-.27-.03-.17.18-.32.47-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M334.12,239.19c.03-.17.29-.29.58-.27s.5.17.47.34c-.03.17-.29.29-.58.27s-.5-.17-.47-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M336.52,239.3c0-.17.23-.3.53-.3.29,0,.53.14.53.31,0,.17-.23.3-.53.3-.29,0-.53-.14-.53-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M338.92,239.27c-.03-.17.18-.32.47-.33.29-.02.55.1.58.27.03.17-.18.32-.47.33-.29.02-.55-.1-.58-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M359.74,227.79c-.29-.02-.5-.17-.47-.34.03-.17.29-.29.58-.27.29.02.5.17.47.34-.03.17-.29.29-.58.27Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-101"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-111"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-109"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-113"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "309.26 196.77 309.26 258.09 336.97 274.11 364.69 258.09 364.68 196.77 309.26 196.77"
  }))))), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M218.73,155.37l54.09-26.77c-6.53-12.4-14.92-23.69-25.18-33.39l-40.1,44.3c4.66,4.76,8.4,10.07,11.19,15.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M103.08,132.71c5.6-4.01,11.19-7.37,16.79-10.07l-21.45-56.05c-13.05,5.41-25.18,12.78-35.44,21.73l40.1,44.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M156.24,116.11c6.53.47,13.06,1.68,19.58,3.73l21.46-56.15c-13.06-4.48-26.12-7.18-41.04-7.74v60.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M75.1,181.4c.94-6.81,2.8-13.24,5.6-19.31l-54.1-26.77c-5.59,12.59-10.26,26.3-11.18,40.66l59.68,5.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M276.56,136.35l-53.16,26.86c1.87,5.97,3.73,12.31,4.66,18.93l60.62-5.6c-1.87-14.18-6.53-27.7-12.12-40.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M221.53,312.43l-31.71-51.11c-5.59,3.17-12.12,5.78-18.65,7.46l11.19,59.13c13.99-3.17,27.05-8.49,39.17-15.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M84.43,154.35c3.73-5.78,7.46-11.1,12.12-15.85l-40.1-44.39c-10.26,9.7-18.65,20.98-26.11,33.48l54.09,26.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M225.26,218.51c-1.87,6.16-4.66,11.94-8.4,17.35l47.56,36.19c8.4-11.19,13.99-23.6,18.65-36.93l-57.82-16.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M184.22,123.01c5.59,2.8,11.19,6.34,16.79,10.63l40.1-44.3c-10.26-9.23-22.38-16.88-35.44-22.48l-21.45,56.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M162.77,270.46c-3.73.56-7.46.84-11.19.84-2.8,0-6.53-.19-9.33-.56l-11.19,59.13c6.53,1.03,13.99,1.49,20.52,1.49,7.46,0,14.92-.56,22.39-1.77l-11.19-59.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M74.17,193.61v-3.64s-59.69-5.32-59.69-5.32c-.93,2.99-.93,5.97-.93,8.95,0,11.47,1.87,22.66,4.66,33.29l57.83-16.6c-1.87-5.32-1.87-10.91-1.87-16.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M211.27,242.86c-3.73,5.13-8.4,9.79-13.99,13.71l31.7,51.2c11.19-7.93,21.45-17.63,30.78-28.73l-48.49-36.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M228.99,193.61c0,5.69,0,11.19-1.87,16.51l57.83,16.6c2.8-10.54,4.66-21.64,4.66-33.11,0-2.8,0-5.6-.93-8.39l-59.69,5.6v2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M92.82,243.98l-48.5,36.37c9.33,11.01,19.58,20.52,31.71,28.35l31.7-51.11c-5.59-3.92-11.19-8.49-14.92-13.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M87.22,237.07c-3.73-5.6-6.52-11.75-9.33-18.37l-57.82,16.6c4.66,13.8,11.18,26.67,19.58,38.14l47.56-36.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M128.26,119.56c6.53-1.96,13.06-3.17,19.58-3.45v-60.16c-13.99.37-27.98,2.98-41.03,7.55l21.45,56.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M133.86,269.34c-6.52-1.59-13.05-4.1-18.65-7.27l-31.7,51.2c12.12,6.9,25.18,12.12,39.17,15.11l11.18-59.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M160.56,74.64s0,.06-.01.09l-1.71,4.71c-.04.12-.17.18-.29.13-.12-.04-.18-.17-.13-.29l1.71-4.71s.02-.04.03-.06c-.08-.09-.12-.21-.1-.34l.47-2.86c.12-.72.76-1.22,1.47-1.17.02,0,.05,0,.08,0l2.26.37s.05.01.07.02c.69.18,1.14.86,1.03,1.58l-.45,2.77c.07-.06.16-.1.26-.08.11.02.19.09.23.18h0s.29.76.39.91c.11.16.23.16.23.16l.99.16s.12.03.27-.08c.15-.1.64-.72.66-.74h0c.07-.07.17-.11.27-.1.09.02.17.07.21.15.02-.09.05-.15.05-.15l1.25-2.51s.42-.72,1.06-.61l2.07.34c.64.11.81.92.81.92l.38,2.78s.07.51-.37.56c-.43.05-.48-.44-.48-.44l-.29-2.32s0-.18-.14-.16c-.13.02-.11.21-.11.21l.46,4.33-1.06-.17-.49,2.96c-.05.28-.31.47-.59.42s-.47-.31-.43-.59l.49-2.96-.29-.05-.49,2.96c-.05.28-.31.47-.59.43s-.47-.31-.43-.59l.49-2.96-1.06-.17,1.82-3.95s.08-.17-.04-.23c-.12-.06-.18.11-.18.11l-1.02,2.1s-.2.45-.59.26c-.12-.06-.18-.14-.21-.23-.04.07-.1.16-.1.16l-.98,1.25s-.07.09-.08.19l-.05.28.17,1.67-.43-.07-.21,1.31c-.04.22-.25.37-.47.34s-.37-.24-.34-.47l.21-1.26s0-.02,0-.05l-.24-.04s0,.05,0,.05l-.21,1.26c-.04.22-.24.37-.47.34s-.37-.24-.34-.47h0s.21-1.31.21-1.31l-.43-.07.69-1.52.05-.29c.02-.09-.02-.2-.02-.2l-.58-1.62s0-.02,0-.04c-.09.12-.24.19-.4.17-.22-.04-.37-.25-.34-.47l.4-2.46c.02-.09.01-.22-.16-.25-.12-.02-.16.1-.18.18l-1.21,7.37c-.05.32-.35.53-.67.48s-.53-.35-.48-.67l.7-4.25s0-.17-.14-.2h0c-.15-.02-.18.1-.19.14l-.7,4.25c-.05.32-.35.53-.67.48s-.53-.35-.48-.67l1.21-7.37c0-.08,0-.21-.11-.23-.17-.03-.22.09-.23.18l-.4,2.46c-.03.16-.15.29-.3.33ZM185.2,72.49c.09-.57.63-.96,1.2-.86s.96.63.86,1.2-.63.96-1.2.86-.96-.63-.86-1.2ZM187.2,74.29c.69.18,1.14.86,1.02,1.58l-.47,2.86c-.04.22-.24.37-.47.33s-.37-.25-.34-.47l.4-2.46c.02-.09,0-.22-.16-.25-.12-.02-.16.1-.18.18l-1.21,7.37c-.05.32-.35.53-.67.48s-.53-.35-.48-.67l.7-4.25s.01-.17-.14-.2h0c-.15-.02-.18.09-.19.14l-.7,4.25c-.05.32-.35.53-.67.48s-.53-.35-.48-.67l1.21-7.37c0-.08,0-.21-.11-.23-.17-.03-.22.09-.23.18l-.4,2.46c-.04.22-.25.37-.47.33s-.37-.25-.33-.47l.47-2.86c.12-.72.76-1.22,1.48-1.17.02,0,.05,0,.08,0l2.26.37s.05.01.08.02ZM178.97,72.02c-.09.54-.6.91-1.14.82s-.91-.6-.82-1.14.6-.91,1.14-.82.9.6.82,1.14ZM175.66,73.76s.42-.72,1.06-.61l2.07.34c.64.11.81.92.81.92l.38,2.78s.07.51-.37.56c-.43.05-.48-.44-.48-.44l-.29-2.32s0-.18-.14-.16c-.13.02-.12.21-.12.21l.46,4.33-1.06-.17-.49,2.96c-.05.28-.31.47-.59.42s-.47-.31-.43-.59l.49-2.96-.29-.05-.49,2.96c-.05.28-.31.47-.59.43s-.47-.31-.43-.59l.49-2.96-1.06-.17,1.82-3.95s.08-.17-.04-.23c-.12-.06-.18.11-.18.11l-1.02,2.1s-.2.45-.59.26c-.39-.19-.17-.65-.17-.65l1.25-2.51ZM173.11,71.06c-.09.54-.6.91-1.14.82s-.91-.6-.82-1.14.6-.91,1.14-.82.91.6.82,1.14ZM181.36,78.03c-.45-.07-.75-.5-.68-.95s.5-.75.95-.68.75.5.68.95-.5.76-.95.68ZM178.99,80.24h0s.33-.56.42-.72c.67-1.13.83-1.32,1.26-1.27.43.06.63.1.63.1,0,0,.19.02.51.08.32.06.66.11.75.68.03.18.34,1.51.34,1.55h0c.05.1.04.21-.02.3-.09.15-.29.19-.43.1-.04-.03-.12-.48-.12-.48l-.19-1.02s-.04-.08-.06.02l-.54,3.32c-.04.23-.26.39-.49.35s-.39-.25-.35-.49l.21-1.31s.05-.18-.1-.21-.16.16-.16.16l-.21,1.31c-.04.23-.25.39-.49.35s-.39-.25-.35-.49h0s.54-3.32.54-3.32c.02-.1-.08-.02-.08-.02l-.67,1.34s-.16.2-.37.06c-.18-.12-.11-.32-.06-.4ZM164.47,69.09c-.09.57-.63.96-1.2.86s-.96-.63-.86-1.2.63-.96,1.2-.86.96.63.86,1.2ZM166.67,75.63c-.45-.07-.75-.5-.68-.95s.5-.75.95-.68.75.5.68.95-.5.76-.95.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M209.51,95.46c-2.53-2.76-3.41-6.6-2.17-9.92l.05-.1c.07-.12.22-.16.35-.09l17.14,10.05c.12.07.16.22.09.34,0,.01-.01.02-.02.03,0,0,0,.01-.01.02-2.25,2.7-5.96,3.82-9.57,3.04l-.3.52s0,0,0,0h0c-.07.12-.22.16-.34.09,0,0,0,0,0,0,0,0,0,0,0,0l-5.38-3.15s0,0,0,0,0,0,0,0c-.11-.07-.15-.21-.09-.33,0,0,0,0,0-.01,0,0,0,0,0,0l.27-.46ZM223.57,84.8c.28-.13.66,0,.84.28.18.28.1.61-.19.74-.04.02-2.48,1.17-2.01,3.35.33,1.54-.15,2.57-.83,3.22l-1.13-.66c.54-.39,1.07-1.13.78-2.49-.63-2.96,2.42-4.37,2.55-4.43ZM216.84,89.73c.54-.39,1.07-1.13.78-2.49-.63-2.96,2.42-4.38,2.55-4.43.28-.13.66,0,.84.28.18.28.1.61-.19.74-.04.02-2.48,1.17-2.01,3.35.33,1.54-.15,2.57-.83,3.22l-1.13-.66ZM216.75,80.8c.28-.13.66,0,.84.28.18.28.1.61-.19.74-.04.02-2.48,1.17-2.01,3.35.33,1.54-.15,2.57-.83,3.22l-1.13-.66c.54-.39,1.07-1.13.78-2.49-.63-2.96,2.42-4.38,2.55-4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M257.54,129.48c-.43.32-.94.44-1.42.38h0s-3.71-.52-3.71-.52l.53-3.71c.08-.48.33-.94.76-1.26.85-.64,1.98-.58,2.6.25.31.41.21,1.22.13,1.7.48.06,1.31.22,1.62.63.62.83.34,1.89-.51,2.53ZM244.09,125.48s-.01-.01-.02-.02c-.11-.17-.09-.39.05-.54l5.46-5.78-4.25.64c-.19.03-.37-.07-.45-.23-.08-.17-.05-.37.08-.5l4.32-4.32-3.79.87c-.17.04-.34-.03-.45-.16l-3.7-4.92c-.14-.19-.11-.46.09-.61s.46-.11.61.09l3.53,4.69,4.99-1.14c.19-.04.38.04.48.21.09.17.06.38-.07.52l-4.45,4.46,4.19-.63c.18-.03.36.06.45.23.09.16.06.37-.07.5l-5.06,5.36,14.79-5.43c.17-.06.36-.01.48.12.12.14.14.33.06.49l-2.53,4.89c-.11.21-.37.3-.59.19-.21-.11-.3-.37-.19-.59l2.01-3.89-15.48,5.68c-.18.07-.38,0-.5-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M241.65,288.36c-1.98,2.33-5.48,2.61-7.81.63-2.33-1.98-2.61-5.48-.63-7.81s5.48-2.61,7.81-.63,2.61,5.48.63,7.81ZM240.25,286.63l-1.45-1.23c-.14-.12-.41-.11-.56.06s-.11.44.03.56l1.45,1.23c.14.12.41.11.56-.06s.11-.45-.03-.57ZM235.27,282.93c-1.03,1.21-.89,3.03.33,4.06.99.84,2.37.9,3.41.24l-.82-.69c-.63.27-1.39.17-1.95-.3-.79-.68-.89-1.87-.21-2.66s1.87-.89,2.66-.21c.56.48.77,1.21.61,1.87l.82.7c.48-1.13.2-2.49-.78-3.33-1.21-1.03-3.03-.89-4.06.33ZM241.59,279.96c-.19-.16-.2-.47-.07-.62l1.57-1.85c.13-.16.43-.19.63-.03s.2.47.07.62l-1.57,1.85c-.13.15-.43.19-.62.03ZM231.22,292.14c-.19-.16-.2-.47-.07-.62l1.57-1.85c.13-.16.43-.19.63-.03s.2.47.07.62l-1.57,1.85c-.13.15-.43.19-.62.03ZM230.13,278.55c.16-.19.47-.2.62-.07l1.85,1.57c.16.13.19.43.03.63s-.47.2-.62.07l-1.85-1.57c-.15-.13-.19-.43-.03-.62ZM228.4,288.07c-.09-.24.05-.5.25-.57l2.28-.82c.19-.07.47.05.56.28.09.24-.06.5-.25.57l-2.28.82c-.19.07-.47-.05-.55-.28ZM234.2,275.73c.24-.09.51.05.57.25l.82,2.28c.07.19-.05.47-.28.56-.24.09-.5-.06-.57-.25l-.82-2.28c-.07-.19.05-.47.28-.55ZM227.99,283.04c.05-.25.3-.41.5-.37l2.38.44c.2.04.39.28.34.53-.05.25-.3.41-.5.37l-2.39-.44c-.2-.04-.38-.28-.34-.52ZM239.23,275.32c.25.05.41.3.37.5l-.44,2.38c-.04.2-.28.38-.53.34-.25-.05-.41-.3-.37-.5l.44-2.38c.04-.2.28-.38.52-.34ZM242.31,288.92c.16-.19.47-.2.62-.07l1.85,1.57c.16.13.19.43.03.63s-.47.2-.62.07l-1.85-1.57c-.15-.13-.19-.43-.03-.62ZM243.45,282.65c-.09-.24.05-.5.25-.57l2.28-.82c.19-.07.47.05.56.28.08.24-.06.5-.25.57l-2.28.82c-.19.07-.47-.05-.55-.28ZM239.62,290.78c.24-.09.5.05.57.25l.82,2.28c.07.19-.05.47-.28.56-.24.08-.5-.06-.57-.25l-.82-2.28c-.07-.19.05-.47.28-.55ZM243.72,285.96c.05-.25.3-.41.5-.37l2.38.44c.2.04.39.28.34.53-.05.25-.3.41-.5.37l-2.39-.44c-.2-.04-.38-.28-.34-.52ZM236.31,291.05c.25.05.41.3.37.5l-.44,2.38c-.04.2-.28.38-.53.34-.25-.05-.41-.3-.37-.51l.44-2.38c.04-.2.28-.38.52-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M194.3,315.13c-.13.33-.3.17-.35.06l-5.95-13.06c-.05-.11,0-.24.11-.29l3.61-1.64c.11-.05.24,0,.29.11l4.24,9.32c.12.27.1.4.03.59l-1.98,4.92ZM202.4,306.21c-.12.33-.3.17-.35.06l-3.97-8.73c-.05-.11,0-.24.11-.29l3.61-1.64c.11-.05.24,0,.29.11l2.27,4.99c.12.27.1.4.03.59l-1.98,4.92ZM194.54,319.88v-.03s-.67-3-.67-3h0s-.01-.06,0-.09c.02-.06.09-.09.14-.06l.93.35,3.75-10.02s.07-.07.11-.05l1.11.41s0,0,.01,0l2.96,1.11,2.42-6.45s.07-.07.11-.05l1.11.41s.07.07.05.11l-2.45,6.54s0,0,0,0l-.41,1.11s-.07.07-.11.05l-4.08-1.53-3.31,8.83.89.33.04.02c.06.02.09.09.07.14,0,.02-.02.04-.04.05l-.05.03-2.4,1.82h-.03s-.02.02-.02.02c-.02,0-.05.01-.08,0-.03-.01-.05-.04-.06-.06ZM197.08,307.93c-.14.36-.31.2-.36.09l-3.72-8.17c-.05-.11,0-.24.11-.29l3.61-1.64c.11-.05.24,0,.29.11l3.66,8.03c.05.11.09.36-.32.21l-2.24-.86s-.09,0-.11.05l-.92,2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M80.4,290.59c.06.05.06.14,0,.2-.02.02-.04.03-.07.04h-.07s-4.49.76-4.49.76h-.04s-.03,0-.03,0c-.03,0-.07-.01-.09-.04-.03-.03-.04-.07-.04-.1v-.04s.44-4.6.44-4.6h0s.01-.08.04-.1c.05-.06.14-.06.2,0l4.15,3.89ZM76.62,286.33c-.06-.05-.06-.14,0-.2l3.05-3.25c.05-.06.14-.06.2,0l1.37,1.29-1.92,2.05c-.05.06-.05.14,0,.2l1.24,1.16c.06.05.14.05.2,0l1.92-2.05,1.34,1.25c.06.05.06.14,0,.2l-3.05,3.25c-.05.06-.14.06-.2,0l-4.15-3.9ZM61.46,273.71c-.06-.05-.06-.14,0-.19l3.9-4.15c.05-.05.14-.06.19,0l4.11,3.86c.06.05.06.14,0,.19l-3.9,4.15c-.05.05-.14.06-.19,0l-4.11-3.86ZM63.08,272.73l-.7.75c-.05.05-.05.14,0,.19l1.23,1.15c.06.05.14.05.19,0l.7-.75c.05-.05.05-.14,0-.19l-1.23-1.15c-.06-.05-.14-.05-.19,0ZM64.96,274.49l-.7.75c-.05.05-.05.14,0,.19l1.23,1.15c.06.05.14.05.19,0l.7-.75c.05-.05.05-.14,0-.19l-1.23-1.15c-.06-.05-.14-.05-.19,0ZM64.38,271.35l-.7.75c-.05.05-.05.14,0,.19l1.23,1.15c.06.05.14.05.19,0l.7-.75c.05-.05.05-.14,0-.19l-1.23-1.15c-.06-.05-.14-.05-.19,0ZM66.25,273.11l-.7.75c-.05.05-.05.14,0,.19l1.23,1.15c.06.05.14.05.19,0l.7-.75c.05-.05.05-.14,0-.19l-1.23-1.15c-.06-.05-.14-.05-.19,0ZM61.98,292.32c-.05-.05-.06-.14,0-.19l12.9-13.75c.05-.05.14-.06.19,0l4.02,3.78c.05.05.06.14,0,.19l-12.9,13.75c-.05.05-.14.06-.19,0l-4.02-3.78ZM71.56,286.9l-.96,1.03s-.03.08,0,.1l.92.86s.08.03.1,0l.96-1.03s.03-.07,0-.1l-.92-.86s-.08-.03-.1,0ZM65.33,289.92l-.96,1.03s-.03.08,0,.1l.92.86s.07.03.1,0l.96-1.03s.03-.07,0-.1l-.92-.86s-.08-.03-.1,0ZM75.99,282.18l-.96,1.03s-.03.07,0,.1l.92.86s.07.03.1,0l.96-1.03s.03-.08,0-.1l-.92-.86s-.08-.03-.1,0ZM69.76,285.2l-.96,1.03s-.03.08,0,.1l.92.86s.08.03.1,0l.96-1.03s.03-.07,0-.1l-.92-.86s-.08-.03-.1,0ZM67.54,287.56l-.96,1.03s-.03.07,0,.1l.92.86s.07.03.1,0l.96-1.03s.03-.07,0-.1l-.92-.86s-.08-.03-.1,0ZM73.77,284.54l-.96,1.03s-.03.08,0,.1l.92.86s.07.03.1,0l.96-1.03s.03-.08,0-.1l-.92-.86s-.07-.03-.1,0ZM71.97,282.85l-.96,1.03s-.03.08,0,.1l.92.86s.07.03.1,0l.96-1.03s.03-.07,0-.1l-.92-.86s-.07-.03-.1,0ZM67.14,291.61l-.96,1.03s-.03.08,0,.1l.92.86s.07.03.1,0l.96-1.03s.03-.07,0-.1l-.92-.86s-.08-.03-.1,0ZM74.18,280.49l-.96,1.03s-.03.07,0,.1l.92.86s.07.03.1,0l.96-1.03s.03-.07,0-.1l-.92-.86s-.08-.03-.1,0ZM69.35,289.26l-.96,1.03s-.03.07,0,.1l.92.86s.07.03.1,0l.96-1.03s.03-.08,0-.1l-.92-.86s-.07-.03-.1,0ZM60.97,274.04s.11-.05.16,0l4.14,3.88s.05.11,0,.16l-.78.83s-.11.05-.16,0l-4.14-3.88s-.05-.11,0-.16l.78-.83ZM59.55,285.16s.02-.04.03-.05l10.54-11.23c.05-.05.14-.06.19,0l4.02,3.77c.05.05.06.14,0,.19l-5.78,6.16s-.07.04-.11.05h-.04s-8.66,1.31-8.66,1.31h-.07s0,0-.01,0c-.03,0-.05-.01-.08-.04-.05-.05-.06-.12-.03-.17ZM67.86,277.23l-.7.75c-.05.05-.05.14,0,.19l1.2,1.12c.05.05.14.05.19,0l.7-.75c.05-.05.05-.14,0-.19l-1.2-1.12c-.05-.05-.14-.05-.19,0ZM66.55,278.61l-.7.75c-.05.05-.05.14,0,.19l1.2,1.12c.05.05.14.05.19,0l.7-.75c.05-.05.05-.14,0-.19l-1.2-1.12c-.05-.05-.14-.05-.19,0ZM67.08,281.72l-1.59,1.7c-.04.06-.03.14.02.19.04.03.08.05.13.04h.06c.62-.09,2.12-.29,2.47-.37,0,0,.02,0,.03,0,0,0,.01,0,.02,0,0,0,.01,0,.02,0,.02,0,.03-.02.04-.03l.2-.21c.05-.05.05-.14,0-.19l-1.2-1.12c-.05-.05-.14-.05-.19,0ZM63.95,281.39l-.7.75c-.05.06-.05.14,0,.19l1.2,1.12c.05.05.14.05.19,0l.7-.75c.05-.05.05-.14,0-.19l-1.2-1.12c-.05-.05-.14-.05-.19,0ZM70.99,277.56l-.7.75c-.05.05-.05.14,0,.19l1.2,1.13c.05.05.14.05.19,0l.7-.75c.05-.05.05-.14,0-.19l-1.2-1.13c-.05-.05-.14-.05-.19,0ZM68.39,280.33l-.7.75c-.05.05-.05.14,0,.19l1.2,1.13c.05.05.14.05.19,0l.7-.75c.05-.05.05-.14,0-.19l-1.2-1.13c-.05-.05-.14-.05-.19,0ZM63.77,284s.06-.02.09-.05c.06-.06.05-.16,0-.22,0,0,0,0,0,0s0,0,0,0l-.99-.93s0,0,0,0,0,0,0,0c-.06-.05-.16-.05-.22.01l-1.19,1.27c-.04.06-.03.14.02.19.04.03.08.05.13.04h.06c.48-.07,1.46-.21,2.06-.3h.06ZM69.69,278.95l-.7.75c-.05.05-.05.14,0,.19l1.2,1.13c.05.05.14.05.19,0l.7-.75c.05-.05.05-.14,0-.19l-1.2-1.13c-.05-.05-.14-.05-.19,0ZM65.25,280l-.7.75c-.05.05-.05.14,0,.19l1.2,1.12c.05.05.14.05.19,0l.7-.75c.05-.05.05-.14,0-.19l-1.2-1.12c-.05-.05-.14-.05-.19,0ZM69.16,275.84l-.7.75c-.05.05-.05.14,0,.19l1.2,1.12c.05.05.14.05.19,0l.7-.75c.05-.05.05-.14,0-.19l-1.2-1.12c-.05-.05-.14-.05-.19,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M27.86,190.45c.05-.05.1-.1.14-.13.05.02.11.05.17.08,1.54.75,7.8,4.25,9.2,12.51,1.4,8.26-3.34,13.63-4.55,14.85-.05.05-.1.1-.14.13-.05-.02-.11-.05-.17-.08-1.54-.75-7.8-4.25-9.2-12.51-1.4-8.25,3.34-13.63,4.55-14.84ZM36.12,203.11c-.22-1.31-.87-2.44-1.77-3.29-.03.14-.09.15-.04.55.08.58.66.89.8,1.07.15.18-.34,1.52-.09,2.44.11.41.38.91.88,1.01.13.03.22-.03.27-.12.06-.54.05-1.09-.04-1.66ZM33.75,199.34c-.67-.48-1.43-.81-2.25-.97-.15.03-.29.1-.36.15-.04.03-.08.06-.12.09-.23.17.21.24.5.91.1.22.19.53.45,1,.19.34.85.68,1.33.39.48-.29.85-.22.47-.63-.38-.41.03-.14.06-.31.03-.16-.22-.08-.11-.42.02-.07.03-.13.04-.19ZM32.5,204.53c-.67-.28-.61.22-.16.38.08.03,1.13.06,1.22-.1.09-.16-.92-.22-1.06-.27ZM30.54,199.83c.01-.07-.01-.3-.11-.29s-.24.2-.28.33c-.04.13.06.23.2.16.13-.07.18-.14.2-.2ZM30.96,202.37c-.12-.1-.34.24-.29.43.02.09.25.29.34.13.09-.16.08-.46-.04-.56ZM34.02,205.34c-.46-.04-.22-.21-.53-.22-.31,0-.34-.1-.7-.02-.35.08-.45.04-.75-.17-.3-.22-.15-.17-.41-.2-.25-.03-.27.24-.38.5-.13.3-.54.66-.86.69-.22.02-.04-.13.19-.45.23-.32.43-.47.32-.73-.11-.26-.42-.59-.68-.45-.18.1-.75,1.14-.9,1.12-.17-.02-.07-.2.1-.51.17-.32.08-.64.45-.78.69-.25.24-1.01.79-1.68.21-.26-.07-.32-.4-.41-.32-.1-.42.19-.59,0-.18-.18-.16-.43.07-.57.22-.13.51-.32.81-.49.28-.16.63-.93.63-1.02-.04-.39-.55.23-.76.31-.21.08-.65-.02-.74-.18-.09-.16-.04-.24-.34-.56-.3-.33-.28.06-.68.14-.4.08-.21-.21-.13-.28.29-.29.05-.65-.17-.66-.05,0-.15,0-.27.02-2.42,1.04-3.92,3.63-3.46,6.34.19,1.14.71,2.15,1.43,2.94-.16-.66-.62-1.96,0-1.91.54.04.46-.95.8-.5.15.19.68.73.63.88-.14.42-.6-.7-.71-.45-.11.25.14.67.27,1,.07.16.18.84.34,1.06.16.22.37.49.56.37.2-.12.25-.81.23-.92-.02-.11-.07-.23-.4-.42-.33-.19-.11-.52-.06-.44.05.08.22.24.42.36.16.09.29.3.21.55-.08.26.08.78.15.87.08.09.3.32.33.39.03.07.11.18.18.12.07-.05.16-.09.23-.04.07.05.21.13.14.3-.07.15.04.54.18.63.05,0,.1.01.15.02.2-.03.52-.17.22-.47-.1-.1-.18-.65-.56-.94-.18-.13-.01-.35.06-.4.07-.05.53-.37.49-.48-.04-.11-.44.27-.49.14-.04-.13.33-.37.26-.45-.19-.19-.17-.38.06-.45.18-.05.33.1.46.31.18.28-.02.86-.09,1.21-.08.43-.07.98-.07.98l.17.32s.08-.02.49.22c.02.01.04.02.06.03.19-.01.38-.04.58-.07.79-.13,1.52-.42,2.16-.83,0,0,0-.01,0-.02.05-.33,0-.23-.13-.44-.14-.21-.39-.37-.22-.56.17-.2.08-.34.4-.41.32-.08-.26-.29.2-.43.73-.22.33-.33.46-.35.36-.06,1.05-.22,1.03-.48-.03-.26-.27-.65-.43-.73-.16-.09-.34-.19-.8-.23ZM30.67,199.56c.02.09.25.29.34.13.09-.16.08-.46-.04-.56-.12-.1-.34.24-.29.43ZM30.58,198.25c-.39-.01-.79.01-1.19.08-.11.02-.22.04-.33.07-.24.12-.39.29-.32.57.02.07.26-.24.37-.17.67.41,1.46-.39,1.47-.55ZM28.2,209.5c.3.12.61.21.93.28.01-.04.01-.09,0-.15-.07-.18-.5-.42-.71-.59-.08-.06-.32-.41-.41-.37-.09.04-.13.24-.08.38.05.14.11.34.24.43,0,0,.02.01.04.02ZM27.57,209.31s.14-.05.14-.19c0-.18-.23-.46-.38-.56-.05-.04-.32-.04-.38-.01-.06.03-.09.15-.06.24.03.09.07.21.16.26.04.02.4.22.52.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M139.03,69.06c-.45-2.62-2.89-4.4-5.5-4.05-.99-1.77-3.02-2.82-5.13-2.45s-3.68,2.02-4.02,4.02c-2.58.54-4.29,3.03-3.84,5.65.27,1.55,1.24,2.81,2.53,3.51-.05.45-.04.91.04,1.38.46,2.67,3.01,4.48,5.68,4.02,1.02-.17,1.9-.65,2.59-1.32.86.38,1.84.53,2.83.36,2.68-.46,4.48-3.01,4.02-5.68-.08-.46-.22-.89-.41-1.29.98-1.08,1.48-2.59,1.21-4.14M133.1,66.75c.33,1.94-.83,3.8-2.65,4.39-.06-.19-.12-.38-.15-.59-.33-1.94.83-3.8,2.65-4.39.06.19.12.38.15.59M131.15,78.55c-.85-.58-1.47-1.49-1.65-2.57s.09-2.12.67-2.94c.85.58,1.47,1.49,1.65,2.58s-.09,2.12-.67,2.94M125.3,67.47c1.91-.04,3.63,1.32,3.96,3.26.03.2.05.4.05.6-1.91.04-3.63-1.32-3.96-3.26-.03-.2-.05-.4-.05-.6M129.14,72.53c-.42,1.38-1.58,2.47-3.09,2.73-.64.11-1.27.05-1.85-.13.42-1.38,1.58-2.47,3.1-2.73.64-.11,1.27-.05,1.85.13M130.99,72.19c.49-.37,1.07-.64,1.72-.75,1.52-.26,2.99.4,3.84,1.57-.49.37-1.07.64-1.72.75-1.52.26-2.99-.4-3.84-1.57M128.56,63.53c1.59-.27,3.12.46,3.95,1.72-1.53.55-2.67,1.81-3.09,3.33-.9-1.3-2.39-2.11-4.02-2.12.36-1.47,1.57-2.67,3.15-2.94M121.51,72.06c-.34-2,.89-3.9,2.8-4.44,0,.21.03.42.07.63.24,1.42,1.07,2.59,2.2,3.31-1.58.46-2.78,1.67-3.29,3.16-.91-.58-1.58-1.51-1.78-2.65M124.07,76.94c-.05-.28-.06-.55-.05-.82.69.2,1.44.25,2.19.12.85-.15,1.61-.5,2.24-1.01,0,.3.02.6.07.91.22,1.31.95,2.41,1.95,3.14-.52.43-1.15.74-1.86.87-2.14.37-4.17-1.08-4.54-3.21M137.25,74.65c.37,2.14-1.08,4.17-3.21,4.54-.7.12-1.38.04-2-.18.68-1.01.98-2.27.76-3.56-.05-.32-.14-.62-.25-.91.76.27,1.6.35,2.45.21.76-.13,1.45-.43,2.03-.85.09.24.17.5.21.76M133.13,70.4c.8-1.05,1.19-2.42.95-3.82-.04-.21-.09-.41-.15-.61,1.98-.12,3.78,1.26,4.12,3.26.19,1.13-.12,2.24-.78,3.08-.96-1.24-2.5-1.99-4.14-1.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M142.13,315.18l4.49,2.59v5.19c0,.11.06.21.15.27l4.65,2.68c.09.05.21.05.31,0l4.65-2.68c.09-.06.15-.16.15-.27v-5.19s4.49-2.59,4.49-2.59c.09-.05.15-.16.15-.27v-5.36c0-.11-.06-.21-.15-.27l-4.65-2.68s-.1-.04-.15-.04-.11.01-.15.04l-4.49,2.59-4.49-2.59s-.1-.04-.15-.04-.11.01-.15.04l-4.65,2.68c-.09.05-.15.16-.15.27v5.36c0,.11.06.21.15.27M151.89,310.08l3.73,2.15-3.73,2.15v-4.3ZM147.55,317.6l3.73-2.15v4.3s-3.73-2.15-3.73-2.15ZM151.89,315.45l3.73,2.15-3.73,2.15v-4.3ZM150.97,314.92l-4.03,2.33-4.03-2.33,4.03-2.33,4.03,2.33ZM147.24,318.13l3.73,2.15-3.73,2.15v-4.3ZM152.19,320.28l3.73-2.15v4.3s-3.73-2.15-3.73-2.15ZM156.53,307.4l4.03,2.33v4.66s-4.03-2.33-4.03-2.33v-4.66ZM155.92,307.4v4.3s-3.73-2.15-3.73-2.15l3.73-2.15ZM142.59,309.73l4.03-2.33v4.66s-4.03,2.33-4.03,2.33v-4.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M273.79,155.82l-10.14,3.7-.41-7.07,11.89-4.35-1.35,7.71ZM274.02,156.53l6.04,5.06-11.89,4.34-4.27-5.7,10.12-3.7ZM270.21,170.86l-2.91.21,2.36-1.72h0s10.58-3.87,10.58-3.87l.55,1.51-10.58,3.87ZM280.06,163.14l-12.19,4.46-.41-.56-4.85-6.27-.29-.78-.68-8.47,12.5-4.57.79.49-12.56,4.59.61,7.76.26.72,4.87,6.24,12.24-4.47-.29.88ZM282.19,166.48l-.81.3-.55-1.51.81-.3c.42-.15.88.06,1.03.48s-.06.88-.48,1.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M282.57,212.68s-.03.06-.07.05l-4.67-.52s-.06-.03-.05-.07l.17-1.55s.03-.06.07-.05l1.74.2-1.81-2.26c-1.07.59-2.33.87-3.64.72-3.03-.34-5.31-2.85-5.46-5.8l-1.82-.2-.21,1.84s-.03.06-.07.05l-1.66-.19s-.06-.03-.05-.07l.21-1.84-1.76-.2s-.06-.03-.05-.07l.19-1.66s.03-.06.07-.05l1.76.2.21-1.84s.03-.06.07-.05l1.66.19s.06.03.05.07l-.21,1.84,1.79.2c.73-2.96,3.56-4.99,6.66-4.64,3.37.38,5.81,3.43,5.43,6.8-.16,1.42-.8,2.67-1.73,3.62l1.83,2.3.21-1.86s.03-.06.07-.05l1.55.17s.06.03.05.07l-.52,4.67ZM270.5,202.57c-.28,2.48,1.51,4.73,3.99,5.01s4.73-1.51,5.01-3.99-1.51-4.73-3.99-5.01c-2.48-.28-4.73,1.51-5.01,3.99ZM274.17,205.77s-.03.06-.06.05l-1.32-.15s-.05-.03-.05-.07l.61-5.46s.03-.06.06-.05l1.32.15s.05.03.05.07l-.61,5.46ZM276.53,206.04s-.03.06-.06.05l-1.32-.15s-.05-.03-.05-.07l.61-5.46s.03-.06.06-.05l1.32.15s.05.03.05.07l-.61,5.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M268.01,257.53s.08-.04.1-.09l5.97-12.34s.02-.09,0-.13c-.02-.04-.06-.07-.1-.09l-13.55-3.99c-.08-.02-.16.01-.19.08l-1.23,2.55-2.13-.81.52-1.07-3.7,1.29,1.29,3.71.52-1.07,1.96,1.16-1.25,2.59c-.03.07-.01.16.05.2l11.6,8s.09.03.13.02M260.28,247.9s-.31-.84.2-1.72c.38-.94,1.23-1.23,1.23-1.23,1.37-.48,2.36.41,2.8,1.02.28.38,1.72,2.83,1.85,3.04h.01s0,0,0,0h0s-.01,0-.01,0c-.24.03-3.06.42-3.53.44-.75.04-2.06-.19-2.54-1.56M265.79,255.4c.31-.26.46-.71.49-1.2.12-1.83.4-2.98,1.68-4.35.81-.86,1.93-1.49,2.07-2.81.09-.87.17-1.69.59-2.53l2.73.72-5.59,11.55-1.97-1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M110.79,310.67s.06.06.05.1l-.55,2.01s-.05.07-.1.06l-6.68-1.84s-.06-.06-.05-.1l.55-2.01s.05-.07.09-.06l6.68,1.84ZM111.97,306.4s.06.06.05.1l-.55,2.01s-.05.07-.1.06l-6.68-1.84s-.06-.06-.05-.1l.55-2.01s.05-.07.09-.06l6.68,1.84ZM112.71,303.34s-.02.1-.07.08l-6.41-1.76s-.06-.08-.01-.11l4.09-2.33s.06,0,.08.02l2.33,4.09ZM113.11,313.67s-.1-.02-.08-.07l1.76-6.41s.08-.06.11-.01l2.33,4.09s0,.06-.02.08l-4.09,2.33ZM102.78,314.07s.02-.1.07-.08l6.41,1.76s.06.08.01.11l-4.09,2.33s-.06,0-.08-.02l-2.33-4.09ZM102.38,303.74s.1.02.08.07l-1.76,6.41s-.08.06-.11.01l-2.33-4.09s0-.06.02-.08l4.09-2.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M33.23,240.46c-.45,2.08.5,4.08,1.03,4.72l.06.07c.61.74,1.59,1.92,4.29,2.53.01,0,.03,0,.05.01h.03s.06.01.09,0c.02-.01.04-.03.06-.05l.04-.07c.23-.36.53-.81.82-1.21,0,0,0,0,0-.01.03-.04.04-.1.01-.15-.02-.04-.05-.06-.08-.07-.02,0-.04,0-.05,0-2.6-.45-3.39-1.41-3.93-2.06l-.06-.08c-.28-.34-.99-1.8-.67-3.25.25-1.14,1.07-2.06,2.46-2.73,2.32-1.14,3.78-.45,4.6.32,1.27,1.2,1.22,2.97,1.22,2.98v.08c.04.98-.1,2.54-1.82,4.79-3.47,4.53-2.97,6.65-2.64,8.06l.02.08c.15.64,1.04,2.69,3.06,3.64,1.06.5,2.81.86,5.16-.29,1.43-.7,2.23-1.46,2.86-2.7.15-.28,1.49-3.03-.74-6-.36-.47-.95-1.06-1.92-1.56l.3-1.04c.02-.07-.02-.14-.09-.16-.03-.01-.06,0-.09,0h0s-3.45,1.05-3.45,1.05l-.04.02s-.06.04-.07.08c-.01.03,0,.06,0,.09v.02s.03.03.03.03l2.35,2.64.04.05s.04.03.06.04c.07.02.14-.02.16-.09l.02-.05.28-.99c.5.3.82.62,1.03.89,1.61,2.15.63,4.07.59,4.15v.03c-.47.9-.99,1.39-2.09,1.93-1.39.68-2.62.77-3.66.28-1.32-.62-2.01-2.03-2.12-2.48l-.02-.08c-.27-1.15-.65-2.73,2.33-6.61,1.54-2.01,2.25-3.94,2.17-5.89,0-.25-.01-1.45-.63-2.71-.26-.53-.62-1.07-1.13-1.55-.8-.76-3.04-2.34-6.55-.62-2.35,1.15-3.14,2.77-3.39,3.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M41.11,149.98s.04-.01.05-.02c.01,0,.03,0,.05,0,.02,0,.03.02.04.03,0,.01.02.03.03.05.44.67,3.06,4.9,1.57,8.95-1.29,3.51-5.85,6.1-5.85,6.1,0,0,2.38,2.48,1.59,5.47,0,.01,0,.02,0,.03v.03c-.04.06-.1.09-.16.06-.02,0-.04-.02-.05-.04l-.03-.04c-.48-.59-1.89-2.2-3.65-2.84s-3.86-.34-4.62-.19c0,0-.07.02-.12,0-.05-.01-.09-.09-.07-.15v-.02s.02-.04.03-.05c1.34-2.79,4.74-3.14,4.74-3.14,0,0-1.81-4.93-.52-8.44,1.48-4.04,6.22-5.58,6.99-5.8ZM39.78,155.31c.24-.65-.1-1.38-.75-1.61s-1.37.1-1.61.75.09,1.37.75,1.61,1.38-.1,1.61-.75ZM28.07,162.11c.26.58,1.18,3.01-1.24,4.34-.03.01-.06.02-.09,0l-.81-.3c-.06-.02-.1-.09-.07-.16,0,0,0-.01.01-.02.02-.01.03-.03.05-.05.52-.49,1.92-2.09.94-4.37,0-.02-.02-.05-.03-.07,0-.02,0-.04,0-.05,0-.01.01-.02.02-.03.02-.02.04-.04.06-.04.57-.36,2.98-2.1,1.82-4.87l-.02-.04s-.01-.06,0-.09c.01-.03.03-.06.06-.07l.04-.02c2.68-1.35,1.96-4.24,1.76-4.89-.02-.02-.02-.05-.02-.07,0-.01,0-.03,0-.04,0-.02.02-.03.03-.05.02-.01.04-.02.06-.03,2.22-1.1,2.19-3.23,2.11-3.94,0-.03,0-.05,0-.07,0,0,0-.02,0-.03.02-.06.09-.1.16-.07l.81.3s.06.04.07.06c.98,2.58-1.29,3.84-1.86,4.11-.02,0-.03.01-.04.02-.02.01-.04.03-.04.06-.01.03,0,.06,0,.09,0,0,0,0,0,0,1.29,2.98-1.26,4.66-1.83,5l-.06.03s-.02.03-.02.04c0,.02,0,.03,0,.05l.03.06c.22.63,1.08,3.57-1.83,5,0,0,0,0,0,0-.03.01-.05.04-.06.07,0,.02,0,.05,0,.07,0,.02.01.03.02.04ZM22.94,164.91s.03-.03.05-.05c.52-.49,1.92-2.09.94-4.37,0-.02-.02-.05-.03-.07,0-.02,0-.04,0-.05,0-.01.01-.02.02-.03.02-.02.04-.03.07-.04.57-.36,2.98-2.1,1.82-4.87l-.02-.04s-.02-.06,0-.09c.01-.03.04-.06.07-.07l.04-.02c2.68-1.35,1.96-4.24,1.76-4.89-.01-.02-.02-.05-.02-.08,0-.01,0-.03,0-.04,0-.02.02-.03.03-.05.02-.01.04-.02.06-.03,2.22-1.1,2.19-3.23,2.11-3.94,0-.03,0-.05,0-.07,0,0,0-.02,0-.03.02-.06.09-.1.16-.07l.8.3s.06.04.07.06c.98,2.58-1.29,3.84-1.86,4.11-.02,0-.03.01-.04.02-.02.01-.04.03-.04.06-.01.03,0,.06,0,.09,0,0,0,0,0,0,1.3,2.98-1.26,4.66-1.83,5l-.06.03s-.02.03-.03.04,0,.03,0,.05l.03.06c.22.63,1.08,3.57-1.83,5,0,0,0,0,0,0-.03.01-.05.04-.06.07,0,.02,0,.05,0,.07,0,.02.01.03.02.04.26.58,1.17,3.01-1.24,4.34-.03.01-.06.02-.1,0l-.8-.3c-.07-.02-.1-.1-.07-.16,0,0,0-.01.01-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M52.74,122.12s.08-.04.12-.01l2.14,1.73s.04.08.01.12l-.7.87s-.08.04-.12.01l-2.14-1.73s-.04-.08-.01-.12l.7-.87ZM63.6,115.17s.08-.04.12-.01l.87.7s.04.08.01.12l-11.51,14.3s-.08.04-.12.01l-.87-.7s-.04-.08-.01-.12l11.51-14.3ZM65.34,116.56s.08-.04.12-.01l.88.71s.04.08.01.12l-11.51,14.3s-.08.04-.12.01l-.88-.71s-.04-.08-.01-.12l11.51-14.3ZM55.85,113.41c0-.3.06-1.03.53-1.61.34-.42.82-.68,1.44-.76.04,0,.09,0,.12.03l.07.06c.06.04.07.12.05.18-.02.04-.06.07-.07.08-.04.02-.08.04-.11.04-.11.03-.34.18-.58.48s-.64.96-.57,1.97v.02c.01.05,0,.12-.04.16-.04.05-.09.08-.15.08h-.02c-1,.15-1.56.68-1.8.98s-.33.55-.34.67c0,.04,0,.07-.01.11,0,.01,0,.02-.01.03-.02.04-.06.07-.1.08-.05,0-.09,0-.13-.04l-.08-.06s-.05-.07-.06-.11c-.05-.61.1-1.13.44-1.54.47-.58,1.18-.8,1.46-.86ZM49.43,109.71c.05-.25.15-.47.3-.65.4-.5,1.03-.54,1.32-.53.05-.14.14-.38.32-.59.23-.29.66-.61,1.36-.5.03,0,.05.01.07.03.01,0,.02.02.03.03l.03.05s.03.08.02.12c0,.03-.02.05-.03.07,0,0,0,0-.01.01,0,0-.01.01-.02.02-.01,0-.04.02-.06.03-.03,0-.06.01-.09,0-.11,0-.44.12-.73.48-.17.21-.29.47-.36.77h0s-.02.07-.04.1c-.01.01-.03.03-.04.04-.04.03-.09.04-.15.03h-.01c-.95-.14-1.44.42-1.49.48-.04.05-.05.08-.06.09,0,.03-.02.06-.04.08,0,0,0,.01-.02.02-.03.03-.07.05-.12.05-.05,0-.09-.03-.12-.07l-.04-.05s-.04-.08-.02-.12ZM49.2,114.5s-.06-.06-.06-.11c-.08-.54.04-1.01.35-1.39.35-.43.86-.63,1.08-.7-.01-.28.01-.92.42-1.43.26-.32.63-.53,1.1-.63.04,0,.08,0,.12.03l.06.04c.06.04.08.11.06.18,0,.01-.01.03-.02.04-.02.02-.04.04-.05.05-.03.02-.07.04-.1.04-.07.03-.22.13-.37.32-.21.26-.55.84-.43,1.72v.02s0,.11-.03.16h0c-.03.05-.08.08-.13.09h-.02c-.7.15-1.11.51-1.34.79s-.31.55-.31.64c0,.03,0,.07,0,.1,0,0,0,.02-.01.03-.02.04-.05.07-.09.08-.05.02-.1.01-.14-.02l-.07-.05ZM44.53,122.66c-.86-.69-.99-1.94-.3-2.8.03-.03.06-.06.08-.1-1.02-.95-1.15-2.54-.26-3.65s2.63-1.34,3.79-.41c.33.26.57.59.74.95,1.08-.86,2.64-.9,3.76,0,1.29,1.04,1.5,2.94.46,4.23-.08.09-2.54,3.11-2.54,3.11-.74.92-2.08,1.06-3,.32-.44-.35-.7-.85-.77-1.37-.64.25-1.4.16-1.97-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M94.66,88.64c.13-.08.29-.04.36.09l1.57,2.58c.08.13.04.29-.09.36l-2.6,1.58c-.13.08-.29.04-.36-.09l-.48-.79-1.81.84-8.46,5.38-.61-1.01,4.77-2.75-.88-1.45c-.56.28-1.14.49-1.74.62-1.03.22-2.48-.04-3.43.19.5-.17,1.67-.65,2.12-1.64.57-1.27.68-1.45,1.23-1.92-1.38.68-2.83.46-4.3-1.1-1.4-1.49-2.05-2-2.96-1.87.99-.74,2.51-1.68,5.36-.94,2.15.55,3.5-.31,3.97-1.97.47-1.66.94-2.61,1.93-2.31.24.07.46.13.66.16-.26-.74-.11-1.39.04-2.03.08-.35.17-.72.18-1.09h.2c-.01.4-.1.77-.18,1.13-.15.66-.3,1.3,0,2.03.48.07.77.06.77.06,0,0-.25.12-.56.36.21.34.52.69.98,1.08-.05.04-.11.08-.16.12-.44-.38-.75-.74-.97-1.07-.15.13-.3.28-.45.46-.49.63-.61,1.44.28,2.8.88,1.34,1.26,3.14-.72,5.27-.27.29-.56.56-.87.8l.92,1.52,2.52-1.45,1.59-1.22-.48-.79c-.08-.12-.04-.29.09-.36l2.6-1.58ZM86.48,93.15l.87,1.44.57-.32-.89-1.47c-.18.13-.36.24-.55.35ZM87.55,78.88s.61-.04.95.31c.34.35.28.96.28.96,0,0-.61.04-.95-.31-.34-.35-.28-.96-.28-.96ZM88.48,81.57s-.61.04-.95-.31c-.34-.35-.28-.96-.28-.96,0,0,.61-.04.95.31.34.35.28.96.28.96ZM89.5,80.34s.04-.56.4-.82c.36-.26.89-.13.89-.13,0,0-.04.56-.4.82-.36.26-.89.13-.89.13ZM88.96,78.22c.12-.5.69-.78.69-.78,0,0,.38.53.26,1.02-.12.5-.69.78-.69.78,0,0-.38-.52-.26-1.02ZM90.11,81.66c-.4.18-.9-.06-.9-.06,0,0,.16-.54.56-.72.4-.18.9.06.9.06,0,0-.16.54-.56.72ZM94.11,87.5c.22-.13.51-.06.64.16s.06.51-.16.64l-2.81,1.7c-.22.13-.51.06-.64-.16s-.06-.51.16-.64l2.81-1.7ZM96.77,91.88c.22-.13.51-.06.64.16s.06.51-.16.64l-2.81,1.7c-.22.13-.51.06-.64-.16s-.06-.51.16-.64l2.81-1.7ZM80.89,94.19c-.14.05-.23.07-.23.07.07-.03.15-.05.23-.07ZM82.44,98.58c.13.21.09.48-.1.59l-.2.12c-.18.11-.44.03-.57-.19l-.42-.7c-.13-.21-.08-.48.1-.59l.2-.12c.18-.11.44-.03.57.19l.42.7Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-98",
    cx: 151.58,
    cy: 193.66,
    r: 66.9,
    transform: "translate(-12.16 10.16) rotate(-3.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M119.59,187.59c0-.29-.1-.52-.31-.68-.21-.16-.57-.33-1.09-.5-.52-.17-.94-.34-1.27-.5-1.07-.53-1.6-1.25-1.6-2.17,0-.46.13-.86.4-1.21.27-.35.64-.62,1.13-.82.49-.19,1.04-.29,1.64-.29s1.12.11,1.6.32c.47.21.84.51,1.1.9.26.39.39.84.39,1.34h-1.98c0-.34-.1-.6-.31-.78-.21-.19-.48-.28-.84-.28s-.64.08-.84.24c-.21.16-.31.36-.31.6,0,.21.11.4.34.58.23.17.63.35,1.2.53.57.18,1.04.38,1.41.59.89.51,1.34,1.22,1.34,2.13,0,.72-.27,1.29-.82,1.7-.54.41-1.29.62-2.24.62-.67,0-1.27-.12-1.82-.36-.54-.24-.95-.57-1.22-.99-.27-.42-.41-.9-.41-1.44h2c0,.44.11.77.34.98.23.21.6.31,1.11.31.33,0,.59-.07.78-.21.19-.14.29-.34.29-.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M129.19,181.53v5.4c0,.61-.13,1.14-.39,1.59-.26.45-.64.79-1.12,1.02-.49.23-1.06.35-1.73.35-1.01,0-1.8-.26-2.38-.78-.58-.52-.87-1.24-.88-2.14v-5.44s2,0,2,0v5.48c.02.9.44,1.35,1.26,1.35.41,0,.72-.11.93-.34.21-.23.32-.59.32-1.11v-5.39s1.99,0,1.99,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M134.8,187.59c0-.29-.1-.52-.31-.68-.21-.16-.57-.33-1.09-.5-.52-.17-.94-.34-1.27-.5-1.07-.53-1.6-1.25-1.6-2.17,0-.46.13-.86.4-1.21.27-.35.64-.62,1.13-.82.49-.19,1.04-.29,1.64-.29s1.12.11,1.6.32c.47.21.84.51,1.1.9.26.39.39.84.39,1.34h-1.98c0-.34-.1-.6-.31-.78-.21-.19-.48-.28-.84-.28s-.64.08-.84.24c-.21.16-.31.36-.31.6,0,.21.11.4.34.58.23.17.63.35,1.2.53.57.18,1.04.38,1.41.59.89.51,1.34,1.22,1.34,2.13,0,.72-.27,1.29-.82,1.7-.54.41-1.29.62-2.24.62-.67,0-1.27-.12-1.82-.36-.54-.24-.95-.57-1.22-.99-.27-.42-.41-.9-.41-1.44h2c0,.44.11.77.34.98.23.21.6.31,1.11.31.33,0,.59-.07.78-.21.19-.14.29-.34.29-.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M144.41,183.06h-2.48v6.72s-1.99,0-1.99,0v-6.72h-2.43s0-1.54,0-1.54h6.9s0,1.54,0,1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M147.12,186.7h1.77s-.89-2.86-.89-2.86l-.88,2.86ZM149.37,188.24h-2.73s-.48,1.54-.48,1.54h-2.13s3.03-8.25,3.03-8.25h1.87s3.05,8.25,3.05,8.25h-2.14s-.48-1.54-.48-1.54Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 152.84,
    y: 181.53,
    width: 1.98,
    height: 8.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M163.22,189.78h-1.98s-2.93-5.14-2.93-5.14v5.14s-1.99,0-1.99,0v-8.25s1.99,0,1.99,0l2.92,5.14v-5.14s1.98,0,1.98,0v8.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M167.13,186.7h1.77s-.89-2.86-.89-2.86l-.88,2.86ZM169.38,188.24h-2.73s-.48,1.54-.48,1.54h-2.13s3.03-8.25,3.03-8.25h1.87s3.05,8.25,3.05,8.25h-2.14s-.48-1.54-.48-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M174.71,186.27v1.98h1.3c.36,0,.64-.08.83-.25.19-.16.29-.4.29-.69,0-.69-.34-1.03-1.03-1.04h-1.39ZM174.71,184.97h1.04c.43,0,.74-.08.93-.24.19-.15.28-.38.28-.69,0-.35-.1-.6-.3-.75-.2-.15-.52-.23-.97-.23h-.98v1.91ZM172.72,189.78v-8.25s2.96,0,2.96,0c1.06,0,1.87.19,2.42.58.55.39.83.95.83,1.7,0,.43-.1.79-.3,1.09-.2.3-.49.53-.87.67.43.11.76.33.99.64.23.31.35.69.35,1.13,0,.81-.26,1.42-.77,1.82-.51.41-1.27.61-2.28.62h-3.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M182.31,188.25h3.46s0,1.53,0,1.53h-5.45s0-8.25,0-8.25h1.99s0,6.72,0,6.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M191.85,186.28h-3.13v1.97h3.7s0,1.53,0,1.53h-5.69s0-8.25,0-8.25h5.7s0,1.54,0,1.54h-3.71v1.74h3.13s0,1.47,0,1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M116.95,194.49v4.97h.66c.55,0,.97-.19,1.26-.58.29-.39.44-.97.44-1.73v-.34c0-.76-.15-1.34-.44-1.73-.29-.39-.72-.58-1.28-.58h-.64ZM115.05,200.93v-7.91s2.55,0,2.55,0c.7,0,1.33.16,1.88.48.56.32.99.76,1.31,1.34.31.58.47,1.22.47,1.94v.36c0,.72-.15,1.37-.46,1.95-.31.57-.74,1.02-1.29,1.35-.56.32-1.18.49-1.86.49h-2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M127.14,197.57h-3v1.89h3.54s0,1.47,0,1.47h-5.45s0-7.91,0-7.91h5.46s0,1.47,0,1.47h-3.55v1.67h3s0,1.41,0,1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M132.02,198.78l1.57-5.76h2.13s-2.66,7.91-2.66,7.91h-2.08s-2.64-7.91-2.64-7.91h2.11s1.57,5.76,1.57,5.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M141.2,197.57h-3v1.89h3.54s0,1.47,0,1.47h-5.45s0-7.91,0-7.91h5.46s0,1.47,0,1.47h-3.55v1.67h3s0,1.41,0,1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M144.42,199.46h3.32s0,1.47,0,1.47h-5.22s0-7.91,0-7.91h1.91s0,6.44,0,6.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M152.73,196.8c0-.79-.13-1.38-.39-1.79-.26-.41-.64-.61-1.13-.61-.96,0-1.46.72-1.51,2.15v.58c0,.77.12,1.37.38,1.79.26.42.64.62,1.15.62s.85-.2,1.11-.61c.26-.41.39-1,.4-1.76v-.36ZM154.67,197.14c0,.77-.14,1.45-.43,2.05s-.69,1.05-1.22,1.37c-.53.32-1.13.48-1.8.48s-1.27-.15-1.79-.46c-.52-.31-.93-.75-1.22-1.33-.29-.58-.44-1.24-.46-1.98v-.45c0-.77.14-1.46.43-2.05s.69-1.05,1.22-1.37c.53-.32,1.13-.48,1.81-.48s1.27.16,1.79.48c.52.32.93.77,1.22,1.36.29.59.44,1.26.44,2.02v.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M157.56,196.77h1.25c.37,0,.65-.09.84-.28.19-.18.29-.44.29-.78,0-.37-.1-.66-.3-.89-.2-.22-.47-.33-.81-.34h-1.27v2.28ZM157.56,198.24v2.68s-1.91,0-1.91,0v-7.91s3.15,0,3.15,0c.6,0,1.14.11,1.6.33.47.22.83.54,1.08.95s.38.88.38,1.4c0,.77-.28,1.39-.83,1.85-.55.46-1.31.69-2.27.69h-1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M165.26,193.02l1.76,5.5,1.76-5.5h2.51s0,7.91,0,7.91h-1.91s0-1.85,0-1.85l.18-3.78-1.91,5.63h-1.26s-1.92-5.63-1.92-5.63l.18,3.78v1.85s-1.91,0-1.91,0v-7.91s2.5,0,2.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M177.23,197.57h-3v1.89h3.54s0,1.47,0,1.47h-5.45s0-7.91,0-7.91h5.46s0,1.47,0,1.47h-3.55v1.67h3s0,1.41,0,1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M185.09,200.93h-1.89s-2.8-4.92-2.8-4.92v4.92s-1.91,0-1.91,0v-7.91s1.91,0,1.91,0l2.8,4.92v-4.92s1.9,0,1.9,0v7.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M192.45,194.49h-2.37v6.43s-1.91,0-1.91,0v-6.43h-2.33s0-1.47,0-1.47h6.61s0,1.47,0,1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M145.03,161.68h1.39c.05-1.87.8-3.57,2.01-4.84l-.99-.99c-1.51,1.58-2.37,3.64-2.41,5.83M147.72,155.57l.99.99c1.27-1.21,2.97-1.96,4.84-2.01v-1.39c-2.19.05-4.25.9-5.83,2.41M153.75,160.29c-.16,0-.32.02-.47.07-.02.02-.04.04-.02.06.04.06.16-.06.17.05.01.08-.13.02-.12.08.01.05.11.03.11.09,0,.06-.06.17-.11.2-.06.04-.4.08-.43.16-.03.07-.06.13-.11.18-.06.06-.33.22-.33.26,0,.1.13-.03.16-.06.06-.06.14-.06.22-.11.12-.07.16.17.04.18-.08,0-.15.23-.27.19-.03-.01-.12-.07-.14,0-.02.06.19.07.25.11.16.11-.12.1-.17.13-.05.03-.02.09.04.07.06-.03.14-.09.18.01.05.14-.23.64-.31.59-.04-.03-.09.01-.13.03.06.11.13.22.21.32.05-.09.14-.22.18-.22.05,0,.03-.04.05-.08.02-.04.09,0,.09-.06,0-.06.16-.15.18-.23,0-.05-.05-.09-.02-.13.03-.05.05-.06.08-.07.03-.01.1.06.13.03.02-.03.13,0,.21.04.04.02.11,0,.16.06.06.09,0,.1,0,.12.01.02.04-.01.05,0,.03.03-.16.15-.14.21.02.06-.17.37-.22.42-.07.07-.19,0-.24,0-.05.01-.06.06-.14.04-.06-.01-.13,0-.2.04.28.25.64.39,1.04.39.09,0,.17,0,.25-.02.05-.07.07-.15.08-.23,0-.04,0-.1.02-.14.02-.03.15-.19.2-.19.05,0,.08.04.14.02.13-.04.21,0,.21.05,0,.08-.16.05-.15.1,0,.03.12.08.16.03.07-.08.06-.19.04-.21-.05-.06-.05-.09.03-.07.05.02.04-.16.09-.23.06-.09-.11-.03-.18-.02-.07,0-.12-.13-.12-.18,0-.04.12.12.19.13.07,0,.16-.08.16-.14,0-.06-.14-.07-.16-.14-.01-.04.11,0,.1-.04,0-.03.01-.12-.07-.15-.08-.03-.15-.28-.21-.3-.06-.01-.1.06-.13.09-.03.03-.09-.02-.06-.05.04-.04.13-.12.15-.18.03-.1.17,0,.14-.14-.03-.16-.16-.13-.1-.21.06-.08.02-.2-.11-.18-.06.01-.12-.09-.13-.17,0-.05-.14-.04-.13-.09.01-.1-.14-.11-.23-.1-.09,0-.27-.14-.29-.17-.02-.04-.15.03-.11-.11.04-.13.17.02.22-.01.06-.04.04-.08.03-.12-.01,0-.02,0-.03,0M153.95,159.91c.13.01.26.04.39.08.03-.08.12-.12.18-.17.08-.05.14-.12.13.03-.01.1-.05.17-.11.21.14.06.27.13.39.22.03.02.05.04.08.06l.13-.13s0,0,0-.01c0-.08.11-.17.24-.22l.43-.43s-.02,0-.03,0c-.06,0-.14.11-.2.08-.06-.04.19-.26.31-.22.02,0,.03.01.05.02l.06-.06c-.55-.49-1.26-.8-2.05-.85v1.4ZM153.95,158.12c.89.05,1.7.4,2.32.96l.99-.99c-.88-.81-2.03-1.32-3.31-1.37v1.39ZM153.95,156.34c1.18.04,2.27.46,3.16,1.13-.1-.13-.2-.27-.25-.32-.09-.09-.41-.2-.37-.25.03-.05.32.18.37.14.06-.05-.14-.31-.13-.32.02-.01.26.22.38.43.05.07.18.04.28.11.09.06.1.16.17.23.01.01.17.1.08.09-.03,0-.07-.06-.1-.03-.02.02.01.12.07.22l.46-.46c-.07-.14-.2-.32-.29-.34-.1-.02-.15.06-.22.11-.07.05-.15.07-.16.04-.01-.04.01-.14,0-.19,0-.05-.05-.1-.06-.15-.03-.12.02-.26-.06-.34-.08-.09-.13-.22-.2-.32-.07-.11-.19-.28-.2-.43-.9-.46-1.9-.71-2.94-.74v1.39ZM153.95,154.55c1.16.03,2.28.33,3.28.87.09-.01.19-.03.25-.06.12-.06.37.07.49.14.11.06.19.15.31.22.12.07.31.26.36.46.04.2.17.18.11.26-.03.04.02.05.08.09l.97-.97c-1.58-1.51-3.64-2.37-5.83-2.41v1.39ZM160.05,155.85l-1.03,1.03c.09.16.27.37.52.63.1.1.21.21.3.3.09.09.65.79.54.89,0,0-.02.01-.02.02.44.92.68,1.93.71,2.96h1.39c-.05-2.19-.9-4.25-2.41-5.83M162.47,162.07h-1.39c-.05,1.87-.8,3.57-2.01,4.84l.99.99c1.51-1.58,2.37-3.64,2.41-5.83M155.82,164.89c0,.07-.07.01-.09.04-.02.02.55.29.64.3.06.01.18.05.38.01.14-.03.18.04.24.03.09,0,.15-.13.21-.2.14-.2.11-.23.15-.26.05-.04.19.27.17.46,0,.03,0,.06-.01.09h.01c.81-.86,1.32-2.02,1.37-3.29h-1.06c.04.06.1.14.17.28.05.11.09.28.18.29.15.01.29.13.3.24,0,.21-.65.26-.73.24-.07-.02-.12-.03-.13.09,0,.13-.24.13-.33.21-.1.09-.11.24-.18.35-.04.07-.28.29-.35.34-.16.11-.45.12-.32.19.1.05.32.07.29.02-.03-.06.02-.06.05-.02.03.04.13-.04.13-.1,0-.06-.02-.16.04-.17.09,0,.19-.11.24-.1.05.01.13.13.07.49-.05.36-.23.61-.29.72-.07.12-.15.03-.25-.02-.13-.07-.32-.06-.45-.11-.07-.02-.46-.17-.45-.12M156.33,159.71s-.09-.01-.12-.02l-.33.33c.06.02.13,0,.21.03.09.04.04-.24.18-.22.13.03.17.11.06.16-.09.03.02.1-.09.14-.1.03.08.12.08.16,0,.05-.13.07.06.14.2.06,0-.17.03-.2.04-.04.14.06.17.02.01-.02.03-.04.06-.08-.09-.16-.2-.31-.32-.44M157.53,158.37l-.99.99c.17.19.32.39.45.61.12.02.27.06.38.2.07.09.28.28.25.36-.02.05.02.11.07.15.07.05.12.05.16,0,.07-.09.08-.22.18-.3.12-.1.36.18.36.24,0,.05-.06.06-.08.15-.02.13-.13.27,0,.32.18.06.2,0,.28-.13.04-.06.03-.15.07-.21.03-.04.07-.05.1-.07-.07-.28-.15-.55-.26-.8-.03-.03-.06-.05-.09-.06-.06-.02-.03-.08-.11-.1-.1-.03-.13-.06-.14-.23,0-.13.11.04.14.02,0,0,.01-.01.02-.02-.21-.4-.48-.77-.78-1.1M157.88,161.66s0,.01-.01.02h1.03c0-.15-.02-.3-.04-.44,0,.02-.02.03-.02.05-.08.16-.09.06-.08,0,0-.09.04-.17.07-.26,0-.05-.02-.09-.03-.14-.03.04-.07.07-.14.11-.05.02-.09.13-.1.17-.02.05-.13-.01-.23.03-.16.08-.33.09-.21.26.08.11-.18.08-.24.21M157.65,167.43c-.04.09-.22.25-.19.3.38-.24.73-.51,1.05-.82l-.99-.99c-.07.06-.14.13-.21.19-.02.11,0,.2.14.24.15.05.4.2.35.35-.06.13-.21.33-.28.46-.06.11.17.16.13.27M158.71,166.56l.08.08c1.14-1.2,1.85-2.8,1.9-4.57h-1.39c-.05,1.38-.6,2.64-1.49,3.58l.5.5s0-.01.01-.02c.04-.09.02-.2.03-.28,0-.05.2-.04.21.05.01.07.05.13.12.31.05.13.07.25.04.35M157.83,158.1s0,.01-.01.02c.23.25.44.52.62.8.02-.03.04-.05.07-.02.05.06-.05.16.09.13.09-.02.07.1,0,.16.04.08.09.16.13.25.05.02.09.05.1.08.02.1.07.21.08.31.07.18.13.36.18.54.07-.06.15-.03.16.07,0,.1-.02.21-.07.31.06.3.1.61.11.93h1.39c-.03-.9-.23-1.8-.59-2.62-.03.02-.06.02-.11.08-.07.09-.18-.02-.25-.1-.12-.14-.39-.55-.52-.57-.1-.02-.18-.15-.29-.17-.11-.02-.24-.08-.26-.2-.02-.12-.06-.17-.18-.19-.14-.02-.23-.07-.33-.18l-.33.33s0,.01,0,.02M159.78,168.18l-.99-.99c-.51.48-1.09.9-1.72,1.22-.21.16-.46.27-.66.36-.08.04-.17.08-.26.08-.03,0-.06,0-.08-.03-.67.22-1.38.35-2.13.37v1.39c2.19-.05,4.25-.9,5.83-2.41M154.61,166.96s-.14-.05-.2-.04c-.23.06-.15-.12-.47-.07v.18c.23,0,.45-.03.67-.07M153.95,167.42v1.39c.56-.02,1.11-.1,1.64-.24-.11-.09-.16-.24-.29-.29-.23-.08-.29-.22-.17-.43.07-.11.04-.16-.04-.27-.1-.15-.22-.21-.31-.25-.27.05-.54.08-.82.09M153.86,165.06c.15-.03.31-.07.44-.08.15-.01,0,.19.08.2.1.01.53.08.56-.01.02-.08.03-.12.12-.14.17-.04.31-.03.46-.14.05-.04.16-.06.19-.12.03-.06-.02-.34-.13-.3-.05.02-.11.1-.22.15-.1.05-.17.07-.24-.02-.06-.09.04-.15.09-.21.08-.09.16-.18.25-.18.04,0,.22-.09.21-.18-.02-.11-.24.01-.29-.04-.04-.03,0-.11-.03-.12-.03-.01-.11.1-.04.16.03.03-.05.12-.15.06-.07-.05-.09.22-.09.27,0,.05.11.04.04.12-.07.09-.09.02-.14.07-.06.05-.07.07,0,.15.06.06-.03.17-.06.07-.01-.07-.16-.05-.19-.13-.03-.08-.15-.07-.3-.15-.11-.06-.1.11.09.16.16.04.15.06.11.16-.04.08-.03-.06-.22-.11-.12-.03-.13-.1-.23-.1-.1,0-.07.09-.17.07-.08-.02-.09.09-.16.12-.09.04-.08.2-.17.24-.13.07-.41.02-.4-.12.01-.13.02-.23.1-.28.07-.04.18.08.27.04.1-.04.07-.15.01-.21-.02-.02-.09-.06-.09-.08,0-.03.14-.04.21-.09s.15-.17.18-.2c.04-.03.11-.04.12-.07,0-.04-.05-.1-.05-.14,0-.04.02-.08.06-.07.03,0,.07.1.05.12-.02.03.02.07.06.05.05-.02.21-.08.26-.1.06-.02-.02-.16,0-.19.02-.02.04,0,.06-.02.03-.03-.05-.05-.04-.1,0-.04.18-.09.13-.12-.05-.03-.11.06-.15.07-.09.04-.13-.06-.12-.13,0-.03.05-.16,0-.18-.06-.03-.07.11-.07.14-.01.04-.05.1.01.21.03.06.02.28-.05.3-.07.03-.1-.11-.13-.16,0,0-.01-.02-.02-.02,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0-.01.01,0,0-.01.02-.02.04,0,0-.02.03-.03.07,0,.02-.02.04-.05.04-.07,0-.14.01-.22.01-.03,0-.06,0-.08,0,.01.04.02.09.04.12.04.07.11.13.1.19-.01.05-.24.1-.26.06-.02-.05.06-.15.05-.19-.01-.08-.05-.13-.05-.19-.4-.04-.76-.2-1.06-.44l-.99.99c.49.43,1.1.73,1.78.82.1-.06.13-.16.21-.11.12.09.27-.03.36-.05M153.56,166.93c-.2.01-.49,0-.56-.04-.15-.1-.32-.2-.34-.28-.04-.14-.23-.24-.23-.37,0-.15.2-.19.15-.34-.04-.12.07-.26.28-.37-.61-.15-1.17-.45-1.62-.86l-.99.99c.91.84,2.07,1.32,3.31,1.37v-.1ZM153.56,167.42c-1.24-.04-2.4-.49-3.35-1.27.02.03.04.05.05.07.06.11.29.34.15.43-.12.07-.31.02-.42.02-.12,0-.3.18-.4.2-.13.02-.21.01-.33-.04-.03-.01-.07-.04-.11-.07l-.16.16c1.2,1.13,2.8,1.85,4.57,1.9v-1.39ZM153.56,169.2c-1.87-.05-3.57-.8-4.84-2.01l-.99.99c1.58,1.51,3.64,2.37,5.83,2.41v-1.39ZM146.82,162.07c.02.72.15,1.42.38,2.07,0,0,.02,0,.02,0,.14,0,.33,0,.42-.07.14-.11.01-.48.1-.64.11-.19.37-.66.45-.66.07,0,.07.05.1.06-.04-.25-.07-.5-.08-.75h-1.39ZM148.71,157.11c-1.13,1.2-1.85,2.8-1.9,4.57h1.39c.05-1.38.6-2.64,1.49-3.58l-.99-.99ZM153.56,156.34v-1.39c-1.77.05-3.37.76-4.57,1.9l.99.99c.95-.88,2.2-1.44,3.58-1.49M153.56,158.12v-1.39c-1.27.05-2.43.56-3.31,1.37l.99.99c.62-.56,1.43-.92,2.32-.96M152.22,162.41s0-.02,0-.03c0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0,0,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.02,0-.03h0s0-.02,0-.02c0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0,0,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0-.01.01-.02.01-.02.03-.02.05-.02.03,0,.08.03.12.03.03,0,.06,0,.09-.04.01-.01.02-.03.03-.05,0-.02.01-.03.01-.05,0,0,0-.01,0-.02,0-.01-.03-.02-.07,0,0,0-.02,0-.02,0-.02,0-.03,0-.05,0,0,0-.01,0-.02,0-.02,0-.04-.01-.06-.03,0,0,0-.01-.01-.02,0-.01-.01-.02-.02-.03-.02-.04-.06-.05-.1-.08-.02-.01-.04-.02-.06-.04,0,0-.02-.02-.03-.03,0,0-.01-.02-.02-.02,0,0,0,0,0,0,0,0,0,0-.01-.01,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0,0,0-.05,0-.1,0-.14.05,0,0,0,0,0,0,0,0-.01.02-.02.02,0,0,0,0,0,0,0,0-.01.02-.02.03,0,0,0,0,0,0,0,.01-.01.02-.02.04-.01.03-.03.06-.04.1-.11.3-.24.21-.22.31,0,.01.03.02.08.02.02,0,.04,0,.06,0s.05,0,.07,0c.02,0,.05,0,.07,0,.01,0,.02,0,.03,0,0,0,.01,0,.02,0,0,0,.01,0,.02,0,0,0,.01,0,.02,0,0,0,.01,0,.02,0,0,0,0,0,.01,0,.01,0,.02,0,.03-.01.01,0,.03-.01.05-.02t0,0s.03,0,.04-.01c.03,0,.06,0,.08,0,.01,0,.05.02.07.05.02.03.04.07.04.11M151.23,164.12l.99-.99c-.08-.1-.15-.2-.21-.32h0s-.03.04-.04.05c-.02.04,0,.19-.06.25-.08.08-.29-.18-.36-.2-.09-.03-.13.07-.13.1.01.07,0,.1-.04.11-.03,0-.2-.11-.12-.13.09-.03-.02-.11-.06-.14-.06-.05-.16,0-.21-.07-.05-.07-.15-.12-.17-.13-.02,0-.12-.05-.18-.01-.05.03-.1-.03-.14-.06-.02-.02-.04-.04-.06-.07.12.61.4,1.15.79,1.6M149.81,161.34c-.11-.01-.22.03-.28.13-.04.07-.05.14-.04.21h.5c0-.09.01-.19.03-.28-.06-.03-.14-.05-.21-.06M150.78,160.28s.03-.01.04-.02c.17-.1.39-.08.49-.04.12.05.28.19.35.24.03.02.04-.02.19-.04.06,0,.07.05.16.06.03,0,.06,0,.09,0l-.86-.86c-.18.2-.33.41-.45.65M150.96,159.36l-.99-.99c-.81.88-1.33,2.03-1.37,3.31h.69c.12-.19.08-.33.11-.44.04-.1.1-.2.16-.29.05-.08.11-.17.22-.17.22,0,.28-.12.42-.18.14-.07.4-.1.37-.18-.02-.05-.53.15-.54.11-.02-.07.16-.06.24-.13.01-.01.03-.02.04-.03.16-.37.38-.71.65-1.01M148.56,166.45s0,0-.01,0c.05.06.11.12.16.18l.11-.11c-.1-.07-.2-.11-.26-.07M148.93,162.69c-.08-.09.05-.36.07-.41.02-.06.14-.13.18-.21h-.59c.01.31.05.61.11.9.14.05.41-.06.22-.28M149.75,165.04s0,.06,0,.08c.07.09.15.18.22.26l.99-.99c-.46-.52-.79-1.16-.91-1.87-.03,0-.06,0-.07-.02-.02-.03,0-.07.05-.11-.01-.1-.02-.21-.03-.32h-.66c0,.1.05.26-.02.31-.06.04-.14,0-.19,0-.13.02-.16.17-.12.27.02.07.05.12.04.2-.01.07-.05.13.06.18.1.05.27.26.25.3-.02.05-.12-.04-.13.04,0,.05.15-.01.14.16,0,.1.02.21.05.28.06.15.13.24.12.41,0,.14-.03.28.03.41.06.13.17.24.17.39M153.2,159.83s-.09.11-.14.2c.16-.06.33-.1.5-.12v-1.4c-.78.04-1.5.36-2.05.85l.99.99c.11-.09.24-.17.37-.24.03-.02.07-.03.1-.05.07-.12.21-.25.23-.23M147.45,167.9l.99-.99c-.19-.21-.38-.42-.55-.65-.08-.03-.15-.07-.21-.14-.08-.11-.13-.26-.17-.26s0,.1-.09.11c-.12.02-.3-.29-.36-.4-.08-.13-.21-.13-.27-.25-.02-.04-.06-.14-.1-.08-.07.11-.3-.24-.36-.21-.06.02,0,.1-.04.13-.07.06-.26-.27-.34-.23-.07.03-.08.07-.09.16,0,.09.11.32.07.34-.06.03-.34-.7-.28-.73.03-.02.03.03.07,0,.04-.02-.03-.07-.05-.15-.02-.08-.09-.08-.1-.17,0-.09.12-.06.12-.1,0-.04,0-.09.05-.12.04-.04.14,0,.16-.12.02-.11.07,0,.08.07.01.09.25.12.26.05,0-.04-.1-.04-.1-.07,0-.07.13,0,.22,0,.04,0,.11-.06.2-.01.1.05.16.07.22.08-.22-.66-.34-1.36-.36-2.08h-1.39c.05,2.19.9,4.25,2.41,5.83M144.64,161.88c0-2.44.95-4.72,2.67-6.44,1.72-1.72,4.01-2.67,6.44-2.67s4.72.95,6.44,2.67c1.72,1.72,2.67,4.01,2.67,6.44s-.95,4.72-2.67,6.44c-1.72,1.72-4.01,2.67-6.44,2.67s-4.72-.95-6.44-2.67c-1.72-1.72-2.67-4.01-2.67-6.44M149.77,162.94s.08-.32.07-.44c-.01-.12-.07-.22-.09-.22-.02.01,0,.08.01.19,0,.17-.07.31-.07.36,0,.05.05.17.08.1M149.81,163.38c0-.06,0-.24-.04-.28s-.04.03-.07.03c-.02,0-.02-.09-.05-.09-.03,0,.01.14.04.23.03.08.11.22.12.11M151.73,163.39s.07-.14.04-.21c-.03-.07-.16-.02-.17.01-.01.03.08.2.12.2M153.2,161.81c-.13-.03-.1.04-.19.05-.13.01-.01-.1-.08-.15-.03-.02-.11.09-.11.16,0,.03,0,.15.05.15.06,0,.35.04.45.06.11.03,0-.25-.13-.28M152.92,161.64c.07,0,.06-.05.1-.05.04,0,0,.05.07.05s.13-.17-.08-.17c-.17,0-.15.16-.1.17M153.23,163.22s-.08-.03-.06,0c.02.04-.02.07.01.12.05.05.15.04.2,0,.03-.03.01-.09-.01-.1-.04-.02-.13.02-.14-.02M155.55,153.99c-.21-.1-1-.09-.98.11.02.18.46.01.57,0,.11-.01.6-.02.41-.12M154.6,154.47c-.16-.1-.03-.24-.15-.33-.09-.07-.33,0-.39.08-.11.14.14.09.22.13.1.04.31.22.35.19.04-.04,0-.04-.03-.06M158.19,155.5c.08.03.08-.12-.05-.22-.13-.11-.31-.06-.26,0,.04.05.25.2.31.23M159.02,159.57s.12.35.14.43c.01.08.04.33.11.31.04-.02.04-.17.03-.23-.03-.17-.06-.32-.13-.52-.03-.1-.18-.44-.23-.43-.04.01.07.25.09.32.01.05,0,.07,0,.11M157.44,159.55c-.07,0-.09.08-.02.12.03.02.13,0,.18-.03.05-.03.1-.07.09-.14,0-.04-.11-.17-.06-.22.06-.05.12.03.17,0,.07-.03.06-.07.07-.13,0-.08-.03-.19-.13-.19-.07,0-.19.19-.2.2,0,.02-.03.09,0,.16.04.1.03.21-.11.22M158.61,162.58c-.08,0-.17.12-.15.13.06,0,.11.05.15.04.09-.02.08-.16,0-.16M155.4,159.77s.22-.07.18-.1c-.03-.03-.24-.12-.24-.06,0,.1.02.14.06.16M155.34,159.83c-.06-.03-.33.29-.29.34.02.02.31-.33.29-.34M153.52,164.04c.07-.1-.1-.16-.14.01-.04.16.08.09.14-.01M143.89,156.6s0,0,.01,0c0,0,0,0,0,0,.16-.13.81-.63,1.03-.85.34-.29.58-.66.83-1.02.26-.38.53-.74.88-1.05.03-.03.05-.04.08-.07,0,0,.01-.03,0-.04-.59.16-1.2.41-1.66.8-.85.68-1.15,2.04-1.18,2.23,0,0,0,0,0,0M142.66,158.87c0,.16,0,.29-.01.38,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.03,0,.03,0,0,0,0,0,0,0,.13-.17.55-.69,1.13-1.17.32-.27.66-.52.96-.81.42-.4.67-1.08.74-1.44,0-.03.01-.06.01-.07,0,0-.03,0-.04.01-.04.06-.09.11-.13.17-.24.33-.5.53-.84.75-.57.36-.97.63-1.29,1.07,0,0,0,0,0,.01-.01.03-.04.01-.03-.01.1-.32.14-.51.21-.79.11-.46.16-1.06.33-1.47.11-.26.26-.47.46-.67,0,0,0,0,0,0,0-.02,0-.04,0-.04-.03,0-.08.02-.11.04-.59.3-.99.77-1.26,1.38-.16.37-.21.76-.21,1.15,0,.13,0,.26.01.39.02.33.03.8.03,1.15M141.76,161.22c.15.43.36,1.08.4,1.24,0,0,.03,0,.03-.02.12-.46.62-1.36.94-1.79.02-.03.04-.06.07-.09.31-.41.65-.82.86-1.3.14-.33.37-1.05.38-1.12,0,0,0,0-.02,0,0,0-.02,0-.04,0,0,0,0,0,0,0,0,0,0,0,0,0-.22.34-.61.74-.86.96-.41.34-.74.6-.99,1.09-.03.05-.06.13-.09.2-.08.18-.15.39-.15.4,0,.01-.03.03-.03,0,0-.02.04-.61.05-.69.02-.47-.07-.94-.13-1.41-.08-.59-.13-1.08.03-1.78.01-.05.02-.09.04-.14.01-.04.02-.06.03-.1,0,0,0-.03-.02-.04-.62.76-.98,2.14-.82,3.21.05.38.32,1.25.35,1.34M142.77,165.7s0,0,0,0c.02-.02.02-.02.01-.08-.07-.65.04-1.17.25-1.78.32-.91.62-1.86.72-2.82.01-.13.03-.33.02-.39,0,0-.04.01-.04.02-.14.34-.46.85-.64,1.15-.36.56-.76,1.12-.81,1.79-.01.17-.01.4.01.58,0,0,0,.02-.02.02,0,0,0,0-.01-.01-.04-.16-.09-.36-.15-.57-.33-1.11-1.11-1.81-1.11-3.43,0,0-.02-.04-.03-.04-.02.03-.07.14-.11.28-.7,2.26.72,3.88,1,4.22.26.32.68.76.9,1.07M143.02,167.81c.47.31,1.18.73,1.43.89,0,0,0,0,0,0,0,0,.02-.03.01-.05,0,0,0,0,0-.01-.31-.62-.36-1.29-.41-1.97-.05-.59.06-1.33.03-1.9-.03-.47-.18-.99-.3-1.39-.02-.05-.02-.06-.02-.07-.01,0-.03.02-.03.03,0,0,0,0,0,0-.06.7-.31,1.33-.4,1.9-.11.67-.03,1.54.15,2.03.01.03-.02.04-.03.02-.37-.56-1.17-1.38-1.59-1.81-.53-.56-.9-1.08-1.1-1.72,0,0-.03-.02-.04-.02,0,0,0,.06,0,.09-.01.9.28,1.78.79,2.51.41.59.93,1.05,1.51,1.44M146.89,170.92s.08.01.14.02c0,0,0,0,0,0,0-.01,0-.02,0-.02,0,0-.03-.03-.04-.04-.42-.41-.68-.93-.87-1.47-.15-.4-.28-.81-.42-1.21-.2-.57-.63-1.48-1.14-2.07,0,0,0,0,0,0,0,0-.02.03-.01.04.17.51.18,1.08.25,1.61.21,1.51.91,2.23.93,2.25.02.02,0,.04-.01.03-.03-.02-.06-.04-.09-.07-.47-.39-.95-.63-1.51-.89-.45-.21-.82-.39-1.23-.67-.84-.57-1.18-1.02-1.2-1.05-.01,0-.03-.01-.04,0,.06.21.14.39.23.58.35.73.89,1.29,1.52,1.78.63.49,1.32.76,2.1.9.47.08.93.19,1.4.29M147.42,172.32c.57-.04,1.12-.16,1.66-.31.36-.1,1.05-.25,1.29-.3,0,0,.01,0,.01,0,0,0,0,0,0,0,0,0,0-.02-.02-.03,0,0-.02,0-.02-.01-.31-.08-1.16-.33-1.76-.9-.38-.35-.74-.73-1.12-1.08-.31-.28-.98-.86-1.03-.87,0,0,0,.03,0,.04.1.13.45.94.67,1.35.31.6.73,1.07,1.34,1.3,0,0,0,0,.01,0,.01.01,0,.03-.05.03,0,0,0,0-.01,0-.69-.11-1.36-.14-2.06-.18-.53-.03-1.07-.06-1.58-.24-.34-.12-.6-.22-1-.53,0,0-.03,0-.05,0,0,0,0,0,0,0,.46.68,1.26,1.26,1.91,1.5.57.21,1.18.28,1.8.23M160.85,153.67c.34.31.62.67.88,1.05.25.36.49.73.83,1.02.22.22.87.73,1.03.85,0,0,0,0,0,0,0,0,.01,0,.01,0,0,0,0,0,0,0-.03-.19-.33-1.55-1.18-2.23-.46-.4-1.07-.64-1.66-.8,0,.01,0,.04,0,.04.03.02.05.04.08.07M163.31,154.8c.2.2.36.41.46.67.17.4.22,1.01.33,1.47.07.28.11.48.21.79,0,.03-.02.04-.03.01,0,0,0,0,0-.01-.32-.44-.72-.71-1.29-1.07-.34-.22-.59-.42-.84-.75-.04-.06-.09-.11-.13-.17,0,0-.03-.01-.04-.01,0,.01,0,.04.01.07.07.37.32,1.04.74,1.44.3.29.64.54.96.81.58.48.99,1,1.13,1.17,0,0,0,0,0,0,0,0,.03.02.03,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.08-.01-.22-.01-.38,0-.35.02-.82.03-1.15,0-.13.01-.26.01-.39,0-.39-.04-.78-.21-1.15-.27-.6-.67-1.08-1.26-1.38-.03-.02-.08-.04-.11-.04,0,0,0,.02,0,.04,0,0,0,0,0,0M164,159.13c-.26-.22-.64-.62-.86-.96,0,0,0,0,0,0,0,0,0,0-.01,0-.01,0-.03,0-.04,0-.01,0-.02,0-.02,0,.01.07.24.78.38,1.12.21.48.54.88.86,1.3.02.03.05.06.07.09.31.42.82,1.32.94,1.79,0,.01.03.03.03.02.04-.17.25-.81.4-1.24.03-.09.3-.96.35-1.34.15-1.07-.2-2.45-.82-3.21-.01,0-.02.03-.02.04.01.04.02.06.03.1.01.05.03.09.04.14.16.7.11,1.19.03,1.78-.06.47-.15.94-.13,1.41,0,.08.05.67.05.69,0,.03-.03,0-.03,0,0,0-.08-.22-.15-.4-.03-.08-.06-.15-.09-.2-.25-.5-.57-.75-.99-1.09M165.22,164.17s0,.01-.01.01c-.01,0-.02-.01-.02-.02.02-.18.02-.41.01-.58-.05-.67-.46-1.23-.81-1.79-.19-.29-.51-.8-.64-1.15,0,0-.03-.02-.04-.02,0,.06,0,.26.02.39.1.96.41,1.91.72,2.82.21.61.32,1.14.25,1.78,0,.05,0,.06.01.08,0,0,0,0,0,0,.22-.31.64-.75.9-1.07.28-.34,1.7-1.96,1-4.22-.04-.14-.09-.25-.11-.28-.01,0-.03.03-.03.04,0,1.62-.78,2.32-1.11,3.43-.06.21-.11.41-.15.57M166.73,163.78c-.2.64-.57,1.16-1.1,1.72-.42.43-1.22,1.24-1.59,1.81-.01.02-.04,0-.03-.02.18-.49.25-1.36.15-2.03-.09-.57-.34-1.2-.4-1.9,0,0,0,0,0,0,0,0-.02-.03-.03-.03,0,0,0,.01-.02.07-.12.41-.27.92-.3,1.39-.03.57.08,1.31.03,1.9-.06.68-.1,1.35-.41,1.97,0,0,0,0,0,.01,0,.02.01.05.01.05,0,0,0,0,0,0,.25-.16.96-.58,1.43-.89.59-.39,1.11-.86,1.51-1.44.51-.73.8-1.61.79-2.51,0-.03,0-.08,0-.09,0,0-.03.02-.04.02M165.82,167.38s-.36.47-1.2,1.05c-.41.28-.78.46-1.23.67-.56.26-1.04.49-1.51.89-.03.03-.06.04-.09.07-.02.01-.03,0-.01-.03.02-.03.72-.74.93-2.25.07-.53.08-1.1.25-1.61,0-.02,0-.03-.01-.04,0,0,0,0,0,0-.51.59-.94,1.5-1.14,2.07-.14.4-.28.81-.42,1.21-.2.55-.46,1.06-.87,1.47,0,0-.04.04-.04.04,0,0,0,0,0,.02,0,0,0,0,0,0,.06-.01.1-.02.14-.02.47-.1.93-.21,1.4-.29.78-.13,1.47-.41,2.1-.9.63-.49,1.17-1.05,1.52-1.78.09-.19.18-.37.23-.58-.01,0-.03,0-.04,0M163.73,170.59c-.41.31-.67.41-1,.53-.5.17-1.05.21-1.58.24-.7.04-1.37.07-2.06.18,0,0,0,0-.01,0-.04,0-.06-.01-.05-.03,0,0,0,0,.01,0,.61-.22,1.03-.7,1.34-1.3.22-.41.57-1.22.67-1.35,0,0,0-.03,0-.03-.05.01-.72.59-1.03.87-.38.35-.74.73-1.12,1.08-.59.57-1.45.82-1.76.9,0,0-.02,0-.02.01,0,.01-.01.02-.01.03,0,0,0,0,0,0,0,0,0,0,.01,0,.24.05.93.21,1.29.3.55.15,1.1.27,1.66.31.61.04,1.23-.02,1.8-.23.65-.24,1.45-.81,1.91-1.5,0,0,0,0,0,0-.02-.01-.04,0-.05,0M161.49,172.62s.03.01.04.02c-.48.49-1.09.82-1.67.99-.43.12-.87.14-1.32.09-.69-.08-1.3-.35-1.87-.73-.34-.22-.68-.45-1.02-.68-.39-.26-.82-.31-1.27-.24-.24.03-.06.14-.02.16.61.3,1.18.65,1.71,1.06.36.27,1.01.89,1.01.89l-.48.41s-.37-.41-.53-.57c-1.06-1.1-2-1.59-2.21-1.71-.04-.02-.07-.04-.11-.04s-.07.02-.11.04c-.21.12-1.15.61-2.21,1.71-.16.16-.53.57-.53.57l-.48-.41s.65-.62,1.01-.89c.53-.41,1.1-.77,1.71-1.06.04-.02.22-.14-.02-.16-.45-.07-.88-.03-1.27.24-.34.23-.68.46-1.02.68-.57.38-1.18.65-1.87.73-.45.05-.89.03-1.32-.09-.59-.17-1.2-.5-1.67-.99,0,0,.02-.02.04-.02.04.02.07.03.1.05.71.36,1.45.41,2.22.26.52-.1,1.01-.31,1.5-.52.35-.15.69-.31,1.05-.43.93-.31,1.88-.3,2.82-.06.02,0,.03,0,.05,0,.02,0,.03,0,.05,0,.95-.24,1.89-.24,2.82.06.36.12.7.28,1.05.43.49.21.97.42,1.5.52.77.15,1.51.11,2.22-.26.04-.02.06-.03.1-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M129.41,221.02c-.67.8-1.62,1.43-2.84,1.87-1.22.44-2.58.66-4.07.66-1.56,0-2.94-.34-4.11-1.02-1.18-.68-2.09-1.67-2.73-2.97-.64-1.3-.97-2.83-.99-4.58v-1.23c0-1.8.31-3.37.91-4.69.61-1.32,1.49-2.33,2.63-3.03,1.15-.7,2.49-1.05,4.03-1.05,2.14,0,3.82.51,5.03,1.53,1.21,1.02,1.92,2.51,2.15,4.46h-3.62c-.17-1.03-.53-1.79-1.1-2.27-.57-.48-1.35-.72-2.34-.72-1.27,0-2.23.48-2.89,1.43-.66.95-1,2.37-1.01,4.24v1.15c0,1.89.36,3.33,1.08,4.29.72.97,1.77,1.45,3.17,1.45s2.4-.3,2.99-.89v-3.12s-3.39,0-3.39,0v-2.74s7.11,0,7.11,0v7.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M154.65,216.57h4.52s-2.27-6.76-2.27-6.76l-2.25,6.76ZM160.17,219.58h-6.53s-1.24,3.72-1.24,3.72h-3.96s6.73-18.07,6.73-18.07h3.45s6.76,18.07,6.76,18.07h-3.96s-1.25-3.72-1.25-3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M170.24,220.32h7.91s0,2.99,0,2.99h-11.63s0-18.07,0-18.07h3.72s0,15.08,0,15.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M135.49,211.84c.23-.39.5-.74.82-1.06l-2.7-2.96c-.68.65-1.26,1.4-1.71,2.23l3.59,1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M142.1,209.75c.41.19.79.43,1.13.71l2.7-2.95c-.71-.61-1.52-1.12-2.4-1.49l-1.44,3.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M148.29,210.64l-3.58,1.79c.17.4.29.82.36,1.27l3.99-.38c-.12-.94-.38-1.84-.76-2.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M144.45,211.91l3.58-1.79c-.44-.82-1.01-1.57-1.67-2.22l-2.7,2.95c.31.32.58.67.8,1.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M134.78,214.45c0-.08,0-.16,0-.24l-3.99-.36c-.01.2-.02.4-.02.6,0,.76.09,1.51.27,2.22l3.85-1.1c-.08-.36-.12-.73-.12-1.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M143.95,217.73c-.28.35-.61.65-.97.91l2.11,3.41c.78-.53,1.48-1.18,2.06-1.91l-3.19-2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M145.12,214.45c0,.38-.04.75-.12,1.1l3.85,1.11c.18-.71.27-1.45.27-2.21,0-.19,0-.38-.02-.56l-3.99.38c0,.06,0,.12,0,.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M136.01,217.81l-3.19,2.42c.59.73,1.29,1.37,2.08,1.89l2.1-3.4c-.37-.26-.71-.56-1-.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M134.84,213.64c.07-.45.2-.88.38-1.28l-3.58-1.79c-.4.84-.67,1.75-.79,2.71l3.99.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M144.59,222.36l-2.1-3.4c-.38.22-.79.38-1.23.5l.74,3.94c.92-.21,1.79-.56,2.59-1.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M144.85,216.11c-.14.41-.33.8-.56,1.15l3.2,2.41c.52-.75.93-1.57,1.21-2.46l-3.85-1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M140.69,219.57c-.24.04-.49.05-.75.05-.2,0-.4-.01-.6-.04l-.74,3.94c.44.06.89.1,1.34.1.51,0,1-.04,1.49-.12l-.74-3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M140.28,209.29c.44.03.87.11,1.28.25l1.44-3.74c-.86-.3-1.77-.48-2.72-.51v4.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M138.78,219.49c-.45-.1-.87-.27-1.27-.48l-2.11,3.41c.81.46,1.7.81,2.64,1.01l.74-3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M138.39,209.52c.42-.13.85-.21,1.31-.23v-4c-.96.03-1.89.2-2.75.5l1.45,3.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M135.66,217.35c-.25-.38-.46-.79-.61-1.22l-3.85,1.1c.29.92.72,1.77,1.27,2.54l3.19-2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M136.74,210.4c.34-.27.71-.49,1.11-.67l-1.45-3.73c-.86.36-1.66.85-2.36,1.45l2.7,2.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M189.09,218.57c0-.7-.25-1.24-.74-1.62-.5-.38-1.39-.77-2.68-1.19-1.29-.42-2.31-.83-3.07-1.24-2.05-1.11-3.08-2.6-3.08-4.48,0-.98.28-1.85.83-2.61.55-.77,1.34-1.36,2.37-1.79,1.03-.43,2.19-.64,3.47-.64s2.44.23,3.45.7c1.01.47,1.79,1.13,2.35,1.98.56.85.84,1.82.84,2.9h-3.72c0-.83-.26-1.47-.78-1.93-.52-.46-1.25-.69-2.2-.69s-1.62.19-2.12.58c-.51.38-.76.89-.76,1.52,0,.59.3,1.08.89,1.48.59.4,1.46.77,2.61,1.12,2.12.64,3.66,1.43,4.63,2.37.97.94,1.45,2.12,1.45,3.53,0,1.56-.59,2.79-1.78,3.68-1.18.89-2.78,1.33-4.78,1.33-1.39,0-2.66-.25-3.8-.76-1.14-.51-2.01-1.21-2.61-2.09-.6-.89-.9-1.91-.9-3.08h3.74c0,1.99,1.19,2.99,3.57,2.99.88,0,1.58-.18,2.07-.54.5-.36.74-.86.74-1.51"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSustainabilityFeatures);
export default __webpack_public_path__ + "static/media/sustainability-features.88a83c9776b5cff9d5d1d345c1ca487b.svg";
export { ForwardRef as ReactComponent };